{
  "account-deletion": {
    "disclaimer": "La suppression de ton compte est définitive.",
    "primaryButtonText": "Supprimer le compte",
    "subtitle": "Ton profil, tes offres, tes besoins, tes données ainsi que tes conversations avec les membres seront définitivement supprimés.",
    "title": "Supprimer le compte",
    "backButtonText": "Annuler"
  },
  "accordion": {
    "showMore": "Voir plus",
    "showLess": "Voir moins"
  },
  "accessibility": {
    "favourite": {
      "add": "Ajouter aux favoris",
      "remove": "Retirer des favoris"
    },
    "close": "Fermer",
    "goBack": "Retour",
    "shareListing": "Partager l’annonce",
    "resetPassword": {
      "close": "Fermer la réinitialisation du mot de passe"
    },
    "forgotPassword": {
      "close": "Fermer la récupération du mot de passe"
    },
    "request": {
      "hide": "Masquer",
      "hideHint": "Masque ce besoin de ton fil d'actualité",
      "restore": "Restaurer"
    },
    "imagePicker": {
      "addImage": "Ajouter une photo",
      "addImageHint": "Ajoute une autre photo à ton annonce",
      "removeImage": "Supprimer la photo",
      "removeImageHint": "Retire cette photo de ton annonce",
      "openCamera": "Appareil photo",
      "openLibrary": "Galerie photo"
    },
    "imageSwiper": {
      "previous": "Image précédente",
      "next": "Image suivante"
    },
    "avatar": {
      "edit": "Modifier ma photo"
    },
    "chat": {
      "minimizeConversation": "Réduire la conversation",
      "messageActions": "Actions du message",
      "newConversation": "Nouvelle conversation",
      "moreActions": "Plus d'actions",
      "moreActionsHint": "Ouvre un menu avec les actions mettre en sourdine, marquer comme non lu, renommer, quitter et supprimer",
      "toolbar": {
        "openCamera": "Ouvrir la caméra",
        "openLibrary": "Ouvrir la photothèque",
        "sendLike": "Envoyer un pouce levé",
        "sendMessage": "Envoyer le message"
      }
    },
    "list": {
      "toggleViewMode": "Changer le mode d'affichage"
    },
    "carousel": {
      "previousSlide": "Diapositive précédente",
      "previousSlideHint": "Fais défiler la liste vers la gauche",
      "nextSlide": "Diapositive suivante",
      "nextSlideHint": "Fais défiler la liste vers la droite"
    },
    "search": {
      "clearSearch": "Effacer la recherche",
      "clearSearchHint": "Efface le texte de recherche actuel"
    },
    "profile": {
      "moreActions": "Plus d’actions sur le profil",
      "editUnavailabilityStatus": "Modifier le statut d'indisponibilité",
      "viewMember": "Voir le profil de {{name}}"
    }
  },
  "download": {
    "download": "Télécharger",
    "the_app": "l’application"
  },
  "loginAsPrompt": {
    "title": "Se connecter comme {{userName}}",
    "message": "Veux-tu être connecté en tant que {{userName}} ?",
    "no": "Non",
    "yes": "Oui"
  },
  "all-channels": {
    "sharedListing": "{{sender}} a partagé une annonce",
    "sharedProfile": "{{sender}} a partagé un profil",
    "tabBarLabel": "Messages",
    "title": "Conversations",
    "headerWithUnreadCount": "Messages ({{count}}) - Non lus {{unreadCount}}",
    "archive": "Archiver",
    "archived": "Archivée",
    "archivedConfirmation": "Conversation archivée",
    "archivedUndo": "Désarchiver",
    "markAsUnreadButton": "Marquer comme non lu",
    "archiveButton": "Archiver",
    "cancelSelection": "Annuler",
    "markAsUnreadSwipe": "Marquer non lu",
    "silence": "Sourdine",
    "unsilence": "Réactiver",
    "markingAsRead": "Conversation marquée non lue.",
    "lookingForArchive": "Pour archiver, glissez vers la droite.",
    "empty": {
      "secondLine": {
        "recent": "Tu n'as pas échangé avec un membre récemment.",
        "archived": "Aucune conversation n'a été archivée.\nGlissez une conversation (vers la droite ou la gauche) pour l'archiver."
      }
    },
    "footer": {
      "title": "Où sont les autres conversations ?",
      "text": "Les vieilles conversations sont archivées automatiquement. Clique sur l'onglet Archivés pour les consulter.",
      "button": "Voir les conversations archivées"
    },
    "file": "[Photo]",
    "filters": {
      "listing": "Par objet",
      "personal": "Par membre"
    },
    "loan": {
      "accepted": "Proposition de prêt - acceptée",
      "completed": "Prêt terminé",
      "pending": "Proposition de prêt - en attente",
      "rejected": "Proposition de prêt - refusée"
    },
    "service": {
      "accepted": "Offre de service - acceptée",
      "completed": "Service rendu",
      "pending": "Offre de service - en attente",
      "rejected": "Offre de service - refusée"
    },
    "donation": {
      "accepted": "Offre de don - acceptée",
      "completed": "Don complété",
      "pending": "Offre de don - en attente",
      "rejected": "Offre de don - refusée"
    },
    "sell": {
      "accepted": "Proposition de vente - acceptée",
      "completed": "Vente complétée",
      "pending": "Proposition de vente - en attente",
      "rejected": "Proposition de vente - refusée"
    },
    "noResponse": "Reçu il y a {{ago}}. Répondre ?",
    "tabs": {
      "recent": "Récents",
      "archived": "Archivés"
    },
    "noChannelSelected": "Aucune conversation sélectionnée",
    "groupConversationCount_one": "{{count}} conversation",
    "groupConversationCount": "{{count}} conversations"
  },
  "landing-page": {
    "tabs": {
      "explore": "Découvrir",
      "home": "Accueil",
      "feed": "Communauté",
      "catalog": "Explorer"
    },
    "manageMyInterests": "Gérer mes intérêts",
    "recentSearches": "Recherches récentes",
    "popularTags": "Intérêts populaires",
    "viewAllListings": "Voir toutes les annonces",
    "quickActions": {
      "loanOutgoing_one": "1 prêt",
      "loanOutgoing_other": "{{count}} prêts",
      "loanIncoming_one": "1 emprunt",
      "loanIncoming_other": "{{count}} emprunts",
      "noActivity": "Aucune activité",
      "activity": "Activité",
      "messages": "Messages",
      "pendingRatings": "Évaluations",
      "pendingRatingsSubtitle_one": "1 à faire",
      "pendingRatingsSubtitle_other": "{{count}} à faire",
      "unread": "non lu(s)",
      "noUnread": "Aucun message non lu",
      "createPost": "Partager une expérience",
      "createPostSubtitle_one": "1 échange à raconter",
      "createPostSubtitle_other": "{{count}} échanges à raconter"
    },
    "upcomingActivity": {
      "title": "Activité à venir",
      "allTitle": "Activité de prêt",
      "window": "Tes 3 prochains jours",
      "allWindow": "Tous tes prêts et emprunts actifs",
      "filteredWindow": "Activité sur {{period}}",
      "viewAll": "Tout voir",
      "openDetails": "Ouvre les détails du prêt",
      "deletedUser": "Compte supprimé",
      "calendar": {
        "addLabel": "Ajouter cette date à mon calendrier",
        "addedLabel": "Ajouté à mon calendrier",
        "added": "{{item}} a été ajouté à ton calendrier"
      },
      "filters": {
        "all": "Tout",
        "threeDays": "3 jours",
        "oneWeek": "1 semaine",
        "oneMonth": "1 mois",
        "threeMonths": "3 mois",
        "sixMonths": "6 mois",
        "empty": "Aucune activité pendant cette période"
      },
      "roles": {
        "lending": "Prêt",
        "borrowing": "Emprunt"
      },
      "donationRoles": {
        "lending": "Don offert",
        "borrowing": "Don reçu"
      },
      "saleRoles": {
        "lending": "Vente",
        "borrowing": "Achat"
      },
      "actions": {
        "completePurchase": "Confirmer la réception auprès de {{name}}",
        "completeSale": "Confirmer la vente à {{name}}",
        "handOff": "Remettre à {{name}}",
        "pickUp": "Récupérer auprès de {{name}}",
        "returnItem": "Retourner à {{name}}",
        "expectReturn": "Retour attendu de {{name}}",
        "confirmReturn": "Confirmer le retour de {{name}}",
        "confirmSale": "Confirmer la vente avec {{name}}"
      },
      "relative": {
        "actionRequired": "Action requise",
        "overdue_one": "1 jour de retard",
        "overdue_other": "{{count}} jours de retard",
        "today": "Aujourd’hui",
        "tomorrow": "Demain",
        "inDays_one": "Dans 1 jour",
        "inDays_other": "Dans {{count}} jours"
      },
      "empty": {
        "title": "Tout est à jour",
        "subtitle": "Rien ne demande ton attention dans les 3 prochains jours."
      }
    },
    "stepsToComplete": {
      "stepsCompleted": "{{completed}} sur {{total}} étape(s) complétée(s)",
      "nextStep": "Prochaine étape : {{step}}",
      "title": "Complète ton profil",
      "description": "Donne confiance aux membres en complétant ton profil...",
      "completedTitle": "Profil complété, bravo! 🎉",
      "completedSubtitle": "Tu inspires confiance aux membres de la communauté",
      "addPicture": "Ajoute une photo",
      "addBio": "Ajoute une bio",
      "setInterests": "Définis tes intérêts",
      "addListings": "Ajoute ({{count}}/5) objets à prêter"
    },
    "popularInterests": "Intérêts populaires 📈",
    "myInterests": "Mes intérêts 🎯",
    "noInterestsTitle": "Personnalise ta découverte",
    "noInterestsSubtitle": "Choisis tes centres d'intérêt et reçois des suggestions adaptées à toi.",
    "addInterestsCta": "Ajouter mes intérêts",
    "greeting": {
      "morning": "Bonjour",
      "afternoon": "Bon après-midi",
      "evening": "Bonsoir"
    },
    "subscription": {
      "discovery": "Découverte"
    },
    "unlockFullExperience": {
      "accessibilityLabel": "Débloquer l’expérience complète",
      "title": "Débloque l’expérience complète !",
      "discount": "-25 %",
      "discountDeadline": "jusqu’au {{date}}"
    },
    "requests": {
      "emptyState": {
        "title": "Rien à afficher pour le moment.",
        "subtitle": "Nous te préviendrons si tes voisins ont besoin d’aide",
        "cta": "Voir tous les besoins"
      }
    },
    "theme": "Thème de la semaine",
    "multipleOfferCard": {
      "new": "Nouveau",
      "quickOffers": "Publier des objets",
      "desktopBadge": "Offre rapide ⚡",
      "title": "Tu as sûrement ces objets chez toi !",
      "desktopSubtitle": "Ça tombe bien les offres sont déjà prêtes à publier",
      "subtitle": "Ça tombe bien les offres sont déjà prêtes à publier",
      "button": "Publier en un éclair",
      "desktopButton": "Publier en un éclair"
    },
    "viewMore": "Voir plus",
    "viewLess": "Voir moins",
    "carousel": {
      "previousSlide": "Diapositive précédente",
      "nextSlide": "Diapositive suivante",
      "previousSlideHint": "Fais défiler la liste vers la gauche",
      "nextSlideHint": "Fais défiler la liste vers la droite"
    },
    "immature": {
      "defricheur": {
        "title": "Offre du défricheur",
        "text": "Il y a peu d'objets dans ton quartier. <strong>Abonnement gratuit aux 5 premier.ère.s</strong> qui publieront un objet.",
        "button": "Publie une offre"
      },
      "referral": {
        "title": "Aide-nous à faire grandir la communauté. Invite <strong>5 personnes</strong> et gagne <strong>un cadeau d'une valeur de 25 $ !</strong>",
        "progress": "{{current}} sur {{total}}",
        "button": "Invite tes voisin·e·s",
        "seeConditions": "Voir les conditions"
      },
      "writeToMayor": {
        "title": "Demande à la ville d'offrir Partage Club à ses citoyen·ne·s",
        "text": "Nous avons rédigé une lettre que tu peux directement envoyer. Il te suffit de remplir le formulaire de demande sur notre site web",
        "button": "Écrire au maire",
        "textLetter": "Nous avons rédigé une lettre que tu peux personnaliser et envoyer au maire de ta ville."
      },
      "socialMedia": {
        "title": "Suis-nous sur les réseaux !",
        "text": "Rejoins des milliers de partageur·euse·s de confiance"
      }
    }
  },
  "my-interests": {
    "title": "Mes intérêts",
    "subtitle": "Sélectionne tes centres d'intérêt pour personnaliser ta découverte",
    "searchPlaceholder": "Rechercher un intérêt…",
    "selectedSection": "Sélectionnés ({{count}})",
    "exploreSection": "Tous les intérêts",
    "noResults": "Aucun résultat pour « {{query}} »",
    "emptyTitle": "Aucun intérêt sélectionné",
    "emptySubtitle": "Touche un intérêt ci-dessous pour l'ajouter à ton profil"
  },
  "all-listings": {
    "map": {
      "signInToExplore": "Connecte-toi pour explorer la carte.",
      "approximateLocation": "Emplacement approximatif",
      "switchToMap": "Passer à la vue carte",
      "switchToList": "Passer à la vue liste"
    },
    "emptyRequests": {
      "title": "Les besoins les plus récents s’affichent ici",
      "secondTitle": "Rien à afficher pour le moment, sois le premier à ajouter un besoin!",
      "button": "Ajouter un besoin"
    },
    "bonificationPrompt": {
      "title_one": "Un objet à bonifier!",
      "title": "{{numListings}} objets à bonifier!",
      "text_one": "Tu as <strong>un objet</strong> avec une photo générique ou aucune description. Les objets avec une photo ont plus de chances d'être empruntés!",
      "text": "Tu as <strong>{{numListings}} objets</strong> avec une photo générique ou aucune description. Les objets avec une photo ont plus de chances d'être empruntés!",
      "button_one": "Compléter la fiche de l'objet",
      "button": "Voir mes annonces",
      "dismiss": "Fermer"
    },
    "pendingBonificationsBanner": {
      "title_one": "1 suggestion à examiner",
      "title": "{{count}} suggestions à examiner",
      "subtitle": "Un emprunteur a proposé des améliorations pour ton annonce.",
      "item": "Voir la suggestion"
    },
    "bonificationBadge": "À bonifier",
    "bonificationBadge2": "Qualité",
    "numComments_one": "1 commentaire",
    "numComments_other": "{{count}} commentaires",
    "hasAcceptedLoan": "a prêté l’objet",
    "hasAcceptedLoanAgo": "a prêté l’objet il y a {{ago}}",
    "addAddressPrompt": {
      "button": "Ajouter un quartier",
      "text": "Au bureau, à l’école, au chalet ou chez tes parents : si tu t’y rends fréquemment, ça vaut le coup d’élargir ta recherche.",
      "title": "Ajoute une adresse"
    },
    "addPhoneNumberPrompt": {
      "banner": {
        "button": "Ajouter mon numéro de téléphone",
        "text": "Ajouter <strong>ton numéro de téléphone</strong> aide les membres à te contacter plus facilement pour organiser des prêts.",
        "title": "Ton profil est complet à {{percent}}%"
      },
      "bottom-sheet": {
        "button": "Ajouter mon numéro de téléphone",
        "text": "Ajouter <strong>mon numéro de téléphone</strong> aide les membres à me contacter plus facilement pour organiser des prêts.",
        "title": "Mon profil est complet à {{percent}}%"
      }
    },
    "addressAddedToast": {
      "text": "Pour le modifier ou en ajouter d’autres, c’est dans Profil > Mes clubs",
      "title": "Nouveau club créé"
    },
    "allCategories": "Toutes",
    "peopleSearch": {
      "title": "Membres",
      "empty": "Aucun membre ne correspond à cette recherche.",
      "viewAll": "Tout voir",
      "subtitle": "{{count}} membre trouvé près de toi",
      "subtitle_other": "{{count}} membres trouvés près de toi"
    },
    "filters": {
      "all": "Toutes",
      "name": "Filtres"
    },
    "guest": {
      "locationHint": "Indique ta position pour voir les objets disponibles près de chez toi.",
      "addressError": "Impossible de trouver cette adresse ou ce code postal.",
      "apply": "Appliquer",
      "bannerCta": "Obtenir l'app",
      "bannerText": "Le moyen le plus rapide pour ajouter du matériel à ton profil.",
      "bannerTitle": "Publie tes objets en un clin d’œil avec l’application mobile",
      "categories": "Catégories",
      "distance": "Dans un rayon de {{distance}} km",
      "distanceTitle": "Dans un rayon de :",
      "locating": "Recherche de ta position…",
      "location": "Position",
      "locationError": "Impossible d'accéder à ta position. La position par défaut reste sélectionnée.",
      "locationTitle": "Localisation",
      "maximumDistance": "Maximum ({{distance}} km)",
      "mobileBannerTitle": "Ouvrir avec l’application mobile {{appName}}",
      "myPosition": "Ma position",
      "myPositionHint": "Découvre les offres à proximité",
      "postalCode": "Adresse ou code postal",
      "reset": "Réinitialiser",
      "tags": "Étiquettes"
    },
    "banner": {
      "halloween": {
        "title": "Abracadabra !",
        "text": "Propose tes costumes en un clic ☞",
        "button": "Partagez-les"
      },
      "xmas": {
        "text": "Les Fêtes arrivent ! Aide tes voisin.e.s à trouver ces objets souvent demandés.",
        "button": "Voir les suggestions"
      }
    },
    "canOffer": "Je peux prêter",
    "createYourNeed": "Ajoute ton besoin",
    "createYourOffer": "Ajoute ton offre",
    "dateRange": "Du {{start}} au {{end}}",
    "disconnected": {
      "text": "Crée ton compte ou connecte-toi pour voir les offres près de chez toi.",
      "buttonSignUp": "Créer mon compte",
      "buttonLogIn": "J'ai déjà un compte",
      "buttonCode": "Tu as un code d'invitation ?"
    },
    "empty": {
      "offer": {
        "firstLine": "Débute ton aventure ici !",
        "primaryButtonText": "Créé une première offre",
        "secondLine": "Les membres pourront la voir et t'envoyer une demande pour l'emprunter."
      },
      "request": {
        "firstLine": "Tu ne trouves pas ?",
        "primaryButtonText": "Publie un besoin !",
        "secondLine": "Les membres peuvent t'aider à trouver ce que tu cherches."
      },
      "invite": {
        "firstLine": "Débute ton aventure ici !",
        "primaryButtonText": "Invite tes voisins",
        "secondLine": "Invite des voisins ou publie une offre dans ton quartier."
      },
      "nothing": {
        "firstLine": "Aucune annonce pour le moment.",
        "secondLine": "Ça ne devrait pas tarder !"
      },
      "nothingServicesOnly": {
        "firstLine": "Rien à récolter pour le moment.",
        "secondLine": "Gardez un œil ouvert : les demandes arrivent avec les saisons !"
      }
    },
    "filter": {
      "neighborhoodClubCheckbox": "<strong>Club du quartier</strong>{{suffix}}",
      "neighborhoodClub": "Club du quartier"
    },
    "found": "Trouvé!",
    "groupingMembers": "{{count}} membres",
    "groupingMembersMany": "{{count}}+ membres",
    "headline": "Nouvelle",
    "inviteOthersPrompt": {
      "title": "Aide-nous à faire grandir la communauté dans ton quartier!",
      "description": "Ton quartier semble immature, c'est-à-dire qu'il y a peu de membres dans les environs mais tu peux changer la donne !",
      "ctaButton": "Invite tes voisin·e·s"
    },
    "levelUpModal": {
      "primaryButtonText": "Voir mon impact",
      "secondaryButtonText": "Fermer",
      "text": "Tu as augmenté ton impact en publiant ta première offre. Tu accèdes maintenant à un niveau supérieur : <strong>Contributeur</strong>.",
      "title": "Bravo !"
    },
    "moreResultsWithoutDistanceFilter": "Chercher plus loin que <strong>{{distance}}</strong>",
    "nearYou": "Nouvelles offres",
    "needLogin": {
      "firstLine": "Débute ton aventure ici !",
      "primaryButtonText": "Me connecter",
      "secondLine": "Connecte-toi pour voir les objets disponibles dans ton quartier."
    },
    "needsAppUpdateTitle": "Mise à jour requise",
    "needsAppUpdateText": "Pour bénéficier des dernières fonctionnalités, tu dois mettre à jour l'application en utilisant l'App Store Apple ou le Google Play Store.",
    "needsAppUpdateButtonTextIOS": "Ouvrir l'App Store",
    "needsAppUpdateButtonTextAndroid": "Ouvrir le Play Store",
    "neighborOffer": "Offre d'un.e membre",
    "neighborRequest": "Besoin d'un.e membre",
    "noDateRange": "Dates flexibles",
    "flexibleLabel": "(flexibles)",
    "new": "Nouveau",
    "noResults": {
      "firstLine": "Les membres n’ont pas encore publié d’objets ici.",
      "primaryButtonText": "Publier",
      "secondLine": "Sois le.la premier.ère à le faire!"
    },
    "numResults": {
      "default_zero": "Aucun article trouvé",
      "default_one": "{{count}} article trouvé",
      "default": "{{count}} articles trouvés",
      "offer_zero": "Objets à prêter",
      "offer_one": "{{count}} objet à prêter",
      "offer": "{{count}} objets à prêter",
      "request_zero": "Besoins",
      "request_one": "{{count}} besoin",
      "request": "{{count}} besoins",
      "publicDonations_zero": "Dons offerts",
      "publicDonations_one": "{{count}} don offert",
      "publicDonations": "{{count}} dons offerts"
    },
    "offeredBy": "Prêté par {{firstName}} {{lastName}}",
    "postNeedPrompt": {
      "afterResults": {
        "button": "Publier un besoin",
        "text": "Demande à ta communauté !\n<strong>1 besoin sur 3</strong> est comblé en moins de <strong>24 heures</strong>.",
        "title": "🥳"
      },
      "noResults": {
        "button": "Publier un besoin",
        "text": "Demande à ta communauté !\n<strong>1 besoin sur 3</strong> est comblé en moins de <strong>24 heures</strong>.",
        "title": "🥳"
      }
    },
    "searchAssistant": {
      "title": "On peut chercher pour toi !",
      "body": "Souhaites-tu que notre assistant intelligent contacte des prêteurs susceptibles d'avoir <strong>{{itemName}}</strong> ?",
      "bodyNote": "Tu pourras ajuster les détails de la recherche à ta convenance juste après.",
      "dismiss": "Pas maintenant",
      "confirm": "Oui, lancer la recherche",
      "close": "Fermer"
    },
    "postOfferPrompt": {
      "first": {
        "button": "Publier une offre !",
        "text": "Publie 5 objets et gagne ton <strong>abonnement annuel</strong> !",
        "title": "Gagne ton abonnement !"
      },
      "firstAfter": {
        "button": "Inviter mes voisin.e.s",
        "text": "Contribue à faire grandir cette chaîne de générosité !",
        "title": "Invite tes voisin.e.s !"
      },
      "second": {
        "button": "Publier une offre !",
        "text": "Avec l'offre multiple, publiez plus vite que l'éclair.",
        "title": "Publier en 10 secondes "
      },
      "third": {
        "button": "Publier un besoin !",
        "text": "Les membres ont souvent plus d'objets à prêter que ce qui est affiché. Demande, on ne sait jamais.",
        "title": "Demande à tes voisins"
      }
    },
    "promoDragonText": "<strong>Promotion</strong> « Dans l'oeil du dragon ». Bénéficiez d'un <strong>abonnement annuel</strong> à 30 $ au lieu de 60 $.",
    "promoDragonText2": "⌛ Jusqu'au 24 avril 2024 à 23 h 59",
    "promoDragonButtonText": "Profiter de 50 % de réduction (30 $)",
    "promoFreeSub": {
      "defricheur": {
        "text": "⏳ Plus que {{numDays}} jours pour profiter de ton essai gratuit. Publie des offres pour gagner ton abonnement !",
        "text1": "⏳ Dernier jour pour profiter de ton essai gratuit. Publie des offres pour gagner ton abonnement !",
        "button": "Gagner mon abonnement annuel !"
      },
      "trial": {
        "text": "⏳ Plus que {{numDays}} jours pour profiter de ton essai gratuit. Découvre notre offre et obtiens ton abonnement gratuit !",
        "text1": "⏳ Dernier jour pour profiter de ta période d'essai. Obtiens ton abonnement gratuit avec notre offre spéciale !",
        "button": "Profiter de l'offre !"
      }
    },
    "quickOffer": {
      "text": "Publie en 10 secondes !",
      "title": "Publication rapide"
    },
    "partialSearchBar": {
      "placeholder": "Rechercher dans cette liste",
      "empty": "Aucun objet ne correspond à cette recherche."
    },
    "sortTitle": "Trier par",
    "sortBy": {
      "distance": "Distance",
      "date": "Nouveautés",
      "startDate": "Date",
      "popularity": "Popularité",
      "random": "Aléatoire",
      "relevance": "Pertinence",
      "urgency": "Urgence"
    },
    "subtype": {
      "object": "Objet",
      "service": "Service"
    },
    "tabs": {
      "offer": "Offres",
      "people": "Membres",
      "request": "Besoins",
      "donations": "Dons",
      "services": "Besoins"
    },
    "topListings": {
      "title": "Offres populaires",
      "viewMore": {
        "details": "Voir toutes les offres classées par popularité.",
        "cta": "Allons-y !"
      }
    },
    "featured": {
      "title": "En vedette"
    },
    "recommended": {
      "title": "Recommandé pour toi"
    },
    "urgent": "Urgent",
    "dateTag": {
      "from": "À partir du {{date}}",
      "until": "Jusqu’au {{date}}",
      "range": "Du {{start}} au {{end}}",
      "remaining_one": "{{count}} jour restant",
      "remaining_other": "{{count}} jours restants",
      "urgent": "Urgent",
      "urgentRemaining_one": "Urgent · {{count}} jour restant",
      "urgentRemaining_other": "Urgent · {{count}} jours restants"
    },
    "mode": {
      "lend": "Prêt",
      "sell": "Vente",
      "give": "Don"
    },
    "requestMode": {
      "lend": "Emprunt",
      "sell": "Achat",
      "give": "Don"
    },
    "activeSearch": "Rech. active",
    "dismissAction": "Masquer",
    "dismissAccessibilityHint": "Masque ce besoin de ton fil d'actualité",
    "undismissAction": "Restaurer",
    "dismissToast": {
      "title": "Besoin masqué",
      "undo": "Annuler"
    },
    "focused-user-listings": "Annonces de {{userName}}",
    "user-display-name-fallback": "Ce membre",
    "userMetaModal": {
      "polymtl_segment_user_type": {
        "prompt": "Aide-nous à mieux comprendre l’utilisation de l’application à Poly ! Je suis …",
        "options": {
          "student": "Étudiant.e",
          "staff": "Professeur.e ou membre du personnel"
        }
      }
    }
  },
  "api-errors": {
    "Municipal activation code already active": "Ce code est déjà actif sur ton compte.",
    "Social sign-in failed": "La connexion avec ce service a échoué. Réessaie ou connecte-toi avec ton courriel et ton mot de passe. Si tu n’as pas de mot de passe ou si tu l’as oublié, utilise l’option de réinitialisation du mot de passe dans le formulaire de connexion.",
    "generic-title": "Erreur de connexion à l'API",
    "An account cannot move into or out of the United States by changing its address.": "Une fois le compte créé, son adresse ne peut pas passer des États-Unis à un autre pays, ni l’inverse.",
    "The last admin cannot leave or be removed before another member is promoted.": "Tu dois nommer un autre administrateur avant de pouvoir quitter cette discussion.",
    "Attempt limit exceeded, please try after some time.": "Trop de tentatives ; veuillez réessayer plus tard.",
    "An account already exists for this email address. Please use the log in form.": "Un compte existe déjà avec cette adresse courriel. Utilise le formulaire de connexion.",
    "Can't delete listing that has accepted loan.": {
      "offer": "Tu ne peux pas supprimer une offre dont le prêt est présentement en cours ou en retard. Tu dois soit annuler ce prêt, soit confirmer le retour de cet objet.",
      "request": "Tu ne peux pas supprimer un besoin dont l'emprunt est présentement en cours ou en retard. Le retour doit d'abord être confirmé par le propriétaire."
    },
    "Date is required": "Choisis une date",
    "Failed to apply invite code.": "Erreur avec le code d'invitation.",
    "Incorrect email or password": "Le courriel ou le mot de passe est invalide",
    "Network Error": "Réseau non disponible",
    "Outside geofence": "Impossible d'utiliser ce code à l'extérieur de la zone autorisée.",
    "Please complete your profile before creating a listing.": "Complète ton profil avant de créer une annonce.",
    "Please enter a valid activation code.": "Entre un code d'invitation valide.",
    "No user exists with the specified email.": "Aucun compte n'utilise cette adresse courriel.",
    "The provided address was not found.": "L'adresse spécifiée est introuvable.",
    "The provided password is incorrect": "Le mot de passe (actuel) est incorrect.",
    "You already created a listing for this item in this category": "Tu as déjà publié une offre avec ce nom dans cette catégorie.",
    "You are not authorized to use this code": "Tu n'es pas autorisé à utiliser ce code.",
    "You need a valid license to post a need.": "Tu dois avoir une licence valide pour publier un besoin."
  },
  "app_update": {
    "button_cancel": "Annuler",
    "button_ok": "Ok",
    "question": "Veux-tu mettre à jour?",
    "title": "Une nouvelle mise à jour est disponible."
  },
  "billboard": {
    "tabBarLabel": "Accueil",
    "title": "Trouvez facilement",
    "title_2": "l’objet qu’il te faut!",
    "unauthenticatedTitle": "Crée un compte ou connecte-toi",
    "unauthenticatedTitle_2": "pour voir les offres près de chez toi.",
    "invitationCode": "Tu as un code d'invitation ?",
    "buttonSignUp": "Créer mon compte",
    "buttonLogIn": "J'ai déjà un compte",
    "requestTitle": "Besoins",
    "publishOfferButton": "Publier une offre",
    "publishNeedButton": "Ajouter un besoin",
    "viewAllCatalogButton": "Voir tout le catalogue",
    "browseByCategories": "Parcourir par catégories",
    "needsTitle": "Ces membres ont besoin d'aide"
  },
  "calendar": {
    "disabled": "Tu ne peux pas modifier les dates d’un besoin dont l’emprunt est présentement en cours ou en retard."
  },
  "calendar-settings": {
    "calendarModal": {
      "primaryButtonText": "Accéder aux Réglages",
      "secondaryButtonText": "Annuler",
      "text": "Pour nous permettre d'ajouter des événements dans le calendrier de ton téléphone, accède aux réglages de ton appareil et autorise l'accès complet au calendrier.",
      "title": "Autoriser le calendrier"
    },
    "title": "Ajout au calendrier"
  },
  "change-password": {
    "newPasswordConfirmationFieldLabel": "Confirmation du nouveau mot de passe",
    "newPasswordConfirmationFieldPlaceholder": "",
    "newPasswordFieldLabel": "Nouveau mot de passe",
    "newPasswordFieldPlaceholder": "",
    "passwordFieldLabel": "Mot de passe actuel",
    "passwordFieldPlaceholder": "",
    "primaryButtonText": "Enregistrer",
    "title": "Modifier mon mot de passe"
  },
  "chooseUserType": {
    "title": "Bienvenue !",
    "alreadyHaveAccount": "Tu as déjà un compte ?",
    "clickHere": "Me connecter",
    "loggedIn": "Tu es connecté !",
    "loggedInRedirect": "Tu seras redirigé automatiquement.",
    "instructionsLoggedIn": "Choisis ton profil ci-dessous pour finaliser ton compte :",
    "instructions": "Ou choisis ton profil ci-dessous :",
    "type": {
      "desc": {
        "pro": "Accès réservé aux fermes, formateur·trice·s et organismes impliqués dans l’horticulture de proximité.\n\n<strong>Code d’invitation requis.</strong>",
        "public": "Pour les citoyen·ne·s qui souhaitent s’impliquer."
      },
      "button": {
        "pro": "Professionnel·le·s",
        "public": "Grand public"
      }
    }
  },
  "closestListingsModal": {
    "breadcrumb": {
      "first": "Tes intérêts",
      "second": "Ta sélection",
      "third": "Envoyer"
    },
    "title": "Brise la glace et fais ton premier emprunt !",
    "instructions": "Sélectionne les catégories qui t’intéressent et nous te proposerons de belles trouvailles.",
    "buttonText": "Continuer"
  },
  "closestListingsChoose": {
    "instructions": "Choisis l’objet que tu souhaites emprunter, on s’occupe du reste.",
    "buttonText": "Vérifier les disponibilités",
    "messageToSend": "Bonjour {{name}},\nJe suis intéressé.e par ton offre. As-tu des disponibilités prochainement ?",
    "chatToast": "On a salué le prêteur pour toi. Maintenant, propose des dates d’emprunt !"
  },
  "collection": {
    "title": "Collection: {{name}}",
    "iHaveThis": "J'ai ça !",
    "iNeedThis": "Je cherche ça",
    "itemHasListingsIStillNeedThisPrompt": "Si les offres ci-haut ne te conviennent pas, tu peux toujours publier un besoin avec ce bouton.",
    "moreMembers": "+ {{num}} de plus",
    "nobodyOfferedYet": "⭐️ Sois le premier à l'offrir !",
    "postNeedPrompt": {
      "button": "Publier un besoin !",
      "text": "Les membres peuvent t'aider à trouver ce que tu cherches.",
      "title": "Besoin spécial ?"
    },
    "subscribe": "M'abonner",
    "subscriptionSuccess": "Tu es abonné·e. Tu recevras une notification quand un membre publie une offre pour cet objet.",
    "successfullyAddedNeed": "Besoin publié",
    "successfullyAddedOffer": "Offre publiée",
    "successfullyAddedOfferNow": "Wah-hoo !",
    "unsubscribe": "Abonné",
    "unsubscriptionSuccess": "Tu es désabonné·e. Tu ne recevras plus de notification pour cet objet."
  },
  "common": {
    "perishable": "Périssable",
    "goBack": "Précédent",
    "ambassador": "Ambassadeur·rice",
    "ambassadorAndSuper": "Super Partageur.euse |\n<color>Ambassadeur·rice</color>",
    "appName": "Partage Club",
    "appDownloadPrompt": {
      "title": "Télécharge l’application",
      "guest": "Tu aimes ce que tu vois? Retrouve Partage Club sur ton téléphone et reçois les nouvelles disponibilités près de chez toi",
      "dateProposal": "Télécharge l'app pour être averti·e dès que {{firstName}} te répond",
      "listingPublished": "Télécharge l'app pour publier des offres / besoins encore plus facilement!",
      "thisMember": "ce membre",
      "qrCodeAccessibilityLabel": "Code QR pour télécharger l’application Partage Club",
      "openStore": "Ouvrir {{store}}"
    },
    "applicationError": {
      "firstLine": "Oups, voilà qui n'était pas prévu ! Nous travaillons à régler ce problème.",
      "secondLine": "Voici quelques trucs que tu peux essayer :\n\n• Attends quelques secondes, puis utilise le bouton 'Réessayer' ci-dessous.\n\n• Ferme l'appli complètement, et relance-la.\n\n• Va dans l'écran Profil, et déconnecte-toi, puis reconnecte-toi {{connectHow}}\n\n• Désinstalle l'appli de ton appareil, et réinstalle-la.\n\n• Si rien de tout ça ne t'aide, écris-nous ASAP à support@partage.club.",
      "connectHow": {
        "empty": "",
        "email": "avec l'adresse {{email}}",
        "loginWithApple": "avec le bouton 'Connexion avec Apple'"
      },
      "primaryButtonText": "Réessayer"
    },
    "applyUpdateLabel": "Mettre à jour",
    "archived": "Archivée",
    "available": "Disponible",
    "back": "Retour",
    "cancel": "Annuler",
    "cityRequiredError": "Entre une ville.",
    "dateFormat_MMMd": "d MMM",
    "dateFormat_MMMMd": "d MMMM",
    "dateFormat_EEEEMMMMd": "EEEE d MMMM",
    "dateFormat_MMMYYYY": "MMM yyyy",
    "dateFormat_MMMdYYYY": "d MMM yyyy",
    "dateFormat_MMMMdYYYY": "d MMMM yyyy",
    "deleted": "Supprimée",
    "deletedUser": "Utilisateur supprimé",
    "donation": {
      "label": "<strong>Don</strong>",
      "lastDay": "<strong>Dernier jour</strong>",
      "numDays_one": "<strong>1 jour</strong> restant",
      "numDays": "<strong>{{count}} jours</strong> restants",
      "numMonths_one": "> <strong>1 mois</strong> restant",
      "numMonths": "> <strong>{{count}} mois</strong> restants"
    },
    "expiredLoans": {
      "firstParagraph": "<strong>{{item}}</strong> de <strong>{{firstName}} {{lastName}}</strong> était dû le {{date}}.",
      "secondParagraph": "Confirme le retour ou modifie les dates d'emprunt en cliquant ici.",
      "sectionTitle_one": "{{count}} emprunt en retard",
      "sectionTitle": "{{count}} emprunts en retard",
      "title": "As-tu retourné l'objet emprunté ?"
    },
    "expiredService": {
      "firstParagraph": "<strong>{{firstName}} {{lastName}}</strong> devait t'aider à <strong>{{item}}</strong> le {{date}}.",
      "secondParagraph": "Confirme que le service a été rendu ou modifie les dates en cliquant ici.",
      "sectionTitle_one": "{{count}} service en retard",
      "sectionTitle": "{{count}} services en retard",
      "title": "Est-ce que le service a été rendu ?"
    },
    "expiredDonation": {
      "firstParagraph": "Tu devais ramasser <strong>{{item}}</strong> le {{date}} chez <strong>{{firstName}} {{lastName}}</strong>.",
      "secondParagraph": "Confirme que le ramassage a été fait ou modifie la date en cliquant ici.",
      "sectionTitle_one": "{{count}} don en retard",
      "sectionTitle": "{{count}} dons en retard",
      "title": "Est-ce que le don a été ramassé ?"
    },
    "expiredSale": {
      "firstParagraph": "La vente de <strong>{{item}}</strong> avec <strong>{{firstName}} {{lastName}}</strong> était prévue le {{date}}.",
      "secondParagraph": "Confirme la vente ou modifie la date de ramassage en cliquant ici.",
      "sectionTitle_one": "{{count}} vente en retard",
      "sectionTitle": "{{count}} ventes en retard",
      "title": "Est-ce que la vente a été complétée ?"
    },
    "expiredItems": {
      "sectionTitle_one": "{{count}} élément en retard",
      "sectionTitle": "{{count}} éléments en retard"
    },
    "favourites": "Favoris",
    "fieldErrorDefault": "Ce champ n'est pas valide",
    "fieldErrorLength": "Ce champ doit contenir exactement {{length}} caractères",
    "fieldErrorPatternEmail": "Ce champ doit être une adresse courriel valide",
    "fieldErrorRequired": "Ce champ est requis",
    "fieldErrorTooLong": "Ce champ doit contenir au maximum {{max}} caractères",
    "fieldErrorTooShort": "Ce champ doit contenir au moins {{min}} caractères",
    "genericError": "Une erreur est survenue",
    "lastActiveAgo": "Actif.ve il y a {{ago}}",
    "lastActiveAgoShort": "il y a {{ago}}",
    "lateSince": "En retard de {{days}} jour(s)",
    "loaned": "Emprunté",
    "manageOffer": "Gérer cette offre",
    "mandatory": "obligatoire",
    "noResults": "Aucun résultat",
    "noResultsFor": "Aucun résultat pour :\n<strong>{{query}}</strong>",
    "afterResultsFor": "Tu ne trouves pas ce que tu cherches ?",
    "offer": "Prêt",
    "optional": "optionnel",
    "optionals": "optionnels",
    "optionale": "optionnelle",
    "optionales": "optionnelles",
    "or": "ou",
    "otherCountries": "Tous les pays",
    "passwordErrorDigit": "Ce champ doit contenir au moins un chiffre",
    "passwordErrorLowercase": "Ce champ doit contenir au moins une lettre minuscule",
    "passwordErrorMatching": "Ce champ doit être le même que ton mot de passe",
    "passwordErrorSpecial": "Ce champ doit contenir au moins un caractère spécial",
    "passwordErrorUppercase": "Ce champ doit contenir au moins une lettre majuscule",
    "postalCodeRequiredError": "Entre un code postal",
    "postedOn": "Publié le {{date}}",
    "request": "Besoin",
    "search": "Recherche",
    "searchPlaceholder": "Rechercher des annonces, des membres et des objets...",
    "serviceCategories": {
      "general_help_outside_bf": {
        "name": "Aide extérieure à domicile",
        "desc": "Exemple : remplir le lave-glace dans la voiture, gonfler des pneus, rouler les bacs…"
      },
      "urgency_help_bf": {
        "name": "Aide d'urgence",
        "desc": "Exemple : aider à trouver un vétérinaire pour un animal blessé, aider à trouver une pharmacie de garde…"
      },
      "companionship_bf": {
        "name": "Compagnie et loisirs",
        "desc": "Exemple : Pratiquer une langue, partenaire de promenades…"
      },
      "know_how_bf": {
        "name": "Transfert de connaissances",
        "desc": "Exemple : conseils jardinages, réparation…"
      },
      "landscaping_bf": {
        "name": "Entretien du terrain",
        "desc": "Exemple : râcler, préparer le terrain, la piscine, sortir le mobilier…"
      },
      "public_tessier": {
        "name": "Besoin de service",
        "desc": ""
      }
    },
    "streetRequiredError": "Entre une adresse",
    "suggested": "suggéré",
    "suggestede": "suggérée",
    "superPartageur": "Super Partageur.euse",
    "unavailable": "Indisponible",
    "updateAvailable": "Bonjour! Nous avons une mise à jour pour toi 🥳🎉.",
    "version": {
      "copied": "Version copiée",
      "update_label": "Mise à jour",
      "version_label": "Version"
    },
    "year": "Année",
    "x$": "{{amount}} $"
  },
  "contact-information": {
    "title": "Ton code postal",
    "prompt": "Ajoute ton code postal afin de découvrir tout ce que tu peux emprunter près de chez toi !",
    "mapMarkerPrompt": "Définis la localisation de ton domicile en positionnant le marqueur sur la carte.",
    "mapStatsPrompt": "Change le rayon de recherche pour visualiser le nombre de membres et le nombre d'objets qui sont disponibles à emprunter autour de chez toi.",
    "invalidAddressError": "Code postal invalide. Réessaie.",
    "changePostalCode": "Changer mon code postal"
  },
  "help": {
    "title": "Comment ça marche ?",
    "roleBorrow": "J'ai un besoin",
    "roleLend": "J'ai une offre",
    "assistanceQuestion": "Tu as besoin d'une assistance supplémentaire?",
    "visitHelpCenter": "Visiter le centre d'aide",
    "guestCta": {
      "title": "Prêt·e à commencer ?",
      "text": "Rejoins ton voisinage et découvre tout ce que tu peux emprunter près de chez toi.",
      "button": "Créer mon compte"
    },
    "compensation": {
      "title": "Dédommagement sur les objets",
      "text": "Tu es dédommagé sur les objets prêtés et empruntés",
      "subscribeText": "Avec l'abonnement, Partage Club te dédommage jusqu'à 300 $ sur les objets prêtés et empruntés.",
      "subscribeCta": "Je m'abonne",
      "learnMore": "En savoir plus"
    },
    "borrower": {
      "steps": {
        "catalog": {
          "title": "Parcours le catalogue",
          "text": "Cherche un objet dans le catalogue ou crée un besoin visible par tes voisin·e·s",
          "exploreLink": "Explorer le catalogue",
          "needLink": "Ajouter un besoin"
        },
        "meeting": {
          "title": "Convenir d'un rendez-vous",
          "text": "Propose et confirme des dates d'emprunt et de ramassage avec ton·ta voisin·e"
        },
        "pickup": {
          "title": "Récupère l'objet et utilise-le",
          "text": "Rencontre ton·ta voisin·e à son domicile ou dans un lieu public sécuritaire. <strong>Aucun échange d'argent, c'est gratuit !</strong>"
        },
        "return": {
          "title": "Rends l'objet",
          "text": "Ramène l'objet en bon état à son·sa propriétaire et partage ton expérience"
        }
      }
    },
    "lender": {
      "steps": {
        "photo": {
          "title": "Prends un objet en photo",
          "text": "Prends quelques clichés qui mettent en valeur ton objet"
        },
        "publish": {
          "title": "Publie une offre",
          "text": "Ajoute des détails d'usage sur ton objet et publie ton offre. Si tu manques de temps, choisis des annonces pré-faites par nos soins pour des objets souvent demandés.",
          "offerLink": "Publier une offre spécifique",
          "suggestedLink": "Choisir parmi les objets suggérés"
        },
        "share": {
          "title": "Partage l'objet",
          "text": "Rencontre ton·ta voisin·e à ton domicile ou dans un lieu public sécuritaire pour lui donner l'objet. <strong>Aucun échange d'argent, c'est gratuit !</strong>"
        },
        "return": {
          "title": "Récupère l'objet",
          "text": "Reprends l'objet à la fin du prêt et partage ton expérience. <strong>Moins de 1%</strong> des objets empruntés sont endommagés. Et souvent, ils reviennent encore plus propres. C'est magique."
        }
      }
    }
  },
  "contact-us": {
    "title": "Aide",
    "firstParagraph": "Le service aux membres du Partage Club est accessible par courriel et par messagerie. Nous te répondrons dans les plus brefs délais.",
    "chatCTALabel": "Messagerie",
    "transportCTALabel": "Aide au transport",
    "emailCTALabel": "Courriel",
    "faqCTALabel": "Foire aux questions (FAQ)",
    "bugReportCTALabel": "Signaler un problème",
    "suggestionCTALabel": "Suggestion de fonctionnalité",
    "faqLink": "https://www.partage.club/fr-ca/about/frequently-asked-questions",
    "chatPrompt": {
      "bugReport": "Salut {{name}} ! 😊\n\nMerci de nous expliquer ce qui ne va pas.",
      "suggestion": "Salut {{name}} ! 😊\n\nOn est toujours ouverts aux suggestions. Merci de nous aider à améliorer notre service.\n\nMerci !"
    }
  },
  "choose-sharer-type": {
    "title": "Motivations",
    "subtitle": "Avec {{appName}},\n tu penses plus...",
    "borrower": "Emprunter",
    "lender": "Prêter",
    "both": "Les deux",
    "borrowerEmoji": "🙋",
    "lenderEmoji": "🤝",
    "bothEmoji": "🔁"
  },
  "credentials": {
    "emailFieldLabel": "Adresse courriel",
    "emailFieldPlaceholder": "Adresse courriel",
    "errors": {
      "resource-already-exists": "Le courriel entré est déjà associé à un compte"
    },
    "activationCodeFieldLabel": "Code d'invitation",
    "activationCodeFieldPlaceholder": "Entre le code qui t'a été partagé",
    "inviteCodeFieldLabel": "Code d'invitation (optionnel)",
    "inviteCodeFieldPlaceholder": "ex: XYZ1234",
    "passwordConfirmationFieldLabel": "Confirmation du mot de passe",
    "passwordConfirmationFieldPlaceholder": "Mot de passe",
    "passwordFieldLabel": "Mot de passe",
    "passwordFieldPlaceholder": "Mot de passe",
    "title": "Informations de compte",
    "loadingPleaseWait": "Chargement en cours, veuillez patienter...",
    "validate": "Valider"
  },
  "email-verification": {
    "codeFieldLabel": "Code de confirmation",
    "codeFieldPlaceholder": "ex: 123456",
    "errors": {
      "invalid-code": "Le code entré n'est pas valide, veuillez essayer de nouveau"
    },
    "subtitle": "Un courriel a été envoyé contenant un code de sécurité. Entre ce code avant de pouvoir continuer.",
    "title": "Validation du courriel"
  },
  "favourites": {
    "empty": {
      "filtered": "Aucun favori ne correspond à ce filtre.",
      "firstLine": "Mets ta première offre en favori !",
      "primaryButtonText": "Explorer les offres",
      "secondLine": "Les favoris apparaîtront ici"
    },
    "filters": {
      "all": "Tout"
    },
    "title": "Mes favoris"
  },
  "forgot-password": {
    "emailFieldLabel": "Adresse courriel",
    "emailFieldPlaceholder": "Adresse courriel",
    "forgotPassword": {
      "close": "Fermer la récupération du mot de passe",
      "goBack": "Retour"
    },
    "primaryButtonText": "Réinitialiser mon mot de passe",
    "subtitle": "Saisis ton adresse courriel ci-dessous et nous t'enverrons un courriel contenant les instructions pour créer un nouveau mot de passe.",
    "title": "Récupérer ton mot de passe"
  },
  "free-sub": {
    "billboardButtonText": "Allez au babillard",
    "headerText": "Tu as publié ta première offre.",
    "headerTextFiveOffers": "Tu as publié 5 offres !",
    "headerTextNotYet": "Tu contribues à faire grandir le catalogue du <strong>Partage Club</strong> !",
    "headerTextTutorial": "Tu maîtrises à présent l'art de partager des objets.",
    "headerTitle": "Bravo !",
    "headerTitleNotYet": "Merci !",
    "inviteButtonText": "Inviter mes voisin.e.s",
    "myImpactLevelButtonText": "Voir mon impact",
    "createOfferButtonText": "Publier une autre offre",
    "spreadTheLoveText": "Parle-en à tes voisin.e.s pour qu’eux.elles aussi puissent profiter de l’offre spéciale !",
    "subHeaderTextTutorial": "Merci d'avoir publié un objet. Nous sommes ravis de t'annoncer que ton abonnement annuel gratuit est maintenant activé !",
    "subscriptionActivatedText": {
      "CAD": "<strong>Abonnement annuel activé</strong> (valeur de 60 $)",
      "EUR": "<strong>Abonnement annuel activé</strong> (valeur de 72 €)",
      "USD": "<strong>Abonnement annuel activé</strong> (valeur de 72 USD)"
    },
    "subscriptionNotYetActivatedText": "<strong>Continue à publier des offres pour gagner ton abonnement !</strong>",
    "userNowContributorText": "Tu accèdes à un niveau supérieur : <strong>Contributeur</strong>. En publiant ta première offre, tu as augmenté ton impact."
  },
  "group-members": {
    "headerTitle": "Membres",
    "Members": "Membres",
    "filter": {
      "apply": "Appliquer",
      "neighborhoodClub": "Club du quartier",
      "title": "Filtre"
    }
  },
  "grouped-listing": {
    "concierge": {
      "title": "Un seul besoin. On s’occupe de demander.",
      "description": "Publie un besoin dans ta communauté. On contacte les prêteurs pour toi.",
      "action": "Envoyer une demande",
      "publishing": "Publication du besoin…",
      "successTitle": "Le besoin est publié !",
      "successDescription": "Nous allons contacter les prêteurs potentiels. Les réponses seront accessibles dans le besoin.",
      "viewRequest": "Voir mon besoin",
      "retry": "Réessayer",
      "message": "Bonjour ! Je cherche à emprunter {{item}}. Serait-il possible de me prêter cet objet ? Nous pourrons convenir des dates ensemble. Merci !",
      "queued_one": "Envoi dans {{count}} seconde…",
      "queued_other": "Envoi dans {{count}} secondes…",
      "undo": "Annuler l’envoi",
      "undone": "Rien n’a été publié. Aucun prêteur n’a été contacté.",
      "pausedTitle": "Les contacts sont en pause",
      "pausedDescription": "Ton besoin reste visible dans ta communauté. Reprends quand tu veux.",
      "activeDescription": "Ton besoin est visible dans ta communauté. On contacte les prêteurs pour toi.",
      "waitingDescription": "Ton besoin est visible dans ta communauté. Consulte les réponses dans ton besoin.",
      "found": "Un.e prêteur.se peut aider",
      "foundDescription": "Ouvre ton besoin pour échanger avec le.la prêteur.se.",
      "contacted_zero": "Aucun prêteur contacté pour le moment.",
      "contacted_one": "{{count}} prêteur contacté.",
      "contacted_other": "{{count}} prêteurs contactés."
    },
    "headerSection": {
      "numOffers": "Nombre de prêteurs : {{numOffers}}",
      "lenders_one": "{{number}} prêteur à proximité",
      "lenders_other": "{{number}} prêteurs à proximité",
      "available": "Disponible à proximité"
    },
    "listHeader": "Contacte directement un.e prêteur.se :",
    "listHeaderLegacy": "Choisis un.e prêteur.se :"
  },
  "guidelines": {
    "firstParagraph": "<strong>Toujours être respectueux.euse</strong> avec les membres que ce soit virtuellement ou en personne.",
    "secondParagraph": "<strong>Veiller à remettre les objets empruntés</strong> dans l'état dans lequel ils ont été prêtés. Si un dommage survient, nous recommandons à l'emprunteur de réparer ou de remplacer l'objet concerné.",
    "secondParagraphInsured": "<strong>Veiller à remettre les objets empruntés</strong> dans l'état dans lequel ils ont été prêtés. Avec ton abonnement, si un dommage survient aux objets que tu prêtes ou empruntes d'une valeur de 25 $ ou plus, <strong>nous nous engageons à te dédommager jusqu’à 300 $ par an</strong>. N’hésite pas à nous contacter via la messagerie de l'app ou par courriel à info@partage.club.",
    "secondParagraphPublic": "<strong>Respecter les dates et heures de rencontre</strong> convenues avec les membres.",
    "thirdParagraph": "<strong>Respecter les dates de retour des prêts.</strong>",
    "thirdParagraphPublic": "<strong>Respecter les consignes</strong> de ramassage des membres.",
    "fourthParagraph": "<strong>Être généreux.euse</strong> en répondant proactivement aux besoins des membres.",
    "fifthParagraph": "Ne pas utiliser Partage Club pour louer ou vendre des objets.",
    "conditionsCheckboxText": "J'accepte les <Link1>conditions d'utilisation</Link1> et la <Link2>politique de confidentialité</Link2>.",
    "guidelinesCheckboxText": "Je m'engage à respecter les règles d'or.",
    "primaryButtonText": "Enregistrer",
    "startingKit": "Je veux recevoir la <startingKitLink>Trousse de départ</startingKitLink> par la poste pour recruter mes voisin.e.s (optionnel)",
    "title": "Les règles d'or"
  },
  "image-picker": {
    "add": "Ajouter",
    "camera": "Appareil photo",
    "cancel": "Annuler",
    "fileTooLarge": {
      "title": "Fichier trop volumineux",
      "text": "Choisis un fichier de moins de {{max}} Mo."
    },
    "library": "Galerie photo",
    "manage": "Gérer les photos",
    "save": "Enregistrer"
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Rejoint Partage Club",
        "title": "Explorateur"
      },
      "1": {
        "button": "Publier",
        "description": "Publie une offre",
        "description-completed": "Publié une offre",
        "title": "Contributeur"
      },
      "2": {
        "button": "Explorer",
        "description": "Réalisez un partage (prêt ou emprunt)",
        "description-completed": "Réalisé un partage",
        "title": "Partageur"
      },
      "3": {
        "button": "Explorer",
        "description": "Réalisez 5 partages (prêt ou emprunt)",
        "description-completed": "Réalisé 5 partages",
        "title": "Super Partageur.euse"
      }
    }
  },
  "header": {
    "publishButton": "Publier",
    "helpButtonAccessibilityLabel": "Aide sur le processus de partage"
  },
  "introModal": {
    "pageTitle": {
      "intro": "Bon à savoir !",
      "b2c_paid": "Abonnement activé",
      "b2b_activated": "Abonnement activé",
      "newly_insured": "La Responsabilité Partage Club",
      "offre_defricheur": "Offre du Défricheur",
      "custom": "Information"
    },
    "title": "Bonjour\n{{name}} !",
    "titleNewFeature": "Partage Club est responsable !",
    "codeFullWarning": "Tous les abonnements offerts par {{groupName}} ont été distribués mais tu peux toujours profiter d’une offre gratuite. →",
    "welcome": {
      "b2b": "<strong>Bienvenue dans le Club !</strong>\nGrâce à {{groupName}}, ton abonnement est gratuit. 🎉Profites-en pour partager de façon illimitée avec {{withWho}} !",
      "withWho": {
        "education": "les membres de ta communauté",
        "enterprise": "tes collègues et tes voisins",
        "municipal": "tes voisins",
        "municipal_closed": "tes voisins",
        "realestate": "tes voisins"
      },
      "trial": {
        "CAD": "<strong>Ton premier emprunt est gratuit !\n</strong><padding/>Prêter tes objets ?\nGratuit à vie.\n<padding/><smaller>Après ton crédit gratuit, abonne-toi pour continuer à emprunter :\n<padding/><strong>• 60 $/an</strong>\n<padding/><underline>Aucun paiement sans ton accord.</underline></smaller>",
        "EUR": "<strong>Ton premier emprunt est gratuit !\n</strong><padding/>Prêter tes objets ?\nGratuit à vie.\n<padding/><smaller>Après ton crédit gratuit, abonne-toi pour continuer à emprunter :\n<padding/><strong>• 72 €/an</strong>\n<padding/><underline>Aucun paiement sans ton accord.</underline></smaller>",
        "USD": "<strong>Ton premier emprunt est gratuit !\n</strong><padding/>Prêter tes objets ?\nGratuit à vie.\n<padding/><smaller>Après ton crédit gratuit, abonne-toi pour continuer à emprunter :\n<padding/><strong>• 72 USD/an</strong>\n<padding/><underline>Aucun paiement sans ton accord.</underline></smaller>"
      },
      "regular": "<strong>Bienvenue dans le Club !</strong>\nEn tant que membre officiel du Partage Club, ton abonnement te donne accès à de nouveaux avantages."
    },
    "insurable": {
      "insurance": {
        "trial": "Avec ton abonnement, si un dommage survient aux objets que tu prêtes ou empruntes d'une valeur de 25 $ ou plus, <strong>nous nous engageons à te dédommager jusqu’à 300 $ par an</strong>.",
        "regular": "Grâce à ton abonnement, si un dommage survient à tes objets d'une valeur de 25 $ ou plus pendant un prêt, <strong>nous nous engageons à te dédommager jusqu’à 300 $ par an</strong>."
      },
      "zeroOnePercent": "Rassure-toi, moins de 0,1 % des partages entraînent un dommage. Il est tout à fait normal qu'un objet présente des signes d'usure lorsqu'il est partagé et utilisé par plusieurs !"
    },
    "notInsurable": {
      "savings": "<strong>Emprunter, c’est bien plus économique qu’acheter !</strong> Jette un œil sur l’application avant d’acheter, tu risques d’être surpris.e.",
      "community": "<strong>C’est l’occasion parfaite pour faire connaissance avec tes voisins.es</strong>, et faire un pas vers un monde durable."
    },
    "cleaner": "Et imagine… <strong>les objets reviennent souvent même plus propres qu'avant</strong>. C’est magique !",
    "referralPromo": "<strong>Réfère quelqu’un et obtiens un mois gratuit !</strong>\nChaque nouvelle référence prolonge ton abonnement d’un mois.\n\nExemple : 12 références = 12 mois gratuits.",
    "offreDefricheur": "Il y a peu d'objets dans ton quartier. <strong>Abonnement annuel gratuit aux 5 premier.ère.s</strong> qui publieront un objet.",
    "borrow": "<strong>Tu peux maintenant emprunter</strong> parmi un large catalogue d’objets disponibles à deux pas de chez toi.",
    "custom": {
      "support": "<strong>Un bris ? Un souci ? Partage Club t’assure un service aux membres en tout temps.</strong>",
      "supportButtons": {
        "inAppMessaging": "Messagerie",
        "email": "Courriel"
      }
    },
    "continueButton": " Suivant →",
    "backButton": "← Précédent",
    "doneButton": "J'ai compris"
  },
  "insured": {
    "landing-page": {
      "title": "Responsabilité Partage Club",
      "text": "Tu es protégé·e en cas de dommages"
    },
    "listing": {
      "title": "Partage en toute confiance.",
      "text": {
        "own": "Avec ton abonnement, tu profites de la Responsabilité Partage Club en cas de dommage à tes objets.",
        "other": "Avec son abonnement, {{name}} profite de la Responsabilité Partage Club en cas de dommage à ses objets."
      }
    },
    "link": {
      "more_details": "En savoir plus"
    },
    "myPlan": {
      "title": "Partage Club est responsable",
      "text": "En t’abonnant, tu profites de la Responsabilité Partage Club si un objet que tu prêtes ou empruntes est endommagé."
    },
    "profile": {
      "title": "{{name}} profite de la <strong>Responsabilité Partage club</strong> en cas de <strong>dommage</strong> à ses objets."
    },
    "help": {
      "button": "Signaler un dommage"
    },
    "details": {
      "title": "Responsabilité Partage Club",
      "text": {
        "own": "Avec ton abonnement, si un dommage survient aux objets que tu prêtes ou empruntes d'une valeur de 25 $ ou plus, nous nous engageons à te dédommager jusqu'à <strong>300 $ par an</strong>.",
        "other": "Avec son abonnement, si un dommage survient aux objets que {{name}} te prête ou t'emprunte d'une valeur de 25 $ ou plus, nous nous engageons à le.la dédommager jusqu'à <strong>300 $ par an</strong>."
      },
      "how": {
        "intro": "Comment ça fonctionne :",
        "step1": "Le prêteur ou l’emprunteur nous contacte via la messagerie de l'app ou par courriel.",
        "step2": "On fait le constat rapidement.",
        "step3": "Si la demande est admissible, on dédommage le prêteur."
      },
      "link": "Lire la politique de responsabilité"
    }
  },
  "invite": {
    "headerAction": "Inviter",
    "headerTitle": "Inviter des amis",
    "codeCopied": "Le code d'invitation a été copié.",
    "details": "Tu as invité {{numInvited}} personnes.\nPlus tu invites, plus tu contribues à faire grandir cette chaîne de générosité !",
    "details2": "",
    "referralProgram": {
      "title": "Tu aimes Partage Club ?\n<color>Pour chaque référence</color> nous t’offrons <color>1 mois gratuit !</color>",
      "details": "Chaque fois qu’un ami s’abonne avec ton lien de référencement, tu reçois 1 mois gratuit chez Partage Club.",
      "details2": "",
      "referrals": {
        "title_zero": "Prêt à commencer ? 🚀",
        "title": "Tes références ! 🎉",
        "subTitle_zero": "Fais ta première référence pour obtenir ton premier mois gratuit !",
        "subTitle_one": "<strong>{{count}} personne</strong> a rejoint Partage Club grâce à <strong>toi</strong> 🥳",
        "subTitle": "<strong>{{count}} personnes</strong> ont rejoint Partage Club grâce à <strong>toi</strong> 🥳",
        "rewardMessage_one": "Grâce à ta référence, tu as gagné <strong>1 mois d’abonnement gratuit</strong> 😊",
        "rewardMessage": "Grâce à tes références, tu as gagné <strong>{{count}} mois d’abonnement gratuit</strong> 😊",
        "1referral": "Une référence",
        "1monthFree": "Un mois gratuit",
        "1monthFreeWithEmoji": "1 mois gratuit 🎉"
      },
      "subscription": "Voir mon abonnement",
      "howItWorks": {
        "title": "Comment ça marche ?",
        "subtitle": "1 membre référé = 1 personne qui télécharge l’application et crée un compte",
        "step1": "Envoie ton code d'invitation",
        "step2": "Tes amis s’inscrivent avec ton code",
        "step3": "Reçois ta récompense !"
      },
      "gift": {
        "prefix": "Pour chaque personne référée, tu reçois automatiquement un mois gratuit chez Partage Club.",
        "prefix2": "<strong>1 mois gratuit</strong>"
      },
      "shareYourCode": "Partage ton code",
      "shareText": "Salut !\n\nJ’utilise Partage Club, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}"
    },
    "referralProgram202506": {
      "title": "T'aimes Partage Club ?\n<color>Invite 5 personnes</color> et on t’offre <color>un cadeau d’une valeur de 25 $ !</color>",
      "details": "Chaque fois que 5 de tes amis s’abonnent grâce à ton lien de référencement, tu reçois un cadeau d’une valeur de 25 $.",
      "details2": "",
      "currentStep": {
        "progress": "{{numInvites}} sur 5",
        "0": "Prêt à commencer ? 🚀",
        "1": "C’est parti ! 🎯",
        "2": "Beau début ! ✌️",
        "3": "Tu y es presque ! 🔥",
        "4": "Plus qu’un ! ⏳",
        "5": "🎉 Bravo et merci.\nTu as gagné ta récompense !"
      },
      "howItWorks": {
        "title": "Comment ça marche ?",
        "subtitle": "1 membre référé = 1 personne qui télécharge l’app et crée un compte",
        "step1": "Envoie ton code d'invitation",
        "step2": "Tes amis s'inscrivent avec ton code",
        "step3": "Obtiens ta récompense !"
      },
      "gift": {
        "prefix": "Dès que tu atteins <strong>5 membres référés</strong>, tu obtiens <strong>25 $</strong> au choix :",
        "gift1": "Carte-cadeau à l’épicerie de ton choix",
        "gift2": "Carte-cadeau pour le transport en commun",
        "gift3": "Don à un organisme, fait en ton nom"
      },
      "shareText": "Salut !\n\nJ’utilise Partage Club, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}"
    },
    "primaryButtonText": "Envoyer l'invitation",
    "secondaryButtonText": "Copier le code",
    "shareText": "Salut !\n\nJ’utilise Partage Club, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}",
    "subtitle": "Partage ton code",
    "title": "Invite tes voisin.e.s ou tes proches !",
    "referrals": {
      "title_zero": "Prêt à commencer ? 🚀",
      "title": "Tes références ! 🎉",
      "subTitle_zero": "Fais ta première référence en partageant ton code !",
      "subTitle_one": "<strong>{{count}} personne</strong> a rejoint Partage Club grâce à <strong>toi</strong> 🥳",
      "subTitle": "<strong>{{count}} personnes</strong> ont rejoint Partage Club grâce à <strong>toi</strong> 🥳"
    }
  },
  "landing": {
    "signin": "Me connecter",
    "signup": "M'inscrire",
    "welcome": "Bienvenue!"
  },
  "language": {
    "options": {
      "en": "Anglais",
      "fr": "Français",
      "es": "Espagnol"
    },
    "title": "Langue de communication"
  },
  "listings-filters": {
    "title": {
      "request": "Filtrer les besoins par",
      "offer": "Filtrer les offres par"
    },
    "titleClubs": "Clubs",
    "titleType": "Type",
    "transactionMode": {
      "lend": "Prêts",
      "give": "Dons",
      "sell": "Ventes"
    },
    "titleFoundRequests": "Besoins",
    "foundRequestsLabel": "Afficher besoins trouvés ?",
    "dismissedRequestsLabel": "Afficher besoins cachés ?",
    "hideFoundRequestsTag": "Besoins non trouvés",
    "showDismissedOnlyTag": "Besoins masqués",
    "titleOffersWithFee": "Offres",
    "offersWithFeeLabel": "Afficher avec frais de partage ?",
    "hideOffersWithFeeTag": "Offres sans frais",
    "showOffersWithFeeTag": "Offres avec frais",
    "titleCategories": "Catégories",
    "close": "Fermer",
    "titleTags": "Étiquettes",
    "tagsPlaceholder": "Filtrer par étiquette",
    "titleSubtypes": "Types",
    "subtype": {
      "object": "Objets",
      "service": "Services",
      "donation": "Dons"
    },
    "searchDistance": "Distance",
    "distanceTag": "{{distance}} {{unit}}"
  },
  "loanDatesPicker": {
    "endFieldPlaceholder": "Date de fin",
    "informationTextAsBorrower": "Propose des dates au prêteur pour effectuer la réservation et suivre l’objet jusqu’à son retour.",
    "informationTextAsLender": "Propose des dates à l’emprunteur pour effectuer la réservation et suivre ton objet jusqu’à son retour.",
    "informationTextAsService": "Propose une date au membre pour ce service afin de fixer la réservation.",
    "informationTextAsDonation": "Propose une date de ramassage pour récupérer ce don",
    "informationTextAsSell": "Propose une date de ramassage au vendeur pour effectuer la réservation.",
    "informationTextForExistingLoanAsBorrower": "Propose de nouvelles dates au prêteur. Les dates acceptées précédemment seront toujours effectives jusqu'à l'acceptation de ces nouvelles dates.",
    "informationTextForExistingLoanAsLender": "Propose de nouvelles dates à l’emprunteur. Les dates acceptées précédemment seront toujours effectives jusqu'à l'acceptation de ces nouvelles dates.",
    "informationTextForExistingLoanAsService": "Propose une nouvelle date au membre pour ce service. La date acceptée précédemment sera toujours effective jusqu'à l'acceptation de cette nouvelle date.",
    "informationTextForExistingLoanAsDonation": "Propose une nouvelle date au membre pour le ramassage de ce don. La date acceptée précédemment sera toujours effective jusqu'à l'acceptation de cette nouvelle date.",
    "informationTextForExistingLoanAsSell": "Propose une nouvelle date de ramassage au vendeur. La date acceptée précédemment sera toujours effective jusqu'à l'acceptation de cette nouvelle date.",
    "offerDates": "Dates de l’offre",
    "offerDateRange": "{{start}} - {{end}}",
    "plannedSalePeriodReminder": "Rappel : la période définie lors de la création de l’offre est du {{start}} au {{end}}.",
    "flexibleDates": "Les dates sont-elles flexibles ?",
    "primaryButtonTextAsBorrower": "Envoyer la demande",
    "primaryButtonTextBeforeReminder": "Continuer",
    "primaryButtonTextAsLender": "Proposer ces dates",
    "primaryButtonTextAsLenderSingleDate": "Proposer cette date",
    "promptIntroduceYourself": "N'oublie pas d'écrire un message au membre pour te présenter et lui exprimer ton intérêt !",
    "startFieldPlaceholder": "Date de début",
    "title": "Proposition de dates"
  },
  "loanFee": {
    "document": {
      "label": "Document des frais de partage",
      "help": "PDF, PNG ou JPEG — 10 Mo maximum. Visible par les membres qui consultent cette offre.",
      "choose": "Choisir un document",
      "replace": "Remplacer le document",
      "remove": "Retirer le document",
      "view": "Voir",
      "preview": "Prévisualiser : {{name}}",
      "open": "Ouvrir le document",
      "uploading": "Téléversement du document…",
      "invalid": "Choisir un fichier PDF, PNG ou JPEG de 10 Mo maximum.",
      "uploadError": "Le téléversement a échoué. Réessayer.",
      "previewError": "Impossible d’ouvrir le document. Réessayer."
    },
    "selectionTitle": "Modifier les frais de partage de la sélection ({{count}})",
    "title": "Modifier les frais de partage",
    "saveButton": "Sauvegarder les frais de partage",
    "fields": {
      "loanFeePrompt": "Frais requis pour ce prêt ?",
      "loanFeeDescriptionLabel": "Raison du frais de partage",
      "loanFeeDescriptionPlaceholder": "Expliquez en quelques mots ce que couvre ce frais. Ex. 1 personne pour montage/démontage, transport du matériel et installation, etc.",
      "loanFeeLabel": "Frais de partage",
      "loanFeePlaceholder": "0",
      "loanFeePaymentMethodLabel": "Mode de paiement"
    },
    "listingCard": {
      "loanFee": "Frais de partage"
    },
    "modals": {
      "loanFee": {
        "title": "Frais de partage",
        "text": "<strong>Qu’est-ce qu’un frais de partage ?</strong>\n\nUn frais de partage est appliqué à la discrétion du prêteur dans différents cas. Par exemple pour couvrir :\n  • Les frais de manutention ou de transport.\n  • Le temps consacré à la préparation, au montage ou au démontage.\n  • etc.",
        "detailsForLender": "Ce frais est optionnel. Il est recommandé d’indiquer clairement la raison du frais afin d’assurer une transparence avec l’emprunteur."
      },
      "amount": {
        "title": "Frais de partage",
        "text": "<strong>Combien charger ?</strong>\n\nVoici quelques repères pour estimer un frais de partage :\n\n  • Petit prêt (outils, accessoires, etc)\n<strong>5 % de la valeur marchande</strong>\n\n  • Prêt nécessitant du montage/démontage\n<strong>5 à 10 % selon l’effort requis</strong>\n\n  • Prêt avec transport ou déplacement\n<strong>Ajouter un montant fixe (ex. 10 $)</strong>\n\n  • Prêt impliquant du temps ou de la coordination\n<strong>Estimer selon le temps investi (ex. 10 $/h)</strong>\n\nCes montants sont à titre indicatif, adapte-les selon ton jugement et les particularités de chaque prêt."
      },
      "paymentMethod": {
        "title": "Mode de paiement",
        "text": "<strong>Paiement du frais de partage</strong>\n\n  • Si le mode de paiement n’est pas indiqué, il est fortement recommandé de s’entendre avec le prêteur en amont du partage.\n  • Le paiement du frais de partage peut se faire avant ou après le partage, à la convenance du prêteur et de l'emprunteur.\n  • Le paiement se fait à l'extérieur de l’application."
      },
      "other": {
        "title": "Frais de partage"
      }
    },
    "paymentMethods": {
      "cash": "Comptant",
      "interac": "Virement Interac",
      "eft": "Virement bancaire",
      "other": "Autre"
    }
  },
  "loanParticipants": {
    "title": "Participants"
  },
  "loans": {
    "services": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tes emprunts ou services à recevoir s'afficheront ici."
        },
        "pastTitle": "Service reçu",
        "subtitle": "Emprunts en cours et services à recevoir",
        "title": "Je reçois"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tes prêts ou services à rendre s'afficheront ici."
        },
        "pastTitle": "Service rendu",
        "subtitle": "Prêts en cours et services à rendre",
        "title": "J'offre"
      },
      "past": {
        "tabs": {
          "borrowing": "Reçus",
          "lending": "Offerts"
        }
      }
    },
    "donations": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tes emprunts ou dons à recevoir s'afficheront ici."
        },
        "pastTitle": "Don reçu",
        "subtitle": "Emprunts en cours et dons à recevoir",
        "title": "Je reçois"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tes prêts ou dons offerts s'afficheront ici."
        },
        "pastTitle": "Don offert",
        "subtitle": "Prêts en cours et dons offerts",
        "title": "J'offre"
      },
      "past": {
        "tabs": {
          "borrowing": "Reçus",
          "lending": "Offerts"
        }
      }
    },
    "sales": {
      "borrowing": {
        "pastTitle": "Achat"
      },
      "lending": {
        "pastTitle": "Vente"
      }
    },
    "services+donations": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tes emprunts, tes services à recevoir et dons à recevoir s'afficheront ici."
        },
        "subtitle": "Emprunts en cours, services à recevoir et dons à recevoir",
        "title": "Je reçois"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tes prêts, tes services à rendre et dons offerts s'afficheront ici."
        },
        "subtitle": "Prêts en cours, services à rendre et dons offerts",
        "title": "J'offre"
      },
      "past": {
        "tabs": {
          "borrowing": "Reçus",
          "lending": "Offerts"
        }
      }
    },
    "services+donations-ro": {
      "borrowing": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tes dons à recevoir s'afficheront ici."
        },
        "subtitle": "Dons à recevoir",
        "title": "Je reçois"
      },
      "lending": {
        "empty": {
          "firstLine": "",
          "secondLine": "Tes services à rendre s'afficheront ici."
        },
        "subtitle": "Services à rendre",
        "title": "J'offre"
      },
      "past": {
        "tabs": {
          "borrowing": "Reçus",
          "lending": "Offerts"
        }
      }
    },
    "borrowing": {
      "empty": {
        "firstLine": "Aucun objet emprunté",
        "secondLine": "Tous tes emprunts s'afficheront ici."
      },
      "pastTitle": "Emprunt",
      "subtitle": "Les objets que j'emprunte",
      "title": "Mes emprunts"
    },
    "calendar": {
      "activitySummary_one": "{{count}} activité en {{month}}",
      "activitySummary_other": "{{count}} activités en {{month}}",
      "activityTitle": "Activité du mois",
      "close": "Fermer les détails de la date",
      "dateAccessibility_one": "{{date}}, {{count}} activité",
      "dateAccessibility_other": "{{date}}, {{count}} activités",
      "emptyPeriod": {
        "closestActivity": "Aller à {{month}}",
        "description": "Choisis un autre mois ou passe à l'activité la plus proche.",
        "title": "Aucune activité ce mois-ci"
      },
      "emptyRange": {
        "description": "Fais défiler le calendrier ou utilise les flèches pour voir une autre période.",
        "title": "Aucune activité sur cette période"
      },
      "legend": {
        "late": "À surveiller",
        "ongoing": "En cours",
        "returned": "À confirmer",
        "scheduled": "À venir"
      },
      "loading": "Chargement des prêts",
      "nextMonth": "Mois suivant",
      "nextPeriod": "Période suivante",
      "noActivityOnDate": "Il n'y a aucune activité à cette date.",
      "planner": {
        "attentionSummary_one": "{{count}} élément à surveiller",
        "attentionSummary_other": "{{count}} éléments à surveiller",
        "compact": {
          "attention": "Alerte",
          "completed": "Terminé",
          "loanCount_one": "{{count}} prêt",
          "loanCount_other": "{{count}} prêts",
          "ongoing": "En cours",
          "periodSummary_one": "{{count}} activité",
          "periodSummary_other": "{{count}} activités"
        },
        "due": "échéance",
        "groups": {
          "attention": "À surveiller",
          "completed": "Terminés",
          "ongoing": "En cours",
          "upcoming": "À venir"
        },
        "loanColumn": "Emprunts",
        "returned": "retourné",
        "starts": "débute",
        "views": {
          "month": "Mois",
          "planner": "Partages"
        }
      },
      "previousMonth": "Mois précédent",
      "previousPeriod": "Période précédente",
      "sheetSummary_one": "{{count}} activité à cette date",
      "sheetSummary_other": "{{count}} activités à cette date",
      "tabs": {
        "borrowing": "Liste",
        "calendar": "Calendrier",
        "lending": "Liste"
      },
      "today": "Aujourd'hui"
    },
    "card": {
      "status": {
        "cancelled": "Annulé",
        "late": "En retard",
        "ongoing": "En cours",
        "past": "Terminé",
        "pending": "En attente",
        "returned": "Retourné",
        "returnedSale": "Vendu",
        "returnedService": "Rendu",
        "returnedDonation": "Ramassé",
        "scheduled": "Planifié"
      },
      "type": {
        "offer": {
          "mine": "Ton offre",
          "notMine": "Offre d'un membre"
        },
        "request": {
          "mine": "Ton besoin",
          "notMine": "Besoin d'un membre"
        }
      },
      "when": {
        "late": {
          "x_days": "En retard de {{numDays}} jours",
          "yesterday": "En retard depuis hier"
        },
        "ongoing": {
          "today": "Retour prévu aujourd'hui",
          "tomorrow": "Retour prévu demain",
          "x_days": "Retour prévu dans {{numDays}} jours"
        },
        "past": {
          "today": "Retourné aujourd'hui",
          "x_days": "Retourné le {{date}}",
          "yesterday": "Retourné hier"
        },
        "pending": {
          "today": "En attente de confirmation",
          "tomorrow": "En attente de confirmation",
          "x_days": "En attente de confirmation"
        },
        "returned": {
          "today": "Retourné aujourd'hui",
          "x_days": "Retourné le {{date}}",
          "yesterday": "Retourné hier"
        },
        "scheduled": {
          "today": "Planifié pour aujourd'hui",
          "tomorrow": "Planifié pour demain",
          "x_days": "Prévu dans {{numDays}} jours"
        }
      },
      "whenService": {
        "late": {
          "x_days": "En retard de {{numDays}} jours",
          "yesterday": "En retard depuis hier"
        },
        "ongoing": {
          "today": "Prévu aujourd'hui",
          "tomorrow": "Prévu demain",
          "x_days": "Prévu dans {{numDays}} jours"
        },
        "past": {
          "today": "Rendu aujourd'hui",
          "x_days": "Rendu le {{date}}",
          "yesterday": "Rendu hier"
        },
        "pending": {
          "today": "En attente de confirmation",
          "tomorrow": "En attente de confirmation",
          "x_days": "En attente de confirmation"
        },
        "returned": {
          "today": "Rendu aujourd'hui",
          "x_days": "Rendu le {{date}}",
          "yesterday": "Rendu hier"
        },
        "scheduled": {
          "today": "Prévu aujourd’hui",
          "tomorrow": "Prévu pour demain",
          "x_days": "Prévu dans {{numDays}} jours"
        }
      },
      "whenDonation": {
        "late": {
          "x_days": "En retard de {{numDays}} jours",
          "yesterday": "En retard depuis hier"
        },
        "ongoing": {
          "today": "Prévu aujourd'hui",
          "tomorrow": "Prévu demain",
          "x_days": "Prévu dans {{numDays}} jours"
        },
        "past": {
          "today": "Ramassé aujourd'hui",
          "x_days": "Ramassé le {{date}}",
          "yesterday": "Ramassé hier"
        },
        "pending": {
          "today": "En attente de confirmation",
          "tomorrow": "En attente de confirmation",
          "x_days": "En attente de confirmation"
        },
        "returned": {
          "today": "Ramassé aujourd'hui",
          "x_days": "Ramassé le {{date}}",
          "yesterday": "Ramassé hier"
        },
        "scheduled": {
          "today": "Prévu aujourd’hui",
          "tomorrow": "Prévu pour demain",
          "x_days": "Prévu dans {{numDays}} jours"
        }
      },
      "whenSale": {
        "late": {
          "x_days": "Vente en retard de {{numDays}} jours",
          "yesterday": "Vente en retard depuis hier"
        },
        "ongoing": {
          "today": "Vente prévue aujourd'hui",
          "tomorrow": "Vente prévue demain",
          "x_days": "Vente prévue dans {{numDays}} jours"
        },
        "past": {
          "today": "Vente complétée aujourd'hui",
          "x_days": "Vente complétée le {{date}}",
          "yesterday": "Vente complétée hier"
        },
        "pending": {
          "today": "En attente de confirmation",
          "tomorrow": "En attente de confirmation",
          "x_days": "En attente de confirmation"
        },
        "returned": {
          "today": "Réception confirmée aujourd'hui",
          "x_days": "Réception confirmée le {{date}}",
          "yesterday": "Réception confirmée hier"
        },
        "scheduled": {
          "today": "Vente prévue aujourd’hui",
          "tomorrow": "Vente prévue demain",
          "x_days": "Vente prévue dans {{numDays}} jours"
        }
      }
    },
    "lending": {
      "empty": {
        "firstLine": "Aucun objet en prêt",
        "secondLine": "Tous tes prêts s'afficheront ici."
      },
      "pastTitle": "Prêt",
      "subtitle": "Les objets que je prête",
      "title": "Mes prêts"
    },
    "past": {
      "empty": {
        "filtered": "Aucun historique ne correspond à ce filtre.",
        "firstLine": "Ton historique de partage est vide",
        "secondLine": "Tous les prêts et les emprunts terminés s'afficheront ici."
      },
      "filters": {
        "all": "Tout"
      },
      "savings": {
        "header": {
          "borrowing": "Économisé en empruntant plutôt qu'en achetant",
          "lending": "Économisé par tes voisins grâce à toi"
        }
      },
      "cards": {
        "date": "{{end}}",
        "dates": "{{start}} au {{end}}"
      },
      "rating": {
        "mine": "Mon évaluation :",
        "recommended": "Recommandé",
        "notRecommended": "Non recommandé"
      },
      "tabs": {
        "borrowing": "Emprunts",
        "lending": "Prêts"
      },
      "title": "Mon historique"
    }
  },
  "login": {
    "signUpOrLogin": "S’inscrire / Se connecter",
    "title": "Connecte-toi",
    "emailFieldLabel": "Adresse courriel",
    "emailFieldPlaceholder": "Adresse courriel",
    "passwordFieldLabel": "Mot de passe",
    "passwordFieldPlaceholder": "Mot de passe",
    "forgotPassword": "J'ai oublié mon mot de passe",
    "guestPrimaryButtonText": "Continuer",
    "primaryButtonText": "Me connecter",
    "lastUsedMethod": "Utilisé récemment",
    "noAccountYetPrefix": "Pas de compte ?",
    "noAccountYet": "S'inscrire",
    "downloadApp": "Télécharge l'app!",
    "errors": {
      "incorrect-credentials": "Ton courriel ou mot de passe n'est pas valide."
    }
  },
  "management": {
    "bonificationPrompt": {
      "text": "Certains de tes objets sont disponibles, mais sans photo ou description."
    },
    "tabBarLabel": "Partages",
    "title": "Mes partages",
    "ongoing": "Partages en cours",
    "publications": "Mes publications",
    "moreOptions": "Plus d'options"
  },
  "my-address": {
    "administrativeAreaFieldLabel": "Province",
    "administrativeAreaFieldPlaceholder": "Choisir la province",
    "cityFieldLabel": "Ville",
    "countryFieldLabel": "Pays",
    "countryRegionLockedHelp": "Une fois le compte créé, son adresse ne peut pas passer des États-Unis à un autre pays, ni l’inverse.",
    "postalCodeFieldLabel": "Code postal",
    "primaryButtonText": "Enregistrer",
    "streetFieldLabel": "Numéro et nom de rue",
    "title": "Mon adresse",
    "unitFieldLabel": "Appartement (optionnel)"
  },
  "my-clubs": {
    "createClubButton": "Ajouter un quartier",
    "addProClubButton": "Rejoindre un club",
    "infoButtonLabel": "Plus d'information sur mes clubs",
    "help": {
      "neighbourhoods": {
        "title": "Clubs de quartier",
        "paragraph1": "Ajoute des clubs pour les quartiers que tu fréquentes souvent pour accéder à plus d’offres et élargir tes offres à plus de membres.",
        "paragraph2": "L’école de ton enfant, ton chalet, etc."
      },
      "pro": {
        "title": "Clubs partenaires",
        "paragraph1": "Un club partenaire est géré par une organisation comme ta ville, employeur, association ou université. Ajoute un tel club si tu as reçu un code d'invitation."
      }
    },
    "neighbourhoodClubName": "Domicile",
    "neighbourhoodTitle": "Clubs de quartier",
    "sharingPlaceTitle": "Lieux de partage",
    "proTitle": "Clubs partenaires",
    "title": "Mes clubs"
  },
  "activity-sectors": {
    "title": "Mes secteurs d’activité",
    "fieldLabel": "Secteur d’activité (obligatoire)*",
    "subtitle": "Sélectionne les secteurs qui décrivent le mieux ton activité. Tu peux en choisir plusieurs.",
    "empty": "Aucun secteur disponible pour l'instant",
    "errorToast": "Une erreur est survenue. Réessaye.",
    "minOneToast": "Tu dois garder au moins un secteur d’activité.",
    "addCta": "Ajouter un secteur",
    "overflowTitle": "Mes autres secteurs"
  },
  "my-impact-financial": {
    "ctaButtonText": {
      "borrowing": "Aller voir la liste de mes emprunts",
      "lending": "Aller voir la liste de mes prêts"
    },
    "ctaButtonTextByTransaction": {
      "lend": {
        "borrowing": "Voir mes emprunts",
        "lending": "Voir mes prêts"
      },
      "sell": {
        "borrowing": "Voir mes achats",
        "lending": "Voir mes ventes"
      },
      "give": {
        "borrowing": "Voir mes dons reçus",
        "lending": "Voir mes dons"
      }
    },
    "empty": {
      "borrowing": {
        "firstLine": "Le montant que tu économises en empruntant s’affichera ici.",
        "primaryButtonText": "Voir les offres des autres membres",
        "secondLine": "Commence à emprunter et vois combien d’argent tu économises !"
      },
      "lending": {
        "firstLine": "Le montant que les autres membres économisent en empruntant tes objets s’affichera ici.",
        "primaryButtonText": "Voir les besoins des autres membres",
        "secondLine": "Partage tes objets et vois combien d'argent tu permets aux membres d'économiser !"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "borrowing": {
          "firstLine": "Le montant que tu économises en empruntant s’affichera ici.",
          "primaryButtonText": "Voir les offres des autres membres",
          "secondLine": "Commence à emprunter et vois combien d’argent tu économises !"
        },
        "lending": {
          "firstLine": "Le montant que les autres membres économisent en empruntant tes objets s’affichera ici.",
          "primaryButtonText": "Voir les besoins des autres membres",
          "secondLine": "Partage tes objets et vois combien d'argent tu permets aux membres d'économiser !"
        }
      },
      "sell": {
        "borrowing": {
          "firstLine": "Le montant de tes achats s’affichera ici.",
          "primaryButtonText": "Voir les offres à vendre",
          "secondLine": "Commence à acheter et suis la valeur de tes achats !"
        },
        "lending": {
          "firstLine": "Le montant de tes ventes s’affichera ici.",
          "primaryButtonText": "Voir les besoins des autres membres",
          "secondLine": "Commence à vendre et suis la valeur de tes ventes !"
        }
      },
      "give": {
        "borrowing": {
          "firstLine": "La valeur des objets que tu reçois s’affichera ici.",
          "primaryButtonText": "Voir les objets à donner",
          "secondLine": "Récupère des objets et suis la valeur de tes dons reçus !"
        },
        "lending": {
          "firstLine": "La valeur des objets que tu donnes s’affichera ici.",
          "primaryButtonText": "Voir les besoins des autres membres",
          "secondLine": "Donne des objets et suis la valeur de tes dons !"
        }
      }
    },
    "howItWorks": {
      "title": "Comment est-ce calculé ?",
      "body": "Nous utilisons un outil d'intelligence artificielle pour déterminer le prix de chaque objet emprunté",
      "bodyByTransaction": {
        "lend": "Nous utilisons un outil d'intelligence artificielle pour déterminer le prix de chaque objet emprunté",
        "sell": "Nous utilisons un outil d'intelligence artificielle pour estimer la valeur de chaque objet vendu",
        "give": "Nous utilisons un outil d'intelligence artificielle pour estimer la valeur de chaque objet donné"
      }
    },
    "subtext": {
      "borrowing": "en empruntant des objets",
      "lending": "en prêtant mes objets"
    },
    "subtextByTransaction": {
      "lend": {
        "borrowing": "en empruntant des objets",
        "lending": "en prêtant mes objets"
      },
      "sell": {
        "borrowing": "en achetant des objets",
        "lending": "en vendant mes objets"
      },
      "give": {
        "borrowing": "en recevant des objets",
        "lending": "en donnant mes objets"
      }
    },
    "roleTabs": {
      "lend": {
        "borrowing": "J'ai économisé",
        "lending": "J'ai fait économiser"
      },
      "sell": {
        "borrowing": "J'ai acheté",
        "lending": "J'ai vendu"
      },
      "give": {
        "borrowing": "J'ai reçu",
        "lending": "J'ai donné"
      }
    },
    "tabs": {
      "borrowing": "J'ai économisé",
      "lending": "J'ai fait économiser"
    },
    "transactionTabs": {
      "lend": "Partage",
      "sell": "Vente",
      "give": "Don"
    },
    "title": "Mon impact économique"
  },
  "my-information": {
    "credentialInformationText": "Les informations ci-dessous <strong>ne seront pas accessibles</strong> aux autres membres.",
    "credentialInformationTitle": "Compte et sécurité",
    "edit": "Modifier",
    "editAvatarButtonLabel": "Modifier ma photo",
    "emailFieldLabel": "Courriel",
    "firstNameFieldLabel": "Prénom",
    "groupMemberCountFieldLabel": "Nombre de membres",
    "groupNameFieldLabel": "Entreprise",
    "groupsTitle": "Mon club de partage",
    "lastNameFieldLabel": "Nom de famille",
    "my-neighborhood-club": "Mon club de quartier",
    "passwordFieldLabel": "Mot de passe",
    "passwordFieldCTA": "Modifier mon mot de passe",
    "personalInformationText": "Les informations ci-dessous seront <strong>visibles</strong> aux autres membres.",
    "personalInformationTitle": "Informations personnelles",
    "phoneFieldLabel": "Numéro de téléphone",
    "phoneFieldError": "Le numéro de téléphone n'est pas valide.",
    "search-radius": "Rayon de recherche*",
    "title": "Mes informations",
    "visibilityRadiusSection": {
      "title": "Mon adresse"
    }
  },
  "my-listings": {
    "title": {
      "offer": "Mes offres",
      "request": "Mes besoins"
    },
    "editButton": "Sélectionner",
    "selectAllButton": "Tout sélectionner",
    "deselectAllButton": "Tout désélectionner",
    "cancelButton": "Annuler",
    "modifyListingsButton": "Modifier",
    "modifyListingsCountButton": "Modifier ({{count}})",
    "modifyListingsTitle": "Modifier",
    "blockDatesButton": "Réserver",
    "changeLoanFeeButton": "Modifier les frais de partage",
    "duplicateButton": "Dupliquer",
    "changePriceButton": "Modifier le prix",
    "duplicateModal": {
      "title": "Dupliquer",
      "copies": "Copies",
      "confirm": "Confirmer"
    },
    "priceModal": {
      "title": "Modifier le prix de la sélection ({{count}})",
      "label": "Prix",
      "placeholder": "50 $/kg",
      "save": "Enregistrer"
    },
    "hideButton": "Masquer",
    "hideAlert": {
      "title": "Confirmer le masquage",
      "message": "Ces objets ne seront plus visibles par les autres, mais tu pourras les restaurer plus tard ici.",
      "confirmButton": "Masquer",
      "cancelButton": "Annuler"
    },
    "unhideButton": "Dé-masquer",
    "unhideAlert": {
      "title": "Confirmer le dé-masquage",
      "message": "Ces objets seront à nouveau visibles par les autres.",
      "confirmButton": "Dé-masquer",
      "cancelButton": "Annuler"
    },
    "deleteButton": "Supprimer",
    "deleteAlert": {
      "title": "Confirmer la suppression",
      "message": "Es-tu sûr de vouloir supprimer ces objets ? Cette action est irréversible.",
      "confirmButton": "Supprimer",
      "cancelButton": "Annuler"
    },
    "hideToast": {
      "title": "Objets masqués",
      "text": "Ils ne sont plus visibles par les autres."
    },
    "unhideToast": {
      "title": "Objets dé-masqués",
      "text": "Ils sont à nouveau visibles par les autres."
    },
    "deleteToast": {
      "title": "Objets supprimés",
      "text": "Ils ont été supprimés définitivement."
    },
    "duplicateToast": {
      "title": "Objets dupliqués",
      "text": "Les copies ont été ajoutées à tes offres."
    },
    "priceUpdatedToast": {
      "title": "Prix mis à jour",
      "text": "Le prix de la sélection a été modifié."
    },
    "transactionModeTabs": {
      "all": "Tout",
      "lend": "Prêts",
      "sell": "Ventes",
      "give": "Dons"
    },
    "emptyState": {
      "all": "Tes offres s'afficheront ici",
      "lend": "Tes offres à prêter s'afficheront ici",
      "sell": "Tes offres à vendre s'afficheront ici",
      "give": "Tes offres à donner s'afficheront ici"
    }
  },
  "my-neighbourhood": {
    "addAddressHelp": "Avoir plus d’un club de quartier (plusieurs adresses) te permet d’accéder à plus d’offres.",
    "addressLabel": "Adresse",
    "audience": "Membres dans la zone",
    "clubName": "Club {{clubName}}",
    "clubNameLabel": "Nom du club",
    "createClubButton": "Ajouter ce quartier",
    "completeAddress": "Compléter l’adresse",
    "deleteButton": "Supprimer",
    "deleteConfirmation": "Supprimer ce club de quartier ?",
    "edit": "Modifier",
    "iconLabel": "Icône du club",
    "neighborhoodClub": "Club du quartier",
    "noteBelowMap": "Ajuste ta zone de partage en la déplaçant sur la carte.",
    "postalCodeLabel": "Code postal",
    "radiusLabel": "Rayon de partage",
    "radiusDescription": "Ton rayon te permet de partager tes annonces dans un périmètre limité de ton quartier. Les voisins habitant hors de cette zone ne pourront pas voir tes annonces.",
    "saveClubButton": "Sauvegarder",
    "titleNew": "Ajouter un quartier",
    "viewMembersList": "Voir la liste des membres"
  },
  "travel-distance": {
    "title": "Distance de recherche",
    "noteBelowMap": "Ajuste ta zone de recherche en la déplaçant sur la carte.",
    "potentialAudience": "Audience potentielle",
    "neighbours": "Membres",
    "neighboursRecentOnly": "Membres actifs",
    "neighbourListings": "Offres disponibles",
    "describeStatsRecentOnly": "Au cours des 3 derniers mois.",
    "noLimit": "Maximum ({{max}} {{unit}})",
    "noLimitWhiteLabel": "Aucune limite - Tous les membres",
    "save": "Sauvegarder",
    "reset": "Réinitialiser",
    "text": "La distance de recherche s'applique uniquement aux annonces de ton Club de quartier."
  },
  "my-personal-information": {
    "additionalNameFieldLabel": "Nom additionnel",
    "bioFieldLabel": "À propos de moi",
    "bioFieldPlaceholder": "Parle-nous un peu de toi.",
    "firstNameFieldLabel": "Prénom",
    "firstNameFieldPlaceholder": "Prénom",
    "lastNameFieldLabel": "Nom de famille",
    "lastNameFieldPlaceholder": "Nom de famille",
    "primaryButtonText": "Enregistrer",
    "title": "Informations générales"
  },
  "my-plan": {
    "addCodeButton": "Utiliser mon code d'invitation",
    "design": {
      "activeSubscription": "Tu es présentement sur un abonnement Partage+.",
      "available": "Disponible",
      "billingNote": {
        "monthly": "*Tu seras facturé {{price}} / mois à la date de renouvellement. Annule jusqu’à 24 h avant la date de ton prochain paiement.",
        "yearly": "*Tu seras facturé {{price}} / année à la date de renouvellement. Annule jusqu’à 24 h avant la date de ton prochain paiement."
      },
      "cancelAnytime": "Annule à tout moment",
      "cancelAnytimeShort": "Annule en tout temps",
      "cancelDescription": "Tu peux annuler ton abonnement jusqu’à 24 h avant la date de ton prochain paiement. Ton abonnement sera renouvelé automatiquement.",
      "codeCopied": "Le code d’invitation a été copié.",
      "current": "Actuel",
      "damageCoverage": "Dédommagement sur les objets",
      "discovery": "Découverte",
      "free": "gratuit",
      "freeBorrowDescription": "Emprunte ton premier objet à tes voisin·e·s gratuitement",
      "frequency": {
        "monthly": "Mensuel",
        "no": "Offert",
        "yearly": "Annuel"
      },
      "goFurther": "Pour aller plus loin",
      "invitationCode": "Ton code d’invitation",
      "learnMore": "En savoir plus",
      "manageTitle": "Gérer mon abonnement",
      "nextPayment": "Prochain paiement",
      "oneBorrow": "1 emprunt",
      "offeredBy": "Offert par :",
      "planType": {
        "citizen": "Citoyen",
        "employee": "Employé"
      },
      "referralBenefit": "Une référence = 1 mois additionnel",
      "referralTitle": "1 référence = 1 mois additionnel",
      "shareReferral": "Rejoins-moi sur Partage Club : {{url}}",
      "renewalCancelled": "Tu as annulé le renouvellement de ton abonnement Partage+.",
      "resubscribe": "Me réabonner",
      "subscribeNow": "S’abonner maintenant",
      "subscriptionEnd": "Date de fin d’abonnement",
      "unlimitedBorrowing": "Emprunts illimités",
      "unlimitedLending": "Prêts illimités",
      "unlimitedLendingDescription": "Publie des offres et prête tes objets à tes voisin·e·s autant de fois que tu le souhaites",
      "useActivationCode": "Utiliser mon code d’activation",
      "usedOn": "Utilisé le {{date}}",
      "yourBenefits": "Tes avantages"
    },
    "businessPlan": {
      "firstParagraph": {
        "education": "Ton abonnement est offert par {{planName}}.",
        "enterprise": "Ton abonnement est offert par {{planName}}.",
        "generic": "Ton abonnement est offert par {{planName}}.",
        "municipal": "Ton abonnement est offert par {{planName}}.",
        "municipal_closed": "Ton abonnement est offert par {{planName}}.",
        "realestate": "Ton abonnement est offert par {{planName}}."
      },
      "title": {
        "education": "Abonnement enseignement",
        "enterprise": "Abonnement employé",
        "generic": "Abonnement offert",
        "municipal": "Abonnement Partage+",
        "municipal_closed": "Abonnement Partage+",
        "realestate": "Abonnement résident"
      }
    },
    "defricheurPlan": {
      "firstParagraph": "Tu as reçu un abonnement gratuit grâce à l'Offre du Défricheur.",
      "title": "Abonnement <strong>annuel gratuit</strong>"
    },
    "dragonPlan": {
      "firstParagraph": "Tu es présentement sur un abonnement pour {{planName}}.",
      "title": "Abonnement <strong>annuel</strong>"
    },
    "end": "Se termine le {{date}}",
    "extraGroups": "Tes autres Clubs",
    "freeSubButtonText": "Créer une annonce",
    "freeSubText": {
      "defricheur": "Il y a peu d'objets dans ton quartier. <strong>Abonnement annuel gratuit aux 5 premier.ère.s</strong> qui publieront un objet.",
      "trial": "Contribue à faire grandir le catalogue du <strong>Partage Club</strong> ! Publie 5 objets et gagne ton <strong>abonnement annuel</strong> !"
    },
    "giftPlan": {
      "firstParagraph": "Tu as reçu un abonnement cadeau.",
      "title": "Abonnement <strong>annuel</strong>"
    },
    "modal": {
      "codeFieldLabel": "Code d'invitation",
      "codeFieldPlaceholder": "Ex: 4D86DJ",
      "error": {
        "codeLimitReached": "Il n’y a plus d’abonnements disponibles pour ce code d’invitation. Toutefois, tu peux toujours essayer l'application durant notre période d'essai gratuite.",
        "forbidden": "Tu n'es pas autorisé à utiliser ce code",
        "invalidCode": "Le code que tu as entré n'est pas valide",
        "missingCode": "Entre un code"
      },
      "firstParagraph": "Entre le code d'invitation qui t'a été transmis.",
      "primaryButtonText": "Activer",
      "secondaryButtonText": "Annuler",
      "title": "Activer ton abonnement"
    },
    "noEnd": "Abonnement à vie",
    "offreTrialPlan": {
      "firstParagraph": "Tu as reçu un abonnement gratuit en publiant 5 offres.",
      "title": "Abonnement <strong>annuel gratuit</strong>"
    },
    "planExpired": {
      "advantages": "Les avantages d’être membre",
      "title": {
        "regular": "Ton abonnement a expiré.",
        "trial": "Ta période d’essai gratuite est terminée."
      },
      "text": {
        "regular": "Tu peux continuer à prêter sans abonnement, mais pour emprunter, tu dois t'abonner.",
        "trial": "Tu peux continuer à prêter sans abonnement, mais pour emprunter, tu dois t'abonner."
      }
    },
    "promoDragonText": "<strong>Promotion</strong> « Dans l'oeil du dragon ». Bénéficiez d'un <strong>abonnement annuel</strong> à 30 $ au lieu de 60 $.",
    "promoDragonText2": "⌛ Jusqu'au 24 avril 2024 à 23 h 59",
    "promoDragonButtonText": "Profiter de 50 % de réduction (30 $)",
    "recurrenceWhen": "Date du prochain paiement",
    "endsWhen": "Date de fin d'abonnement",
    "trialEndsWhen": "Fin de la période d'essai",
    "referralPrizePlan": {
      "firstParagraph": "Tu as reçu un abonnement gratuit d'un an en invitant une personne à s'inscrire.",
      "title": "Abonnement <strong>annuel gratuit</strong>"
    },
    "regularPlan": {
      "firstParagraph": "Tu es présentement sur un abonnement régulier.",
      "title": "Abonnement <strong>régulier</strong>"
    },
    "regularMonthlyPlan": {
      "firstParagraph": "Tu es présentement abonné.e à un plan mensuel.",
      "title": "Abonnement <strong>mensuel</strong>"
    },
    "regularYearlyPlan": {
      "firstParagraph": "Tu es présentement abonné.e à un plan annuel.",
      "title": "Abonnement <strong>annuel</strong>"
    },
    "startRecurrenceButtonText": "Renouveler",
    "stopRecurrenceButtonText": "Me désabonner",
    "stopRecurrenceModal": {
      "title": "Désabonnement",
      "text": "Ton prochain paiement ne sera pas prélevé, et le renouvellement automatique sera annulé. Tu pourras continuer de profiter de ton abonnement jusqu'au {{date}}.",
      "ctaPositive": "Me désabonner",
      "ctaNegative": "Ne rien faire"
    },
    "subscribeButton": "Choisir mon abonnement",
    "title": "Mon abonnement",
    "trialPlan": {
      "firstParagraph": "Tu as <strong>1 crédit d’emprunt gratuit</strong>.",
      "title": "Découverte"
    },
    "viewReferralProgramButton": "Gagner un abonnement annuel gratuit",
    "referralProgram": {
      "title": "Envie de prolonger ton abonnement gratuitement ?",
      "subtitle": "Pour chaque personne référée, tu obtiens automatiquement un mois gratuit au Partage Club."
    }
  },
  "my-preferences": {
    "addToCalendar": {
      "always": "Oui, pour tous les prêts",
      "never": "Non, jamais",
      "once": "Me le redemander à chaque prêt"
    },
    "calendarButtonText": "Calendrier",
    "deleteAccountButtonText": "Supprimer le compte",
    "languageButtonText": "Langue de communication",
    "notificationsButtonText": "Notifications",
    "title": "Mes préférences"
  },
  "my-profile": {
    "clubName": "Club {{clubName}}",
    "memberSince": "Membre depuis {{date}}",
    "subscribedMemberSince": {
      "1": "Membre",
      "2": "abonné",
      "3": "depuis"
    },
    "city": "Ville",
    "location": {
      "profileTitle_one": "Zone de récupération approximative",
      "profileTitle_other": "Zones de récupération approximatives",
      "privacyHint": "Le cercle montre la zone approximative où les récupérations peuvent avoir lieu.",
      "securityMessage": "Cette carte ne révèle jamais une adresse exacte. Les détails de récupération partagés plus tard restent en dehors de cette carte."
    },
    "offers": {
      "empty": "Tu n'as publié aucune offre",
      "subtitle": "{{amount}} offres",
      "title": "Mes offres",
      "count_title": "Mes {{count}} offres"
    },
    "requests": {
      "empty": "Tu n'as publié aucun besoin",
      "subtitle": "{{amount}} besoins",
      "title": "Mes besoins",
      "count_title": "Mes {{count}} besoins"
    },
    "title": "Mon profil",
    "titleSharingPlace": "Mon lieu de partage",
    "tabs": {
      "offers": "Offres",
      "requests": "Besoins",
      "reviews": "Évaluations",
      "places": "Lieux",
      "available": "Sur place",
      "regulars": "Habitués"
    }
  },
  "neighbour-listings": {
    "title": {
      "offer": "Ses offres",
      "request": "Ses besoins"
    }
  },
  "neighbour-profile": {
    "empty": {
      "offers": "Les offres publiées sur ce profil s’afficheront ici.",
      "requests": "Les besoins publiés sur ce profil s’afficheront ici.",
      "places": "Les lieux de partage ajoutés à ce profil s’afficheront ici.",
      "onSite": "Les objets disponibles à récupérer dans ce lieu s’afficheront ici."
    },
    "clubName": "Club {{clubName}}",
    "contactButtonTextMember": "Contacter le membre",
    "contactButtonTextPlace": "Contacter le lieu",
    "memberSince": "Membre depuis {{date}}",
    "currentlyUnavailable": "Indisponible",
    "unavailabilityBannerMessage": "Le membre est actuellement indisponible et pourrait ne pas répondre à tes messages.",
    "subscribedMemberSince": {
      "1": "Membre",
      "2": "abonné",
      "3": "depuis"
    },
    "city": "Ville",
    "sectorActivity": "Secteur(s) d’activité",
    "location": {
      "profileTitle_one": "Zone de récupération approximative",
      "profileTitle_other": "Zones de récupération approximatives",
      "privacyHint": "Le cercle montre la zone approximative où les récupérations peuvent avoir lieu. L'adresse exacte n'est pas affichée."
    },
    "offers": {
      "empty": "Ce membre n'a publié aucune offre",
      "subtitle": "{{amount}} offres",
      "title": "Ses offres",
      "count_title": "Ses {{count}} offres"
    },
    "requests": {
      "empty": "Ce membre n'a publié aucun besoin",
      "subtitle": "{{amount}} besoins",
      "title": "Ses besoins",
      "count_title": "Ses {{count}} besoins"
    },
    "stats": {
      "chatResponseRate": "Taux de réponse",
      "chatResponseTimeAvg": "Réponse moyenne",
      "impactLevel": "Niveau d’impact",
      "numberOfIncomingLoans": "Emprunts",
      "numberOfOutgoingLoans": "Prêts",
      "numberOfRequests": "Besoins",
      "trustPoints": "Recommandations",
      "numberOfOutgoingServiceLoans": "Services rendus",
      "numberOfIncomingServiceLoans": "Services reçus",
      "numberOfOutgoingDonations": "Dons offerts",
      "numberOfIncomingDonations": "Dons reçus",
      "numberOfSales": "Ventes",
      "recommendationsShort": "Reco.",
      "shares": "Partages",
      "responseRateShort": "Taux de rép.",
      "responseTimeShort": "Rép. moyenne",
      "seeMore": "Voir plus",
      "seeLess": "Voir moins",
      "less": "Moins",
      "lent": "Prêt(s)",
      "borrowed": "Emprunt(s)",
      "requests": "Besoin(s)",
      "memberSince": "Inscription"
    },
    "seeMore": "Voir plus",
    "goodToKnow": "Bon à savoir",
    "trust": {
      "summary": "<strong>{{count}}</strong> membres dont <strong>{{names}}</strong> lui font confiance",
      "summary_one": "<strong>{{count}}</strong> membre, <strong>{{names}}</strong>, lui fait confiance",
      "summaryMore": "<strong>{{count}}</strong> membres dont <strong>{{names}}</strong> et <strong>{{remaining}} autres</strong> lui font confiance",
      "noMembers": "Aucun membre ne lui fait encore confiance",
      "add": "Ajouter au club de confiance",
      "trusted": "Je lui fais confiance",
      "info": "Les membres de ton club de confiance peuvent voir les offres que tu choisis de leur réserver.",
      "manage": "Gérer mon club de confiance",
      "circleTitle": "Club de confiance",
      "memberCount_one": "{{count}} membre",
      "memberCount": "{{count}} membres",
      "commonHeading": "Ces membres de ton club de confiance font confiance à {{name}}",
      "otherHeading": "Autres membres qui font confiance à {{name}}",
      "empty": "Aucun membre à afficher",
      "distance": "{{distance}} km",
      "since": "depuis {{date}}",
      "removeTitle": "Retirer {{name}} ?",
      "removeMessage": "{{name}} ne verra plus les offres réservées à ton club de confiance.",
      "remove": "Retirer",
      "cancel": "Annuler",
      "manager": {
        "title": "Partageur·euse·s de confiance",
        "addMembers": "Ajouter des membres",
        "search": "Rechercher des membres",
        "clear": "Tout effacer",
        "results": "Résultats de recherche",
        "suggestions": "Suggestions",
        "noResults": "Aucun autre membre trouvé",
        "save": "Enregistrer",
        "close": "Fermer"
      },
      "badge": "Dans ton club de confiance"
    },
    "shares": {
      "lentTitle": "Objets prêtés par {{name}}",
      "borrowedTitle": "Objets empruntés par {{name}}",
      "recentTitle": "Derniers partages",
      "allTitle": "Tous les partages",
      "commonTitle": "Tous les partages en commun",
      "borrowed": "a emprunté",
      "lent": "a prêté",
      "lentToYou": "t’a prêté",
      "borrowedFromYou": "t’a emprunté",
      "empty": "Aucun partage à afficher",
      "viewHistory": "Voir l’historique",
      "commonWidget": "Tu as partagé <strong>{{count}} fois</strong> avec <strong>{{name}} ·</strong> Dernier {{ago}}",
      "filters": {
        "all": "Tout ({{count}})",
        "lent": "Prêt(s) ({{count}})",
        "borrowed": "Emprunt(s) ({{count}})"
      },
      "memberActions": {
        "more": "Plus d’actions pour {{name}}",
        "view": "Voir le profil",
        "message": "Envoyer un message",
        "addTrust": "Ajouter au club de confiance",
        "removeTrust": "Retirer du club de confiance",
        "report": "Signaler le membre"
      }
    },
    "title": "Profil",
    "shareProfile": "Partager le profil",
    "mainTabs": {
      "info": "Info",
      "reviews": "Avis ({{count}})"
    },
    "titleSharingPlace": "Lieu de partage",
    "reportUser": "Signaler cet utilisateur",
    "reportUserPrompt": "Bonjour, je souhaite signaler un utilisateur dont le comportement me semble inapproprié. Pourrais-tu examiner son profil ?\n\nMerci.",
    "reportRatingPrompt": "Bonjour, je souhaite signaler une évaluation que je trouve inappropriée. Pourrais-tu l'examiner ?\n\nMerci.",
    "ambassadorLabel": "Ambassadeur·rice",
    "discount": {
      "sheetTitle": "Détails de l'offre",
      "learnMore": "En savoir plus"
    },
    "placeHelp": {
      "title": "Lieu de partage",
      "help": "Aide",
      "description": {
        "1": "Un lieu de partage est un ",
        "bold1": "espace sécuritaire et communautaire",
        "2": " dans lequel les membres peuvent se retrouver afin de ",
        "bold2": "partager",
        "3": " des objets entre eux mais aussi ",
        "bold3": "emprunter",
        "4": " des objets proposés sur place"
      },
      "features": {
        "borrow": {
          "title": "Emprunte des objets sur place",
          "description": "Choisis et emprunte des objets parmi la sélection proposée par le lieu"
        },
        "dropOff": {
          "title": "Dépose et ramasse des objets très facilement",
          "description": "Ce lieu de partage accepte de garder temporairement les objets prêtés afin que les emprunteurs viennent les récupérer quand ils le souhaitent"
        },
        "deals": {
          "title": "Bénéficie d'offres spéciales",
          "description": "Les actions de partages dans un lieu de partage te permettent de bénéficier de certains avantages comme des rabais sur les produits proposés sur place"
        },
        "frequenting": {
          "title": "Indique aux autres membres que tu fréquentes ce lieu",
          "description": "Permet aux membres de voir les lieux de partage que tu fréquentes directement sur ton profil"
        }
      }
    },
    "days": {
      "day1": "Lundi",
      "day2": "Mardi",
      "day3": "Mercredi",
      "day4": "Jeudi",
      "day5": "Vendredi",
      "day6": "Samedi",
      "day7": "Dimanche"
    },
    "place": {
      "open": "Ouvert",
      "closed": "Fermé",
      "until": "jusqu'à {{time}}",
      "closedUntil": "jusqu'à {{day}}",
      "members_one": "{{count}} membre fréquente ce lieu",
      "members": "{{count}} membres fréquentent ce lieu",
      "membersTitle": "Membres",
      "searchMembers": "Rechercher par nom",
      "noMembersFound": "Aucun membre trouvé",
      "frequenting": "Lieu fréquenté",
      "joinButton": "Je fréquente ce lieu",
      "helpButton": "Aide sur le lieu",
      "itinerary": "Itinéraire",
      "share": "Partager",
      "openingHoursTitle": "Heures d'ouverture",
      "openingHoursDisclaimer": "Les horaires sont susceptibles de changer. Pensez à vérifier directement sur le site web du commerce.",
      "viewHoursOnWebsite": "Voir les horaires sur le site",
      "joinTitle": "Je fréquente ce lieu",
      "join": {
        "profileTitle": "Afficher ce lieu sur ton profil public",
        "profileDesc": "Les autres utilisateurs pourront voir que tu fréquentes ce lieu.",
        "offersTitle": "Rend tes offres disponibles aux membres à proximité du lieu",
        "offersDesc": "Tes offres seront visibles par les membres qui fréquentent ce lieu."
      },
      "leaveTitle": "Ne plus fréquenter ce lieu",
      "leave": {
        "profileDesc": "Ce lieu ne sera plus affiché sur ton profil public.",
        "offersDesc": "Tes offres ne seront plus disponibles pour les membres à proximité de ce lieu."
      },
      "confirm": "Confirmer",
      "noListingsOffer": "Aucune offre disponible",
      "noListingsRequest": "Aucun besoin",
      "noListingsOnSite": "Aucune offre disponible sur place",
      "noFrequentedPlaces": "Aucun lieu de partage fréquenté"
    },
    "reviews": {
      "recentTitle": "Évaluations récentes",
      "noComments": "Aucun commentaire",
      "defaultSubject": "Ce membre",
      "summaryTitle": "Résumé des recommandations",
      "howItWorks": "Fonctionnement des évaluations",
      "topOpinions": "Ce que les gens pensent",
      "viewAllCount_zero": "Aucune évaluation pour cette offre",
      "viewAllCount_one": "Voir 1 évaluation",
      "viewAllCount": "Voir les {{count}} évaluations",
      "recommended": "Recommandé",
      "notRecommended": "Non recommandé",
      "loanLabel": "de prêt",
      "unknownUser": "Membre",
      "count": "{{count}} évaluations",
      "count_one": "{{count}} évaluation",
      "sortRecent": "Récents",
      "pendingPrompt": {
        "title": "Tu as eu une belle expérience ? Partage-la !",
        "bodyBorrowingStart": "Évalue ton emprunt de ",
        "bodyLendingStart": "Évalue ton prêt de ",
        "bodyWith": " avec {{name}} du ",
        "dateTo": "au",
        "button": "Laisser une évaluation"
      },
      "role": {
        "borrower": "Emprunteur·euse",
        "lender": "Prêteur·euse"
      },
      "listingType": {
        "offer": "Offre :",
        "request": "Besoin :"
      },
      "listingFallback": "Annonce",
      "labels": {
        "assetQuality": "Objet conforme",
        "logisticsReliability": "Ponctualité",
        "communityTrust": "Courtoisie"
      },
      "filters": {
        "all": "Tout ({{count}})",
        "positive": "Recommandé ({{count}})",
        "negative": "Non recommandé ({{count}})",
        "borrower": "De l’emprunteur·euse ({{count}})",
        "lender": "Du prêteur·euse ({{count}})"
      },
      "empty": {
        "title": "{{name}} n’a reçu aucune évaluation",
        "subtitle": "Les évaluations s’afficheront ici"
      },
      "sheet": {
        "title": "Comment fonctionnent les évaluations ?",
        "paragraph1": "Sur Partage Club, les évaluations permettent de bâtir une communauté de confiance pour des partages plus sûrs.",
        "paragraph2": "Lorsqu’un prêt ou un emprunt est finalisé uniquement, les membres peuvent s’évaluer en répondant à des questions thématiques ainsi qu’en laissant un commentaire et des photos s’ils le souhaitent.",
        "paragraph3": "Les résultats des questions se modélisent sous forme d’étiquettes positives, moyennes ou négatives selon les réponses. Les évaluations sont accessibles sur le profil et les offres des membres évalués et font l’objet d’une vérification de notre part."
      },
      "actions": {
        "edit": "Modifier l'évaluation",
        "delete": "Supprimer",
        "report": "Signaler l'évaluation",
        "deleteConfirmTitle": "Supprimer l'évaluation ?",
        "deleteConfirmMessage": "Cette action est irréversible.",
        "deleteConfirmOk": "Supprimer",
        "deleteConfirmCancel": "Annuler"
      }
    },
    "tabs": {
      "overview": "Aperçu",
      "listings": "Annonces",
      "reviewsShort": "Éval.",
      "offers": "Offres",
      "requests": "Besoins",
      "reviews": "Évaluations",
      "places": "Lieux",
      "available": "Sur place",
      "regulars": "Habitués"
    }
  },
  "new": {
    "bonificationPrompt": "Des photos nettes et une description claire donnent envie d’emprunter.",
    "baconBanner": {
      "text": "Ce projet pilote est réservé aux résidents de Beaconsfield. <strong>Merci de participer !</strong>",
      "linkText": "Consultez les conseils pratiques",
      "link": "https://www.beaconsfield.ca/fr/culture-et-loisirs/loisirs-et-vie-communautaire/partage-club"
    },
    "categorySection": {
      "primary": {
        "subtitle": "Sélectionne une catégorie",
        "title": "Catégorie",
        "placeholder": "Catégories"
      }
    },
    "dateSection": {
      "title": "Dates",
      "titleOne": "Date",
      "flexibleDates": "Les dates sont-elles flexibles ?",
      "endBeforeStart": "La date de fin doit être postérieure ou égale à la date de début."
    },
    "urgentSection": {
      "urgentRequiresExpirable": "L'option Urgent? est réservée aux matières périssables."
    },
    "duplicatesStepper": {
      "title": "Copies additionnelles",
      "text": "Crée des copies additionnelles de cette offre.",
      "increment": "Augmenter le nombre de copies",
      "decrement": "Diminuer le nombre de copies"
    },
    "generalSection": {
      "addPicture": "Ajouter une photo",
      "addPictureLater": "Ajouter une photo plus tard",
      "addPictures": "Ajouter des photos",
      "coverPhoto": "Couverture",
      "makeCover": "Choisir comme couverture",
      "pictureCount": "{{count}}/{{max}} photos",
      "oneOrMany": {
        "many": {
          "title": "Offre multiple",
          "subtext": "Publie plusieurs objets en un clic, sans photo ni réflexion au préalable. C'est simple et rapide !"
        },
        "one": {
          "title": "Offre individuelle",
          "subtext": "Publie ton objet en le prenant en photo."
        }
      },
      "publishOffer": "Publier une offre",
      "publishRequest": "Publier un besoin",
      "title": "Offre ou besoin ?",
      "addPhotosCompact": "Ajouter des photos"
    },
    "multiImagePicker": {
      "addImage": "Ajouter une photo",
      "addImageHint": "Ajoute une autre photo à ton annonce",
      "removeImage": "Supprimer la photo",
      "removeImageHint": "Retire cette photo de ton annonce",
      "coverHint": "La première photo sert de couverture",
      "emptyHint": "Ajoute jusqu’à {{max}} photos. Les objets avec des photos claires et bien éclairées sont empruntés plus souvent",
      "uploading": "Chargement en cours..."
    },
    "headerTitle": "Créer une annonce",
    "discardChanges": {
      "title": "Quitter la création de l’annonce ?",
      "description": "Ton annonce n’a pas été publiée. Si tu quittes maintenant, le contenu saisi sera perdu.",
      "keepEditing": "Continuer",
      "leave": "Quitter"
    },
    "bulk": {
      "headerTitle": "Créer plusieurs offres",
      "progress": {
        "accessibility": "Étape {{current}} sur {{total}}"
      },
      "steps": {
        "select": {
          "eyebrow": "Photos",
          "title": "Ajoute une photo par objet",
          "subtitle": "Choisis tous les objets que tu veux publier dans cette session."
        },
        "confirm": {
          "eyebrow": "Vérification",
          "title": "Confirme les photos",
          "subtitle": "Vérifie l’ordre et retire ce que tu ne veux pas publier."
        },
        "generating": {
          "eyebrow": "Préparation des offres",
          "title": "Création de tes offres",
          "subtitle": "Un titre et une description sont préparés pour chaque photo."
        },
        "review": {
          "eyebrow": "Publication",
          "title": "Révise chaque offre",
          "subtitle": "Vérifie les détails, puis publie ou passe chaque offre."
        },
        "complete": {
          "eyebrow": "Terminé",
          "title": "Création multiple terminée",
          "subtitle": "Tes offres publiées apparaissent maintenant comme des annonces normales."
        },
        "visibility": {
          "eyebrow": "Visibilité",
          "title": "Qui peut voir ces offres ?",
          "subtitle": "Choisis les adresses et les groupes pour toutes les offres créées dans cette session."
        }
      },
      "photoSelection": {
        "addPhotos": "Ajouter des photos",
        "selectedCount": "{{count}}/{{max}} sélectionnées",
        "reorderHint": "Utilise les flèches pour réordonner",
        "continue": "Vérifier les photos",
        "generate": "Générer les brouillons",
        "photoNumber": "Photo {{number}}",
        "firstHint": "Elle sera traitée en premier",
        "eachPhotoHint": "Un brouillon sera créé",
        "moveLeft": "Déplacer la photo plus tôt",
        "moveRight": "Déplacer la photo plus tard",
        "remove": "Supprimer la photo"
      },
      "confirmation": {
        "readyTitle": "Prêt à générer",
        "readyDescription": "{{count}} photos seront téléversées et analysées.",
        "confirm": "Générer les brouillons"
      },
      "camera": {
        "capture": "Prendre une photo",
        "close": "Fermer la caméra",
        "counter": "{{count}}/{{max}} photos",
        "done": "Terminer",
        "limitReached": "Tu as atteint la limite de {{max}} photos",
        "permissionAction": "Autoriser la caméra",
        "permissionDescription": "Autorise la caméra pour photographier tes objets, ou ajoute des photos de ta galerie ci-dessous.",
        "permissionTitle": "Accès à la caméra nécessaire",
        "remaining_one": "{{count}} photos restantes",
        "remaining_other": "{{count}} photos restantes",
        "removePhoto": "Supprimer la photo prise",
        "library": "Galerie",
        "hint": "Une photo, un objet",
        "draftHint": "Prends tes photos, puis appuie sur Terminer.",
        "finishHint": "Générer les brouillons à partir des photos sélectionnées",
        "settings": "Ouvrir les réglages",
        "removePhotoNumber": "Supprimer la photo {{number}}"
      },
      "generation": {
        "progress": "{{done}} brouillons prêts sur {{total}}",
        "progressPercent": "{{percent}} % terminé",
        "detail": "{{queued}} en attente, {{generating}} en analyse, {{failed}} en échec",
        "retryFailed": "Réessayer les échecs",
        "uploading": "Envoi de tes photos…",
        "reviewHint": "Rien n’est publié sans ton accord.",
        "failed_one": "{{count}} photo nécessite un nouvel essai.",
        "failed_other": "{{count}} photos nécessitent un nouvel essai.",
        "title": "Des photos aux offres",
        "preparing": "Tes offres prennent forme…"
      },
      "review": {
        "remaining": "{{remaining}} restants · {{saved}}/{{total}} publiés",
        "generationFailedTitle": "Cette photo n’a pas pu être analysée",
        "generationFailedDescription": "Réessaye cette photo ou passe-la pour l’instant.",
        "saveFailedTitle": "Cette offre n’a pas été publiée",
        "saveFailedDescription": "Modifie le titre ou la description et réessaye.",
        "retry": "Réessayer",
        "accept": "Publier",
        "reject": "Passer",
        "regenerate": "Régénérer",
        "skip": "Passer",
        "acceptSwipe": "Publier",
        "rejectSwipe": "Passer",
        "swipeHint": "← Passer · Publier →",
        "looksGood": "C’est bon",
        "noDraftsTitle": "Aucun brouillon à réviser",
        "noDraftsDescription": "Tout ce qui a été généré dans cette session a été publié ou passé.",
        "finish": "Terminer",
        "edit": "Voir et modifier les détails",
        "doneEditing": "Terminer la modification",
        "untitled": "Ajouter un titre",
        "titleHint": "Le titre doit contenir au moins 3 caractères.",
        "title": "Tes offres à vérifier",
        "position": "{{current}} sur {{total}}",
        "editTitle": "Modifier les détails",
        "editHint": "Vérifie les détails. Tes modifications seront publiées seulement lorsque tu appuieras sur Publier."
      },
      "completion": {
        "title": "Merci de partager !",
        "description": "{{saved}} publiées, {{skipped}} rejetées.",
        "close": "Terminer",
        "toast": "Offres publiées",
        "emptyTitle": "Toutes les photos sont vérifiées",
        "published_zero": "Aucune offre publiée.",
        "published_one": "{{count}} offre créée.",
        "published_other": "{{count}} offres créées.",
        "skipped_one": "{{count}} photo passée.",
        "skipped_other": "{{count}} photos passées."
      },
      "cancel": {
        "title": "Annuler la création multiple ?",
        "description": "Les photos des brouillons non publiés seront supprimées.",
        "keepWorking": "Continuer",
        "confirm": "Annuler la session"
      },
      "common": {
        "back": "Retour",
        "cancel": "Annuler"
      },
      "errors": {
        "noPhotos": "Ajoute au moins une photo avant de continuer.",
        "noVisibility": "Choisis au moins une adresse ou un groupe avant de créer des offres."
      },
      "visibility": {
        "confirm": "Enregistrer la visibilité",
        "privateHint": "Toutes les options de partage sont désactivées. Ces offres seront privées."
      }
    },
    "itemInformationSection": {
      "new": "Nouveau",
      "title": "Informations",
      "nameFieldLabel": "Nom de l'objet",
      "nameFieldPlaceholder": "Ex: Tondeuse à gazon",
      "serviceNameFieldLabel": "Titre",
      "serviceNameFieldPlaceholder": "Ex: Râcler le terrain, conseils jardinages…",
      "descriptionFieldLabel": "Description",
      "descriptionFieldPlaceholder": {
        "offer": "Ajoute des détails utiles : dimensions, marque, poids… Plus tu en dis, plus il sera facile pour les membres de comprendre ton offre !",
        "request": "Ajoute des détails utiles : dimensions, marque, poids… Plus tu en dis, plus il sera facile pour les membres de comprendre ton besoin !"
      },
      "clearDescription": "Effacer la description",
      "clearDescriptionAction": "Tout effacer",
      "descriptionFieldHelperText": "Plus tu en dis, plus il sera facile pour les membres de comprendre ton offre ou ton besoin !",
      "serviceDescriptionFieldPlaceholder": "Ajoute des détails utiles pour la compréhension du service demandé. Plus tu en dis, plus il sera facile pour les membres de comprendre ton besoin !",
      "aiGenerate": {
        "button": "Générer",
        "promptTitle": "Remplissage automatique",
        "promptDescription": "Un titre et une description à personnaliser.",
        "skip": "Non merci",
        "loading": "Analyse de l'image en cours",
        "error": "Impossible d'analyser l'image. Réessaye plus tard.",
        "rateLimitError": "Trop de tentatives. Réessaye plus tard."
      },
      "priceFieldLabel": "Prix",
      "valueFieldLabel": "Valeur marchande",
      "valueFieldPlaceholder": "Prix unitaire",
      "transactionMode": {
        "sell": "Vendre",
        "lend": "Prêter",
        "give": "Donner"
      },
      "requestTransactionMode": {
        "sell": "💵 Acheter",
        "lend": "🫴 Emprunter",
        "give": "🎁 Récupérer"
      },
      "assistant": {
        "knowMore": {
          "howItWorks": "Comment ça marche ?",
          "title": "Assistant intelligent",
          "text1": "Notre nouvel assistant intelligent <strong>relie</strong> tes besoins à des <strong>offres pertinentes</strong> et <strong>contacte automatiquement</strong> les membres prêteur·euse·s en se basant sur ta <strong>description</strong> et la <strong>distance souhaitée</strong>.",
          "text2": "Pour que l'assistant puisse t'aider au mieux, donne un <strong>maximum de détails</strong> relatifs à l'objet dans la description.",
          "text3": "Si aucune offre n'est pertinente les premiers jours, pas de panique! L'assistant guette les <strong>potentielles nouvelles offres</strong> publiées."
        },
        "optOutBanner": {
          "title": "Contacter automatiquement les membres qui ont ce qu’il te faut",
          "description": "Personnalise le message envoyé avant la publication"
        },
        "firstCreated": {
          "title": "C'est parti !",
          "text1": "Génial, l’assistant intelligent a commencé à rechercher des offres pertinentes! Tu seras <strong>prévenu</strong> quand des prêteur·euse·s potentiel·le·s auront <strong>répondu à ton message</strong>.",
          "text2": "Cela peut prendre plusieurs minutes",
          "text3": "En attendant, <strong>retrouve</strong> l’assistant intelligent directement dans le <strong>détail de ton besoin</strong>."
        }
      }
    },
    "chooseAutomaticMessage": {
      "text1": "Ton message automatique",
      "text2": "Tu pourras toujours le modifier plus tard",
      "automaticMessageLabel": "✏️ Personnalise le message qui sera envoyé :",
      "confirmButton": "Confirmer",
      "reset": "Réinitialiser",
      "defaultAutomaticMessage": {
        "greeting": "Salut {{firstName}}! Je cherche l'objet suivant, et le système de recommandations pense que tu pourrais potentiellement m'aider :\n\n",
        "itemWithDescription": "\"{{itemName}}: {{description}}\"",
        "itemWithoutDescription": "\"{{itemName}}\"",
        "dateBoth": "\n\nPour la période du {{startDay}} {{startMonth}} au {{endDay}} {{endMonth}}",
        "dateStartOnly": "\n\nPour la période à partir du {{startDay}} {{startMonth}}",
        "dateEndOnly": "\n\nPour la période jusqu’au {{endDay}} {{endMonth}}"
      },
      "automaticMessageRequired": "Le message ne peut pas être vide."
    },
    "listingCreatedToast": {
      "text": {
        "offer": "Pour la modifier, c’est dans Partages > Mes offres",
        "request": "Pour la modifier, c’est dans Partages > Mes besoins"
      },
      "title": "Annonce publiée"
    },
    "locationSection": {
      "addressFieldSubtitle": "Basé sur l'adresse de ton domicile",
      "addressFieldSubtitleCustom": "Basé sur l'adresse de {{clubName}}",
      "addressFieldTitle": "Club du quartier",
      "groupFieldTitle": "Club {{clubName}}",
      "oneGroupFieldTitle": "Visibilité",
      "oneGroupFieldHelp": "Cette annonce devrait-elle être visible pour les autres membres ?",
      "invisible": "Ton annonce ne sera plus affichée aux autres utilisateurs.",
      "addressesTitle": "Adresses",
      "clubsTitle": "Clubs partenaires",
      "title": "Visible pour",
      "makePrivate": "Rendre privé",
      "privateVisibility": "Visibilité privée",
      "shareWithAll": "Partager avec tous"
    },
    "primaryButtonPostOffer": "Publier l'offre",
    "primaryButtonPostOfferMultiple": "Publier {{count}} offres",
    "primaryButtonPostRequest": "Publier le besoin",
    "primaryButtonConfirmRequest": "Confirmer",
    "secondaryButtonText": "Annuler",
    "prompt": {
      "type": {
        "title": "Que souhaites-tu publier ?",
        "offer": "Offres",
        "request": "Besoins",
        "post": "Partager une expérience"
      },
      "post": {
        "title": "Quel échange souhaites-tu raconter ?",
        "loading": "Chargement de tes échanges...",
        "empty": "Tu n’as aucun échange terminé disponible pour une nouvelle publication."
      },
      "offer": {
        "title": "Offres",
        "one": "Prêter un objet spécifique",
        "perishable": "Offre périssable",
        "donation": "Offrir un objet à donner",
        "bulk": "Créer plusieurs offres à partir de photos",
        "many": "Choisir parmi des objets suggérés"
      },
      "request": {
        "title": "Besoins",
        "one": "Emprunter un objet",
        "donation": "Demander un don",
        "service": "Demander un service"
      },
      "serviceRequest": {
        "title": "Sélectionne une catégorie",
        "missing": {
          "title": "Tu ne trouves pas ?",
          "text": "Envoie-nous ta demande et nous évaluerons si elle peut être ajoutée dans la liste prochainement.",
          "ctaButton": "Envoyer",
          "chatPrompt": "Bonjour {{name}},\n\nN’hésite pas à nous <strong>communiquer le besoin de service</strong> que tu aimerais retrouver dans l’application.\n\nNous le transmettrons à la ville de Beaconsfield qui déterminera si on peut l’ajouter."
        }
      },
      "publishAnObject": "Publier un objet"
    },
    "timeSection": {
      "title": "Heures",
      "labelStart": "Début",
      "labelEnd": "Fin"
    },
    "addressSection": {
      "title": "Adresse"
    },
    "bonificationDetailsPrompt": "Une description claire donne envie d’emprunter."
  },
  "notification-explainer": {
    "headerTitle": "Notifications",
    "context": {
      "chat": {
        "subtitle": "Sois alerté·e dès que cette personne te répond en recevant une notification.",
        "title": "Aimerais-tu savoir quand {{name}} te répond ?"
      },
      "listing": {
        "subtitle": "Sois alerté·e dès qu'une personne te contacte en recevant une notification.",
        "title": "Aimerais-tu savoir quand quelqu'un te contacte ?"
      }
    },
    "primaryButtonText": "Oui, m'alerter",
    "secondaryButtonText": "Pas maintenant"
  },
  "notification-super-changed": {
    "headerTitle": "Super Partageur.euse"
  },
  "notification-warn": {
    "authorize": "Autoriser",
    "later": "Pas maintenant",
    "subtitle": "Sois alerté·e dès qu’une personne t’écrit pour emprunter tes objets ou répondre à ton besoin.",
    "title": "Active les notifications pour rester informé·e !"
  },
  "notifications": {
    "donationEndsSoonTitle": "{{listingName}} expire dans {{numDays}} jours",
    "donationEndsSoonMessage": "Change la date limite, ou supprime-le s’il n’est plus nécessaire.",
    "joinCoCreatorTitle": "Améliore l'application avec nous !",
    "joinCoCreatorMessage": "Rejoins notre groupe de cocréateurs sur Facebook.",
    "emptyState": "Tu n'as aucune notification",
    "favouriteReceived": "<strong>{{userName}}</strong> a ajouté ton annonce à ses favoris.",
    "favouriteReceivedOffer": "<strong>{{userName}}</strong> a ajouté ton offre à ses favoris.",
    "favouriteReceivedRequest": "<strong>{{userName}}</strong> a ajouté ton besoin à ses favoris.",
    "futureReminder": "Retour dans {{days}} jour(s)",
    "futureReminderSale": "Vente prévue dans {{days}} jour(s)",
    "impactLevel": "Ton niveau actuel: <strong>{{level}}</strong> !",
    "impactLevelCelebration": {
      "sharer1": {
        "message": "🥳 Bravo! Continue à faire grandir ton impact positif.",
        "title": "Tu es passé·e au niveau <strong>Partageur</strong> !"
      },
      "sharer23": {
        "message": "🎉 Tu es à <strong>{{numLeft}}</strong> partages du niveau ultime. Continue un prêt à la fois !",
        "title": "Bravo !"
      },
      "sharer4": {
        "message": "💪🏻 <strong>Un</strong> partage de plus et tu accéderas au plus haut niveau : <strong>Super Partageur.euse</strong>.",
        "title": "Tu y es presque !"
      },
      "superSharer": {
        "message": "Bravo ! À chaque partage, tu fais grandir ton impact pour un avenir plus vert. Va voir ton impact! 💚",
        "title": "Tu es un·e <strong>Super Partageur.euse</strong> !"
      }
    },
    "impactLevelExplorerMessage": "Commence ton expérience au Partage Club. Publie un objet pour faire grandir ton impact et passer au niveau suivant.",
    "impactLevelMessage": "Bravo ! Va voir comment tu peux faire grandir ton impact et faire progresser ton niveau.",
    "introModal": {
      "intro": {
        "title": "Bienvenue dans le Club",
        "body": "Découvre Partage Club !"
      },
      "b2c_paid": {
        "title": "Bienvenue dans le Club !",
        "body": "En tant que membre officiel du Partage Club, ton abonnement te donne accès à de nouveaux avantages."
      },
      "b2b_activated": {
        "title": "Bienvenue dans le Club !",
        "body": "Grâce à {{groupName}}, ton abonnement est gratuit."
      },
      "newly_insured": {
        "title": "Partage Club est responsable !",
        "body": "Grâce à ton abonnement, si un dommage survient à tes objets d'une valeur de 25 $ ou plus pendant un prêt, nous nous engageons à te dédommager jusqu’à 300 $ par an."
      },
      "custom": {
        "support": {
          "title": "Un problème ? Contacte-nous !",
          "body": "Notre équipe est là pour t’aider rapidement."
        }
      }
    },
    "lateLoan": "Est-ce que l’objet a été retourné ?",
    "lateLoanService": "Service rendu ?",
    "lateLoanDonation": "Don ramassé ?",
    "lateLoanSale": "Vente complétée ?",
    "newListingPostedSubscribed": "<strong>{{userName}}</strong> ({{distance}}) a publié une offre pour un objet qui pourrait t’intéresser : {{itemName}}",
    "newReferralSubscribed": {
      "numLeftMessage": "Il te reste {{numLeft}} inscriptions pour gagner un abonnement annuel gratuit !",
      "receivedPrizeMessage": "Bravo ! 🥳 Tu viens de gagner un abonnement annuel gratuit au Partage Club !",
      "receivedMonthPrizeMessage": "Bravo ! 🥳 Tu viens de gagner un mois gratuit au Partage Club !",
      "referredUserRegisteredMessage": "Tu as invité {{numInvited}} personnes.\nPlus tu invites, plus tu contribues à faire grandir cette chaîne de générosité !",
      "title": "{{firstName}} s'est inscrit.e avec ton code d'invitation"
    },
    "onTime": "Retour prévu aujourd'hui",
    "onTimeService": "Service prévu aujourd'hui",
    "onTimeDonation": "Don ramassé aujourd'hui",
    "onTimeSale": "Vente prévue aujourd'hui",
    "superChanged": {
      "initialGained": {
        "title": "Félicitations !",
        "body": "Tu es maintenant Super Partageur.euse."
      },
      "initialLost": {
        "title": "Tu as perdu ton badge de Super Partageur.euse 😢",
        "body": "Consulte les nouveaux critères pour le récupérer."
      },
      "initialKept": {
        "title": "Félicitations !",
        "body": "Tu conserves ton badge de Super Partageur.euse, même avec les nouveaux critères."
      },
      "gained": {
        "title": "Félicitations !",
        "body": "Tu es maintenant Super Partageur.euse."
      },
      "lost": {
        "title": "Tu as perdu ton badge de Super Partageur.euse 😢",
        "body": "Découvre comment le regagner en un rien de temps."
      }
    },
    "rate": {
      "borrower": {
        "message": "Ton avis est important pour nous et pour les autres membres du Partage Club.",
        "title": "Comment s'est passé ton expérience avec {{lenderName}} ?"
      },
      "lender": {
        "message": "Ton avis est important pour nous et pour les autres membres du Partage Club.",
        "title": "Comment s'est passé ton expérience avec {{borrowerName}} ?"
      }
    },
    "ratingReceived": {
      "cta": "Voir mes évaluations"
    },
    "trustAdded": {
      "title": "Nouvelle recommandation",
      "message": "Un membre t’a recommandé·e."
    },
    "savedMoney": {
      "title": {
        "borrower": "Tu as économisé !",
        "lender": "Tu as fait économiser !"
      },
      "message": {
        "borrower": "Tu as économisé <strong>{{amount}} $</strong> en empruntant {{item}}.",
        "lender": "Tu as aidé un membre à économiser <strong>{{amount}} $</strong> en prêtant {{item}}."
      }
    },
    "savedMoneyService": {
      "title": {
        "borrower": "Tu as économisé !",
        "lender": "Tu as fait économiser !"
      },
      "message": {
        "borrower": "Tu as économisé <strong>{{amount}} $</strong> en demandant de l'aide pour {{item}}.",
        "lender": "Tu as aidé un membre à économiser <strong>{{amount}} $</strong> en offrant de l'aide pour {{item}}."
      }
    },
    "savedMoneyDonation": {
      "title": {
        "borrower": "Tu as économisé !",
        "lender": "Tu as fait économiser !"
      },
      "message": {
        "borrower": "Tu as économisé <strong>{{amount}} $</strong> en recevant un don pour {{item}}.",
        "lender": "Tu as aidé un membre à économiser <strong>{{amount}} $</strong> en lui offrant {{item}}."
      }
    },
    "loanReciprocity": {
      "title": "À ton tour d’aider 🤝",
      "message": "Publie les objets que tu utilises peu et fais-en profiter tes voisin·es."
    },
    "tabBarLabel": "Notifications",
    "closeButtonAccessibilityLabel": "Fermer les notifications",
    "welcome": "Bienvenue au Partage Club!",
    "welcomeMessage": "Merci de nous faire confiance!",
    "trustAdded": {
      "title": "{{name}} te fait confiance ! 🎉",
      "message": "Cette personne t’a ajouté(e) à son club de confiance. Et si tu faisais pareil ?",
      "add": "Ajouter au club de confiance",
      "decline": "Non merci",
      "viewProfile": "Voir le profil du membre"
    }
  },
  "notifications-setting": {
    "title": "Notifications",
    "chatTitle": "Messages",
    "chatHelp": "Reçois une notification lorsqu'un membre t’envoie un message privé, par exemple, pour t’emprunter un objet.",
    "conciergerieTitle": "Assistant Intelligent",
    "conciergerieHelp": "Permets à l'assistant intelligent de te contacter lorsque tes objets peuvent répondre au besoin d’un membre.",
    "conciergerieToggle": "Autoriser les contacts de l'assistant intelligent",
    "needTitle": "Besoins",
    "needHelp": "Reçois une notification lorsque des membres publient de nouveaux besoins, afin de voir si tu peux y répondre.",
    "weeklyOffersTitle": "Nouveautés à emprunter",
    "weeklyOffersHelp": "Reçois une notification, à chaque semaine, qui liste les nouvelles offres disponibles près de toi.",
    "urgentOffersTitle": "Offres urgentes",
    "urgentOffersHelp": "Reçois une notification lorsque des membres publient de nouvelles offres pour des matières périssables sous peu.",
    "interestAlertsTitle": "Alertes sur mes intérêts",
    "interestAlertsHelp": "Reçois une notification quand une nouvelle offre est publiée dans une catégorie que tu suis.",
    "pushNotif": "Notifications poussées (push)",
    "email": "Courriels",
    "sms": "SMS"
  },
  "offerAvailability": {
    "conflictWhen": "Réservé le <strong>{{dates}}</strong>",
    "conflictsTitle": "Conflit de réservation",
    "conflictsInformationText": "Certains objets sont <strong>déjà prêtés</strong> pour ces dates. Tu peux continuer la réservation, mais contacte l'emprunteur ensuite pour résoudre ce(s) conflit(s).",
    "informationText": "Réserve tes objets pour les rendre indisponibles à l'emprunt pendant les jours sélectionnés.",
    "informationTextDonation": "Tu peux choisir une date limite pour indiquer que tu aimerais que le ramassage soit effectué avant cette date.",
    "refrainPopup": {
      "hi": "Cher festival,",
      "text": {
        "lender": {
          "before": "N’oublie pas de réserver tes dates de festival et de planifier tes journées de montage et démontage lors de ta réservation.",
          "after": "N’oublie pas de réserver tes dates de festival et de planifier tes journées de montage et démontage."
        },
        "borrower": "N’oublie pas de planifier tes journées de montage et démontage lors de ton emprunt."
      },
      "subtext": {
        "lender": {
          "before": "Réserve le nombre de jours complets où le ou les objets ne seront pas disponibles.",
          "after": "Réserve le nombre de jours complets où l’objet n’est pas disponible."
        },
        "borrower": "Propose le nombre de jours complets où l’objet sera emprunté."
      },
      "continue": "Compris",
      "reserveDates": "Réserver les dates",
      "later": "Plus tard"
    },
    "saveButton": "Enregistrer",
    "title": "Réservations de l'offre",
    "titleMany": "Réservations pour {{count}} offres",
    "titleDonation": "Date limite",
    "titleSell": "Date de la vente"
  },
  "offers": {
    "empty": {
      "firstLine": "Toutes les offres que tu publieras au sein de la communauté se retrouveront ici.",
      "primaryButtonText": "Publier une offre",
      "secondLine": "Tu n'as pas encore publié d'offre."
    },
    "title": "Mes annonces"
  },
  "onboarding": {
    "confirm": "Confirmer",
    "nextStep": "Continuer"
  },
  "onboardingIntro": {
    "title": "Prêt à partager ?",
    "text": "Crée ton compte (c’est rapide, promis !) et commence à partager avec ta communauté."
  },
  "one-channel": {
    "add": "Ajouter",
    "loadingMessages": "Chargement des messages...",
    "supportReplyPreparing": "Une réponse est en cours de préparation...",
    "dismissConversation": "Fermer la conversation",
    "messageDateSeparator": {
      "todayAt": "Aujourd'hui à {{time}}",
      "yesterdayAt": "Hier à {{time}}",
      "dateAt": "{{date}} à {{time}}"
    },
    "minimizeConversation": "Réduire la conversation",
    "noChannelSelected": "Aucune conversation sélectionnée",
    "titleUser": "Conversation avec {{user}}",
    "titleListing": "Conversation avec {{user}} - Sujet : {{listing}}",
    "addToCalendar": {
      "event": {
        "buyItem": "Achat de {{item}} auprès de {{name}}",
        "donateItem": "Don de {{item}} à {{name}}",
        "receiveDonation": "Don de {{item}} par {{name}}",
        "giveService": "Service à rendre à {{name}} : {{item}}",
        "receiveService": "Service à recevoir de {{name}} : {{item}}",
        "sellItem": "Vente de {{item}} à {{name}}",
        "borrowObject": {
          "start": "Début de l'emprunt à {{name}} pour {{item}}",
          "end": "Retour de l'emprunt à {{name}} pour {{item}}"
        },
        "lendObject": {
          "start": "Début du prêt à {{name}} pour {{item}}",
          "end": "Retour du prêt à {{name}} pour {{item}}"
        }
      },
      "modal": {
        "always": "Oui, pour tous les prêts",
        "description": "Souhaites-tu ajouter ces dates dans le calendrier de ton téléphone ?",
        "discard": "Non, pas cette fois-ci",
        "never": "Non, jamais",
        "once": "Oui, une fois seulement",
        "title": "Ajouter au calendrier"
      }
    },
    "beaconsfieldNewLoanWarning": "Bonjour {{name}},\n\nÀ Beaconsfield, le partage se fait dans le respect, la confiance… et la bonne humeur !\nQuelques conseils pour une expérience agréable et sécuritaire :\n- Rencontre l'autre personne dans un lieu public si ça te rassure (ex. : Bibliothèque, Hôtel de Ville).\n- Partage uniquement les renseignements essentiels pour rendre possible le partage (ex. : numéro de téléphone, adresse).\n\nBon partage !\n\nEt surtout, profite-en pour tisser des liens, à ton rythme.",
    "firstLoanPrompt": {
      "title": "Bravo pour ton premier emprunt !",
      "savedAmount": "Bravo, c’est <highlight>{{amount}}</highlight> d’économisé !",
      "description": "Le premier emprunt est offert !",
      "subscribeTitle": "Pour continuer d’emprunter",
      "subscribeDescription": "Pour continuer d’emprunter sans limite, abonne-toi maintenant et bénéficie d’un <strong>rabais de 25 % !</strong>",
      "subscribeDescriptionWithDeadline": "Abonne-toi et bénéficie <strong>d’un rabais de 25 % jusqu’au {{date}} !</strong>",
      "cta": "Passer à",
      "discountDeadlineNote": "Valide jusqu’au {{date}}.",
      "note": "Si la réservation est annulée, ton emprunt gratuit sera de nouveau disponible",
      "lending": {
        "title": "Bravo pour ton premier prêt !",
        "description": "Profite du dédommagement sur les objets",
        "subscribeDescription": "Abonne-toi maintenant et bénéficie d’un <strong>rabais de 25 % !</strong>"
      }
    },
    "banner": {
      "listingDeleted": "Annonce supprimée",
      "oneDate": "Proposer une date",
      "donationDate": "Proposer une date de ramassage",
      "saleDate": "Proposer une date de ramassage",
      "twoDatesLender": "Proposer des dates",
      "twoDatesBorrower": "Voir les disponibilités",
      "borrowerCreditExhausted": "Ce membre est en essai gratuit et ne peut plus emprunter.",
      "manageLoan": {
        "lender": "Gérer le prêt",
        "borrower": "Gérer l'emprunt"
      },
      "manageSale": {
        "lender": "Gérer la vente",
        "borrower": "Gérer la vente"
      },
      "manageParticipations": {
        "lender": "Gérer l'inscription",
        "borrower": "Gérer la demande de service"
      },
      "manageService": {
        "lender": "Gérer le service",
        "borrower": "Gérer la demande de service"
      },
      "manageDonation": {
        "lender": "Gérer le don",
        "borrower": "Gérer le don"
      },
      "memberNeed": "Besoin d'un membre",
      "memberOffer": "Offre d'un membre",
      "unavailable": {
        "lender": {
          "offer": "Déjà prêté",
          "request": "Déjà trouvé"
        },
        "borrower": {
          "offer": "Déjà emprunté",
          "request": "Déjà trouvé"
        }
      },
      "viewListing": "Voir l'annonce",
      "yourNeed": "Ce membre peut t'aider",
      "yourOffer": "Ton offre"
    },
    "levelModal": {
      "primaryButtonText": "Voir mon impact",
      "secondaryButtonText": "Fermer",
      "sharer1": {
        "message": "Tu as augmenté ton impact en réalisant ton premier prêt ! Tu accèdes maintenant à un niveau supérieur : <strong>Partageur</strong>.",
        "title": "Bravo !"
      },
      "sharer23": {
        "message": "Tu es à <strong>{{numLeft}}</strong> partages du niveau ultime. Continue un prêt à la fois !",
        "title": "Bravo !"
      },
      "sharer4": {
        "message": "<strong>Un</strong> partage de plus et tu accéderas au plus haut niveau : <strong>Super Partageur.euse</strong>.",
        "title": "Tu y es presque !"
      },
      "superSharer": {
        "message": "Tu as augmenté ton impact en réalisant 5 partages ! Tu accèdes maintenant au niveau ultime : <strong>Super Partageur.euse</strong> et deviens un exemple à suivre au Partage Club.\n\nBravo! À chaque partage, tu fais grandir ton impact pour un avenir plus vert.",
        "title": "Tu es un.e Super Partageur.euse !"
      }
    },
    "loanManagement": {
      "cta": {
        "late": "Confirmer le retour",
        "returned": "Confirmer le retour"
      },
      "body": {
        "late": {
          "lender": "La période d'emprunt est dépassée. Tu peux contacter {{name}} afin d'organiser un moment pour qu'il.elle te retourne l'objet. Lorsque tu auras récupéré l'objet, utilise le bouton ci-bas.",
          "borrower": "La période d'emprunt est dépassée. Tu peux contacter {{name}} afin d'organiser un moment pour retourner l'objet dès que possible. Lorsque tu auras rendu l'objet, utilise le bouton ci-bas."
        },
        "returned": {
          "lender": "{{name}} a indiqué avoir retourné l’objet. Peux-tu confirmer cela ?",
          "borrower": "En attente de confirmation de {{name}}."
        }
      },
      "title": {
        "scheduled": "Prêt planifié",
        "late": "Ce prêt est en retard",
        "returned": {
          "lender": "L'objet a été retourné ?",
          "borrower": "Tu as retourné cet objet"
        },
        "past": "Ce prêt est maintenant terminé"
      },
      "status": "Statut"
    },
    "saleManagement": {
      "cta": {
        "ongoing": {
          "borrower": "Confirmer la réception",
          "lender": "Confirmer la vente"
        },
        "late": {
          "borrower": "Confirmer la réception",
          "lender": "Confirmer la vente"
        },
        "returned": {
          "lender": "Confirmer la vente"
        }
      },
      "body": {
        "ongoing": {
          "borrower": "La date prévue pour la vente est arrivée. Une fois l’objet reçu de {{name}}, confirme la réception avec le bouton ci-dessous.",
          "lender": "La date prévue pour la vente est arrivée. Une fois l’objet remis à {{name}}, confirme la vente avec le bouton ci-dessous."
        },
        "late": {
          "borrower": "La date prévue pour la vente est passée. Tu peux contacter {{name}} pour organiser la récupération. Une fois l’objet reçu, confirme la réception avec le bouton ci-dessous.",
          "lender": "La date prévue pour la vente est passée. Tu peux contacter {{name}} pour organiser la récupération. Une fois l’objet remis, confirme la vente avec le bouton ci-dessous."
        },
        "returned": {
          "borrower": "Tu as confirmé avoir reçu l’objet. En attente de la confirmation de {{name}}.",
          "lender": "{{name}} a confirmé avoir reçu l’objet. Confirme la vente pour la terminer."
        }
      },
      "title": {
        "scheduled": "Vente planifiée",
        "ongoing": "La vente est prévue aujourd’hui",
        "late": "Cette vente est en retard",
        "returned": {
          "borrower": "Réception confirmée",
          "lender": "L’objet a été reçu"
        },
        "past": "Cette vente est terminée"
      },
      "status": "Statut"
    },
    "serviceManagement": {
      "cta": {
        "late": "Confirmer service rendu",
        "returned": "Confirmer service rendu"
      },
      "body": {
        "late": {
          "lender": "La période prévue pour le service est dépassée. Tu peux contacter {{name}} pour organiser un nouveau moment afin de le réaliser. Une fois le service rendu, utilise le bouton ci-dessous.",
          "borrower": "La période prévue pour le service est dépassée. Tu peux contacter {{name}} afin d’organiser un nouveau moment dès que possible. Une fois le service complété, utilise le bouton ci-dessous."
        },
        "returned": {
          "lender": "{{name}} a indiqué que le service a été rendu. Peux-tu confirmer ?",
          "borrower": "En attente de confirmation de {{name}}."
        }
      },
      "title": {
        "late": "Ce service est en retard",
        "returned": {
          "lender": "Est-ce que le service a été rendu?",
          "borrower": "Tu as reçu ce service"
        },
        "past": "Le service a été rendu avec succès"
      },
      "status": "Statut"
    },
    "donationManagement": {
      "cta": {
        "late": "Confirmer le don",
        "returned": "Confirmer le don"
      },
      "body": {
        "late": {
          "lender": "La date prévue pour le ramassage du don est passée. Tu peux contacter {{name}} pour organiser un nouveau moment afin de le réaliser. Une fois le ramassage effectué, utilise le bouton ci-dessous.",
          "borrower": "La date prévue pour le ramassage du don est passée. Tu peux contacter {{name}} pour organiser un nouveau moment afin de le réaliser. Une fois le ramassage effectué, utilise le bouton ci-dessous."
        },
        "returned": {
          "lender": "{{name}} a indiqué que le don a été ramassé. Peux-tu confirmer ?",
          "borrower": "En attente de confirmation de {{name}}."
        }
      },
      "title": {
        "late": "Ce ramassage est en retard",
        "returned": {
          "lender": "Est-ce que le ramassage a été effectué?",
          "borrower": "Tu as ramassé le don"
        },
        "past": "Le don a été ramassé avec succès"
      },
      "status": "Statut"
    },
    "loanMessage": {
      "cancel": "Annuler",
      "edit": "Modifier",
      "accept": "Accepter",
      "contentAccepted": "La réservation de l'objet a été confirmée.",
      "contentAsBorrower": "Le prêteur doit confirmer pour que l’objet soit réservé.",
      "contentAsLender": "L’emprunteur doit confirmer pour que l’objet soit réservé.",
      "contentCompleted": "Ce prêt est maintenant terminé.",
      "contentPending": "La proposition de dates doit être acceptée afin que l’objet soit réservé.",
      "contentPendingIsUpdate": "Les dates de prêt ont été modifiées. Acceptez afin de confirmer ces nouvelles dates.",
      "contentRejected": "La réservation de l'objet a été annulée.",
      "endDatePassed": "La date proposée de fin du prêt est passée.",
      "flexibleDates": "(flexibles)",
      "loanStatusAsBorrower": "Statut de l'emprunt",
      "loanStatusAsLender": "Statut du prêt",
      "period": "Période",
      "date": "Date",
      "reject": "Refuser",
      "startDatePassed": "La date proposée de début du prêt est passée.",
      "status": {
        "accepted": "Accepté",
        "completed": "Terminé",
        "pending": "En attente",
        "rejected": "Annulé",
        "returned": "Retourné"
      },
      "to": "au"
    },
    "serviceMessage": {
      "contentAccepted": "La réservation du service est confirmée.",
      "contentAsBorrower": "Le membre doit confirmer pour que le service soit réservé.",
      "contentAsLender": "La demande doit être confirmée pour que le service soit réservé.",
      "contentCompleted": "Le service a été rendu.",
      "contentPending": "La proposition de dates doit être acceptée pour que le service soit réservé.",
      "contentPendingIsUpdate": "Les dates du service ont été modifiées. Acceptez pour confirmer ces nouvelles dates.",
      "contentRejected": "La demande de service a été refusée.",
      "loanStatusAsBorrower": "Statut",
      "loanStatusAsLender": "Statut",
      "startDatePassed": "La date proposée pour le début du service est passée.",
      "status": {
        "accepted": "Accepté",
        "completed": "Rendu",
        "pending": "En attente",
        "rejected": "Refusé",
        "returned": "Rendu"
      }
    },
    "donationMessage": {
      "contentAccepted": "La date de ramassage du don a été confirmée.",
      "contentAsBorrower": "La date de ramassage proposée est en attente de confirmation.",
      "contentAsLender": "La date de ramassage proposée est en attente de confirmation.",
      "contentCompleted": "Le don a été ramassé.",
      "contentPending": "La proposition de date doit être acceptée pour que le ramassage ait lieu.",
      "contentPendingIsUpdate": "La date du ramassage a été modifiée. Accepte pour confirmer cette nouvelle date.",
      "contentRejected": "La proposition de date a été refusée.",
      "loanStatusAsBorrower": "Statut",
      "loanStatusAsLender": "Statut",
      "startDatePassed": "La date proposée pour le ramassage est passée.",
      "status": {
        "accepted": "Accepté",
        "completed": "Ramassé",
        "pending": "En attente",
        "rejected": "Refusé",
        "returned": "Ramassé"
      }
    },
    "sellMessage": {
      "contentAccepted": "La date de ramassage a été confirmée.",
      "contentAsBorrower": "La date de ramassage proposée est en attente de ta confirmation.",
      "contentAsLender": "La date de ramassage proposée est en attente de confirmation de l'acheteur·euse.",
      "contentCompleted": "L'article a été remis à l'acheteur·euse.",
      "contentPending": "La proposition de date doit être acceptée pour que le ramassage ait lieu.",
      "contentPendingIsUpdate": "La date du ramassage a été modifiée. Accepte pour confirmer cette nouvelle date.",
      "contentRejected": "La proposition de date a été refusée.",
      "loanStatusAsBorrower": "Statut",
      "loanStatusAsLender": "Statut",
      "startDatePassed": "La date proposée pour le ramassage est passée.",
      "status": {
        "accepted": "Accepté",
        "completed": "Remis",
        "pending": "En attente",
        "rejected": "Refusé",
        "returned": "Remis"
      }
    },
    "participationsMessage": {
      "contentAccepted": "L'inscription a été confirmée.",
      "contentAsBorrower": "",
      "contentAsLender": "",
      "contentCompleted": "Le service a été rendu.",
      "contentPending": "",
      "contentPendingIsUpdate": "",
      "contentRejected": "L'inscription a été annulée.",
      "loanStatusAsBorrower": "Statut",
      "loanStatusAsLender": "Statut",
      "startDatePassed": "La date de l'événement est passée.",
      "status": {
        "accepted": "Accepté",
        "completed": "Passé",
        "pending": "En attente",
        "rejected": "Annulé",
        "returned": "Passé"
      }
    },
    "message_was_read": "Lu par {{name}}",
    "notifNowInsured": "<strong>Sois sans crainte et partage !\n\nPartage Club peut te dédommager jusqu'à 300 $</strong> en cas de problème sur des articles prêtés, d'une valeur de 25 $ et plus.\n\nS’il arrive quoi que ce soit, tu peux nous contacter ici, ou bien par courriel à <strong>info@partage.club</strong>",
    "promptIntroduceYourself": "Écris un petit mot au membre pour te présenter et exprimer ton intérêt.",
    "quickOffer": {
      "text": "Publie en 10 secondes !",
      "title": "Publication rapide"
    },
    "membersCount_one": "{{count}} membre",
    "membersCount": "{{count}} membres",
    "membersTitle": "Membres",
    "admin": "Admin",
    "isYou": "Toi",
    "memberMenu": {
      "makeAdmin": "Désigner comme admin",
      "makeRegular": "Retirer les droits d'administrateur",
      "seeProfile": "Voir le profil",
      "remove": "Retirer de la discussion",
      "report": "Signaler le membre",
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "makeAdminModal": {
        "title": "Ajouter comme administrateur",
        "body": "Es-tu sûr de vouloir ajouter {{name}} comme administrateur de cette discussion ?"
      },
      "makeRegularModal": {
        "title": "Retirer les droits d'administrateur",
        "body": "Es-tu sûr de vouloir retirer les droits d'administrateur de {{name}} pour cette discussion ?"
      },
      "removeModal": {
        "title": "Retirer de la discussion",
        "body": "Es-tu sûr de vouloir retirer {{name}} de cette discussion ?"
      },
      "reportModal": {
        "title": "Signaler le membre",
        "body": "Es-tu sûr de vouloir signaler {{name}} ?"
      }
    },
    "muteConversation": "Mettre en sourdine",
    "linkOffer": "Lier une offre",
    "linkedOffer": "Offre liée",
    "linkOfferModal": {
      "title": "Lier une offre",
      "description": "Choisis une de tes offres pour utiliser son calendrier de disponibilités dans cette conversation.",
      "empty": "Tu n'as pas d'offre active à lier."
    },
    "linkOfferInline": {
      "title": "Lier une offre",
      "description": "Choisis l'une de tes offres liées à « {{itemName}} », puis confirme pour utiliser son calendrier de disponibilités dans cette conversation.",
      "loading": "Recherche de tes offres...",
      "empty": "Aucune offre correspondante trouvée pour cette recherche.",
      "confirm": "Lier cette offre",
      "confirmSelected": "Lier cette offre"
    },
    "seeListing": "Voir l'annonce",
    "transportListing": {
      "date": "Date",
      "departure": "Départ",
      "destination": "Destination",
      "notAvailable": "N/A",
      "view": "Voir"
    },
    "silenceDurationPrompt": "Pendant combien de temps veux-tu mettre cette conversation en sourdine ?",
    "silenceFor1Minute": "Pendant 1 minute",
    "silenceFor15Minutes": "Pendant 15 minutes",
    "silenceFor1Hour": "Pendant 1 heure",
    "silenceFor8Hours": "Pendant 8 heures",
    "silenceFor24Hours": "Pendant 24 heures",
    "silenceFor48Hours": "Pendant 48 heures",
    "silenceFor1Week": "Pendant 1 semaine",
    "silenceUntilChanged": "Jusqu'à ce que je le change",
    "silenceNotifications": "Mettre en sourdine les notifications",
    "toolbar": {
      "defaultValue": "Bonjour {{name}} ! ",
      "openCamera": "Ouvrir la caméra",
      "openLibrary": "Ouvrir la photothèque",
      "placeHolder": "Ton message...",
      "sendLike": "Envoyer un pouce levé",
      "sendMessage": "Envoyer le message"
    },
    "unmuteConversation": "Réactiver les notifications",
    "viewMembers": "Voir les membres",
    "conciergeMessage": {
      "canHelp": {
        "title": "Super ! Tu peux aider {{interlocutorName}} :",
        "proposeDates": "• Propose des dates de prêt",
        "sendMessage": "• Envoie-lui un message pour discuter des détails",
        "lastMessageText": "Tu veux aider {{interlocutorName}} avec ce besoin"
      },
      "canYouHelp": {
        "title": "Penses-tu pouvoir l'aider ?",
        "subtitle": "Si non, j'archiverai la conversation pour toi",
        "buttonNo": "Non",
        "buttonYes": "Oui",
        "whyDidIReceiveThisMessage": "Pourquoi ai-je reçu ce message ?",
        "bottomSheet": {
          "title": "Assistant intelligent",
          "paragraph1": "Tu as reçu ce message parce que l’assistant intelligent pense que tu pourrais avoir l’objet demandé par ce membre.",
          "paragraph2": "Tant que tu ne réponds pas “oui”, la conversation reste invisible pour l’emprunteur, alors sens-toi à l’aise de décliner !",
          "paragraph3": {
            "beforeBold": "Pour ne plus recevoir ces messages, ",
            "bold": "désactive l’option dans tes préférences",
            "afterBold": "."
          },
          "cta": "Modifier mes préférences →"
        },
        "lastMessageText": "Peux-tu aider {{interlocutorName}} avec ce besoin ?"
      },
      "matchAccepted": {
        "title": "Quelle chance ! {{interlocutorName}} souhaite t'aider",
        "proposeDates": "• Propose des dates de prêt",
        "sendMessage": "• Envoie-lui un message pour discuter des détails",
        "lastMessageText": "{{interlocutorName}} a accepté de t'aider !"
      },
      "cantHelp": {
        "title": "Pas de souci !",
        "subtitle": "N'hésite pas à contacter {{interlocutorName}} si tu changes d'avis",
        "lastMessageText": "Tu ne peux pas aider {{interlocutorName}} avec ce besoin"
      },
      "resolved": {
        "title": "Bonne nouvelle !",
        "subtitle": "{{interlocutorName}} a trouvé ce dont il avait besoin",
        "lastMessageText": "{{interlocutorName}} a trouvé ce dont il avait besoin"
      }
    },
    "archivedConvoToast": {
      "title": "Conversation archivée",
      "message": "Tu peux la retrouver dans la section Conversations archivées."
    },
    "visibleOnlyToYou": "Visible seulement par toi",
    "transportPrompt": {
      "title": "As-tu besoin d’aide pour le transport ?",
      "description": "Tu peux contacter le service d’aide pour le transport afin d’organiser la récupération.",
      "cta": "Écrire au service d’aide"
    },
    "postSaleListingPrompt": {
      "title": "Que veux-tu faire avec ton annonce ?",
      "description": "En reste-t-il encore à vendre ? Penses-tu en avoir de nouveau plus tard ?",
      "keep": "Ne rien faire",
      "hide": "Masquer",
      "delete": "Supprimer"
    },
    "loanReciprocityPrompt": {
      "title": "À ton tour d’aider 🤝",
      "description": "La communauté te permet d’emprunter plutôt que d’acheter. Publie plusieurs objets que tu utilises peu pour aider à ton tour.",
      "publish": "Publier mes objets",
      "later": "Plus tard"
    },
    "bonification": {
      "borrowerPrompt": {
        "title": "🌟 Fais briller cet objet !",
        "text": "Cet objet mériterait une vraie photo ou une meilleure description. Propose une amélioration !",
        "cta": "Proposer une amélioration"
      },
      "borrowerSubmitted": {
        "title": {
          "reviewing": "✨ Bien joué !",
          "accepted": "🎉 Suggestion acceptée !",
          "rejected": "✏️ Suggestion refusée"
        },
        "text": {
          "reviewing": "Tes suggestions ont été envoyées au prêteur pour évaluation.",
          "accepted": "Le prêteur a accepté tes suggestions. Merci pour ton aide !",
          "rejected": "Le prêteur a refusé tes suggestions. Merci d'avoir pris le temps de proposer des améliorations pour cette annonce."
        }
      },
      "lenderNudge": {
        "title": {
          "lend": "Quelqu'un veut emprunter ton objet 👋",
          "sell": "Quelqu'un veut acheter ton objet 👋",
          "give": "Quelqu'un veut recevoir ton objet 👋"
        },
        "text": "Pour que l'échange se passe encore mieux, ajoute une vraie photo et une courte description. Ça inspire confiance et rend ton objet plus attrayant!",
        "cta": "Compléter la fiche de l'objet"
      },
      "lenderReview": {
        "title": "📩 Nouvelle suggestion reçue",
        "text1": "<strong>{{name}}</strong> a proposé des améliorations pour ton objet.",
        "text2": "👉 Tu peux l'examiner et décider de l'accepter, la refuser, ou la modifier",
        "ctaView": "Voir la suggestion",
        "ctaReject": "Refuser"
      },
      "lenderReviewed": {
        "title": {
          "accepted": "🎉 Suggestion acceptée !",
          "rejected": "✏️ Suggestion refusée",
          "modified": "🎉 Modifications appliquées !"
        },
        "text": {
          "accepted": "Yahoo! Tu viens de compléter la fiche de ton objet.",
          "rejected": "Tu as refusé les modifications suggérées pour cette annonce. Tu peux améliorer la fiche de ton objet par toi-même en allant dans tes offres.",
          "modified": "Les modifications suggérées ont été appliquées à l'annonce."
        }
      }
    },
    "bonificationScreen": {
      "title": "Proposer des améliorations",
      "suggestionBadge": "Suggestion",
      "borrower": {
        "bannerTitle": "✏️ Tu es en mode suggestion",
        "bannerText": "La photo et la description que tu proposes seront envoyées au prêteur pour être approuvées.",
        "addPhoto": "Ajouter une photo",
        "titleLabel": "Titre",
        "descriptionLabel": "Description",
        "submit": "Proposer les modifications"
      },
      "lender": {
        "bannerTitle": "✏️ Tu consultes une suggestion",
        "bannerText": "Voici la photo et/ou la description proposée par l'emprunteur. Tu peux l'accepter, la modifier ou la refuser.",
        "banner": "Tu consultes une suggestion d'un emprunteur.",
        "photoLabel": "Photo de profil",
        "titleLabel": "Nom de l'objet",
        "descriptionLabel": "Description",
        "currentValue": "Actuel : {{value}}",
        "accept": "Accepter les suggestions",
        "acceptModified": "Accepter les modifications",
        "modify": "Mettre à jour",
        "reject": "Refuser",
        "cancel": "Annuler",
        "rejectConfirm": {
          "title": "Refuser les suggestions ?",
          "text": "Es-tu certain de vouloir refuser ces suggestions ?",
          "cancel": "Annuler",
          "confirm": "Refuser"
        }
      },
      "summary": {
        "title": {
          "pending": "Suggestions en attente",
          "reviewing": "Suggestions envoyées",
          "accepted": "Suggestions acceptées",
          "rejected": "Suggestions refusées"
        },
        "text": {
          "pending": "Ces suggestions sont en attente d'évaluation par le prêteur.",
          "reviewing": "Ces suggestions ont été envoyées au prêteur pour revue.",
          "accepted": "Ces suggestions ont été acceptées et appliquées à l'annonce.",
          "rejected": "Ces suggestions ont été refusées."
        }
      }
    },
    "replyingTo": "En réponse à {{name}}",
    "editing": "Modification",
    "edited": "Modifié",
    "deletedMessage": {
      "author": "Tu as supprimé ce message",
      "other": "Ce message a été supprimé"
    },
    "menu": {
      "reply": "Répondre",
      "copy": "Copier",
      "edit": "Modifier",
      "delete": "Supprimer",
      "messageActions": "Actions du message",
      "photo": "📷 Photo"
    },
    "automaticMessageLabel": "Message automatisé",
    "helpButton": "Comment ça marche",
    "howItWorks": {
      "title": "Comment ça marche ?",
      "screenTitle": {
        "borrow": "Emprunter",
        "lend": "Prêter"
      },
      "assistanceQuestion": "Tu as besoin d'une assistance supplémentaire?",
      "visitHelpCenter": "Visiter le centre d'aide",
      "borrow": {
        "step1": "<bold>Écris un mot</bold> pour te présenter et <bold>exprimer ton intérêt</bold>",
        "step2": "<bold>Propose</bold> des dates d'emprunt, <bold>attends la confirmation</bold> de ton·ta voisin·e puis <bold>planifiez le ramassage</bold> ensemble",
        "step3": "<bold>Récupère l'objet</bold> chez ton·ta voisin·e ou dans un lieu public sécuritaire. <bold>Aucun échange d'argent, c'est gratuit !</bold>",
        "step4": "<bold>Rends-le</bold> en bon état et partage ton expérience"
      },
      "lend": {
        "step1": "<bold>Réponds au message</bold> pour faire connaissance et <bold>discuter des détails</bold>",
        "step2": "<bold>Accepte ou propose</bold> des dates de prêt et <bold>planifiez le ramassage</bold> ensemble",
        "step3": "<bold>Prête l'objet</bold> à ton·ta voisin·e. <bold>Aucun échange d'argent, c'est gratuit !</bold>",
        "step4": "<bold>Récupère ton objet</bold> en bon état et partage ton expérience"
      }
    },
    "groupCreatedByYou": "Tu as créé la discussion",
    "addMembers": "Ajouter des membres",
    "seeProfile": "Voir le profil",
    "seeMembers": "Voir les membres",
    "leaveConversation": "Quitter la discussion",
    "renameConversation": "Renommer la discussion",
    "deleteConversation": "Supprimer la discussion",
    "confirmLeaveTitle": "Quitter la discussion",
    "confirmLeave": "Es-tu sûr de vouloir quitter cette discussion ?",
    "confirmDeleteTitle": "Supprimer la discussion",
    "confirmDelete": "Es-tu sûr de vouloir supprimer cette discussion ? Cette action est irréversible.",
    "renameTitle": "Renommer la discussion",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "changeLinkedOffer": "Changer l’offre liée",
    "unlinkOffer": "Délier l’offre"
  },
  "recommendations": {
    "one-to-many-similar-listings": {
      "title": {
        "offer": "Offres similaires",
        "request": "Besoins similaires"
      }
    },
    "your-favourites": {
      "title": "Tes favoris",
      "emptyStateButton": "Explorer le catalogue",
      "emptyStateTitle": "Mets ta première offre en favori !",
      "emptyStateText": "Les favoris apparaîtront ici"
    },
    "most-popular": {
      "title": "Les plus partagés"
    },
    "urgent-needs": {
      "title": "Aide tes voisins !"
    },
    "recent-offers": {
      "title": "Nouvelles offres"
    },
    "match-needs-with-offers": {
      "title": "Tu pourrais aider"
    },
    "mixed-recommendations": {
      "title": "Recommandé pour toi"
    },
    "your-interest": {
      "title": "{{tagName}}"
    },
    "by-category": {
      "title": "{{categoryName}}"
    },
    "recent-loans": {
      "title": "Partages récents",
      "and": "et",
      "shared": "ont partagé",
      "timeAgo": "il y a {{time}}"
    },
    "neighbour-offers": {
      "title": "Ses offres"
    },
    "neighbour-requests": {
      "title": "Ses besoins"
    },
    "nearest-sharing-place": {
      "title": "Lieux de partage près de toi"
    }
  },
  "one-listing": {
    "trustCircle": {
      "offerLabel": "Offre de confiance",
      "requestLabel": "Besoin de confiance",
      "offerExplanation": "Tu vois cette offre parce que {{name}} te fait confiance",
      "requestExplanation": "Tu vois ce besoin parce que {{name}} te fait confiance"
    },
    "urgent": "Urgent",
    "availabilitySection": {
      "reservations": {
        "title": "Réservations",
        "text": "Confirmer tes dates"
      },
      "quantity": {
        "fieldPlaceholder": "1",
        "title": "Inventaire",
        "text": "Indiquer la quantité et/ou l'unité"
      },
      "title": "Disponibilité",
      "donation": {
        "reservations": {
          "title": "Date limite",
          "text": "Venir chercher avant le ..."
        },
        "title": "Disponibilité"
      },
      "loan": {
        "reservations": {
          "title": "Réservation",
          "text": "Rendre indisponible pour mon usage"
        }
      }
    },
    "categorySection": {
      "primary": {
        "subtitle": "Sélectionne la catégorie principale de l'objet",
        "title": "Catégorie",
        "placeholder": "Catégories"
      }
    },
    "confirmReturnModal": {
      "primaryButtonText": "Confirmer",
      "secondaryButtonText": "Annuler",
      "text": {
        "borrower": "En confirmant le retour de cet objet, tu signifies que tu l'as rendu à {{name}}.",
        "lender": "En confirmant le retour de cet objet, tu signifies que celui-ci t'a été rendu par {{name}}."
      },
      "title": "Confirmer le retour ?"
    },
    "confirmSaleModal": {
      "primaryButtonText": {
        "borrower": "Confirmer la réception",
        "lender": "Confirmer la vente"
      },
      "secondaryButtonText": "Annuler",
      "text": {
        "borrower": "En confirmant la réception, tu indiques avoir reçu l’objet.",
        "lender": "En confirmant la vente, tu indiques avoir finalisé l’échange."
      },
      "title": {
        "borrower": "Confirmer la réception ?",
        "lender": "Confirmer la vente ?"
      }
    },
    "confirmServiceDoneModal": {
      "primaryButtonText": "Confirmer",
      "secondaryButtonText": "Annuler",
      "text": {
        "borrower": "En confirmant que le service a été rendu, tu indiques que {{name}} t’a bien rendu ce service.",
        "lender": "En confirmant, tu reconnais avoir rendu le service demandé par {{name}}."
      },
      "title": "Service rendu ?"
    },
    "confirmDonationDoneModal": {
      "primaryButtonText": "Confirmer",
      "secondaryButtonText": "Annuler",
      "text": {
        "borrower": "En confirmant que le don a été ramassé, tu indiques que {{name}} t’a bien donné cet objet.",
        "lender": "En confirmant, tu reconnais avoir donné à {{name}} l'objet en question."
      },
      "title": "Don ramassé ?"
    },
    "createOfferModal": {
      "primaryButtonText": "Publier cette offre",
      "secondaryButtonText": "Non, merci",
      "text": "D’autres membres en auront sûrement besoin. Aimerais-tu en faire profiter d’autres membres en publiant une offre ?",
      "title": "Merci d’avoir prêté ton objet"
    },
    "deleteButtonText": "Supprimer",
    "deleteConfirmation": {
      "offer": "Supprimer l'offre",
      "request": "Supprimer le besoin"
    },
    "deleteErrorModal": {
      "primaryButtonText": "Fermer",
      "title": {
        "offer": "L'offre ne peut pas être supprimée",
        "request": "Le besoin ne peut pas être supprimé"
      }
    },
    "hasAcceptedLoan": "a prêté l’objet",
    "hasAcceptedLoanAgo": "a prêté l’objet il y a {{ago}}",
    "beTheFirstToHelpTitle": "Aucune proposition d’aide",
    "beTheFirstToHelp": "Tu peux être la première personne à contacter ce membre.",
    "wantToHelpTitle_one": "{{count}} membre veut aider",
    "wantToHelpTitle_other": "{{count}} membres veulent aider",
    "wantToHelpSubtitle": "Voir les membres qui veulent aider",
    "borrowers": {
      "title_one": "Emprunté {{count}} fois",
      "title_other": "Emprunté {{count}} fois",
      "borrowedAgo": "Il y a {{ago}}",
      "borrowedTimesAgo_one": "Emprunté {{count}} fois · il y a {{ago}}",
      "borrowedTimesAgo_other": "Emprunté {{count}} fois · il y a {{ago}}"
    },
    "currentBorrower": {
      "title": "Actuellement emprunté par",
      "scheduledEnd": "Fin de l’emprunt prévue le {{date}}",
      "viewProfile": "Voir le profil de {{name}}"
    },
    "sections": {
      "about": "À propos",
      "noDescription": "Cette annonce n’a pas encore de description",
      "availabilityAndPickup": "Disponibilité et récupération",
      "owner": "Membre"
    },
    "availability": {
      "availableNow": "Disponible maintenant",
      "borrowedUntil": "Emprunté jusqu’au {{date}}",
      "availableUntil": "Disponible jusqu’au {{date}}",
      "availableIn_one": "Disponible dans {{count}} jour",
      "availableIn_other": "Disponible dans {{count}} jours",
      "currentlyUnavailable": "Indisponible pour le moment",
      "currentlyBorrowed": "Actuellement emprunté",
      "flexibleDates": "Dates flexibles",
      "requestDate": "Recherché pour le {{date}}",
      "requestDateRange": "Recherché du {{start}} au {{end}}"
    },
    "availabilityCalendar": {
      "title": "Quand est-il disponible ?",
      "noUpcomingReservation": "Disponible toute la semaine",
      "currentReservation": "Réservé jusqu’au {{date}}",
      "nextReservation": "Prochaine réservation dès le {{date}}",
      "availableDaysThisWeek_one": "Disponible 1 jour cette semaine",
      "availableDaysThisWeek_other": "Disponible {{count}} jours cette semaine",
      "available": "Disponible",
      "reserved": "Réservé",
      "viewMore": "Calendrier complet",
      "viewLess": "Voir moins",
      "yourDates": "Ta proposition de dates",
      "selectionHint": "Choisis tes dates de début et de fin",
      "selectedRange": "Du {{start}} au {{end}}",
      "proposeDates": "Proposer ces dates",
      "proposalSent": "Ta proposition de dates a été envoyée",
      "dayAvailable": "{{date}} est disponible",
      "dayUnavailable": "{{date}} est déjà réservé"
    },
    "socialProof": {
      "savedBy_one": "Enregistré par {{count}} membre",
      "savedBy_other": "Enregistré par {{count}} membres",
      "views_one": "{{count}} vue",
      "views_other": "{{count}} vues"
    },
    "owner": {
      "member": "Membre",
      "lastActive": "Dernière activité il y a {{ago}}",
      "memberSince": "Membre depuis",
      "loans": "Partages",
      "recommendations": "Recommandations",
      "responseRate": "Taux de réponse",
      "responseTime": "Répond généralement en",
      "trust": "Confiance",
      "ratingCount_one": "{{count}} évaluation",
      "ratingCount_other": "{{count}} évaluations",
      "viewProfile": "Voir le profil complet",
      "openAvatar": "Ouvrir la photo de profil de {{name}}",
      "openProfile": "Ouvrir le profil de {{name}}"
    },
    "headerSection": {
      "address": "Adresse",
      "available": "Disponible",
      "contactButtonText": "Contacter le membre",
      "dateBefore": "Date limite",
      "date": "Date : ",
      "dates": "Dates : ",
      "distance": "Distance",
      "approximatePickupArea_one": "Zone de récupération approximative",
      "approximatePickupArea_other": "Zones de récupération approximatives",
      "approximateLocationHint": "Le cercle montre la zone approximative où cette offre peut être récupérée.",
      "approximateLocationSecurity": "Cette carte ne révèle jamais une adresse exacte. Les détails de récupération restent privés et se coordonnent séparément entre membres.",
      "approximateBorrowerArea_one": "Emplacement approximatif de l'emprunteur",
      "approximateBorrowerArea_other": "Emplacements approximatifs de l'emprunteur",
      "approximateBorrowerLocationHint": "Le cercle montre où l'emprunteur se situe approximativement pour ce besoin.",
      "approximateBorrowerLocationSecurity": "Cette carte ne révèle jamais une adresse exacte. Les détails additionnels restent privés et se coordonnent directement entre membres.",
      "viewMap": "Voir la carte",
      "editButtonText": "Modifier",
      "lessThan": "Moins de {{distance}}",
      "lessThanKm": "Moins de {{distance}} {{unit}}",
      "loanedLater": "Disponible jusqu'au {{date}}",
      "loanedUntil": "Emprunté jusqu'au {{date}}",
      "myRequest": "Mon besoin",
      "neighborRequest": "Besoin d'un.e membre",
      "noDates": "Dates flexibles",
      "flexibleDates": "(flexibles)",
      "postedOn": "Publié le {{date}}",
      "quantity": "<strong>{{num}}</strong> unités",
      "timeBoth": "De <strong>{{start}}</strong> à <strong>{{end}}</strong>",
      "timeStart": "Dès <strong>{{start}}</strong>",
      "timeEnd": "Jusqu'à <strong>{{end}}</strong>",
      "unavailable": "Indisponible",
      "inventory": "Inventaire",
      "price": "Prix",
      "marketValue": "Valeur marchande",
      "sharingFee": "Frais de partage",
      "transactionModeLabel": "Transaction",
      "transactionMode": {
        "offer": {
          "sell": "Vente",
          "lend": "Prêt",
          "give": "Don"
        },
        "request": {
          "sell": "Achat",
          "lend": "Emprunt",
          "give": "Don"
        }
      }
    },
    "loanFee": {
      "title": "Frais de partage : {{amount}}"
    },
    "itemReturnedButtonText": "Confirmer le retour",
    "serviceDoneButtonText": "Confirmer service rendu",
    "donationDoneButtonText": "Confirmer le don",
    "sellDoneButtonText": "Confirmer la vente",
    "participateButtonText": "M'inscrire",
    "unparticipateButtonText": "Me désinscrire",
    "cantParticipateButtonText": "Complet",
    "viewParticipationButtonText": "Gérer mon inscription",
    "viewParticipationsButtonText": "Voir inscriptions",
    "needFoundModal": {
      "step1": {
        "title": "Retirer l'annonce",
        "body": "Marque ton annonce comme trouvée si ton besoin a été comblé.",
        "primaryButtonText": "Marquer comme trouvé"
      },
      "step2": {
        "title": "Marquer comme trouvé",
        "gotoSelectLender": "Le besoin a été comblé sur Partage Club",
        "gotoFoundElsewhere": "Le besoin a été comblé ailleurs",
        "primaryButtonText": "Suivant"
      },
      "step3": {
        "title": "Félicitations pour ton emprunt",
        "body": "Ton annonce a été marquée comme trouvée.",
        "primaryButtonText": "Aller au catalogue",
        "secondaryButtonText": "Voir mon annonce"
      },
      "step4": {
        "title": "Sélectionner le prêteur",
        "body": "Cette étape est importante pour suivre le prêt et les dates de retour.",
        "primaryButtonText": "Suivant"
      },
      "step5": {
        "title": "Sélectionner les dates convenues",
        "body": "Cette étape est importante pour suivre le prêt et les dates de retour.",
        "primaryButtonText": "Terminer"
      },
      "step6": {
        "title": "Félicitations pour ton emprunt",
        "body": "Ton annonce a été marquée comme trouvée, et le prêteur aura reçu une demande de confirmation pour les dates.",
        "primaryButtonText": "Aller au catalogue",
        "secondaryButtonText": "Voir mon annonce"
      }
    },
    "posterSection": {
      "memberSince": "Membre depuis {{date}}",
      "offer": {
        "title": "Membre"
      },
      "primaryButtonText": "Voir le profil",
      "request": {
        "title": "Membre"
      }
    },
    "primaryButtonText": "Enregistrer",
    "primaryButtonTextWithCopies_one": "Enregistrer et créer {{count}} copie",
    "primaryButtonTextWithCopies_other": "Enregistrer et créer {{count}} copies",
    "saveToast": {
      "title": "Modifications enregistrées",
      "text": "L’annonce a été mise à jour.",
      "copies_one": "{{count}} nouvelle offre créée.",
      "copies_other": "{{count}} nouvelles offres créées.",
      "errorTitle": "Impossible d’enregistrer",
      "errorText": "Merci de réessayer."
    },
    "removeButtonText": "Retirer",
    "subscriptionsSection": {
      "title": "Inscriptions",
      "titlePublic": "Inscription",
      "text": "Max. de participants",
      "textPublic": "Pour combien de personnes ?",
      "participants_one": "{{count}} participant confirmé",
      "participants": "{{count}} participants confirmés",
      "participantsFull": "Complet !",
      "participantsLeft_one": "{{count}}/{{max}} place disponible",
      "participantsLeft": "{{count}}/{{max}} places disponibles",
      "participationsSavedToast": {
        "title_one": "Inscription pour {{count}} personne réussie",
        "title": "Inscription pour {{count}} personnes réussie",
        "text": "Pour modifier, changez le nombre ici et cliquez sur Enregistrer."
      },
      "participationsDeletedToast": {
        "title": "Désinscription réussie",
        "text": "Tu peux te réinscrire à tout moment s’il reste de la place."
      }
    },
    "title": {
      "offer": "Offre",
      "request": "Besoin",
      "offerDonation": "Offre (don)",
      "requestDonation": "Besoin (don)"
    },
    "unavailableMessage": "L’annonce peut avoir été supprimée ou n’est plus visible pour le moment.",
    "unavailableTitle": "Cette annonce n’est plus disponible",
    "urlCopied": "L'adresse (URL) à partager a été copiée.",
    "viewsSection": {
      "title": "Portée",
      "views": "Vues",
      "favourites": "Favoris"
    },
    "tabs": {
      "info": "Détails",
      "stories": "Histoires ({{count}})"
    },
    "automaticMessageCard": {
      "title": "Nous contactons des membres potentiels pour toi...",
      "titleSearching": "Recherche de membres en cours...",
      "titleContactedAll": "Tous les membres potentiels ont été contactés",
      "titleNoCandidates": "L'assistant intelligent reste à l'affût !",
      "titleDisabled": "L'assistant intelligent est désactivé",
      "titleWithResponses": "L’assistant contacte des prêteur·euse·s potentiel·le·s... Tu as des réponses ! ",
      "subtitle": "Plus tu en dis, plus il sera facile pour les membres de comprendre ton offre ou ton besoin !",
      "subtitleNoCandidates": "Aucune offre trouvée. Nous attendons qu'un.e membre publie une nouvelle offre correspondante à ton besoin !",
      "subtitleDisabled": "Réactive l'assistant pour reprendre la recherche de prêteur·euse·s potentiel·le·s.",
      "subtitleSearching": "Cela peut prendre quelques minutes.",
      "subtitleWithResponses": "Des membres potentiels t'ont répondu !",
      "subtitleContactedAll": "En attendant leur réponse, nous restons à l’affût d’une nouvelle offre pertinente pour ton besoin",
      "contacted": "Membre(s) contacté·e·(s) :",
      "responses": "Réponse(s) : {{count}}",
      "viewResponses_zero": "Voir conversation(s)",
      "viewResponses": "Voir ({{count}}) réponse(s)",
      "learnMore": "En savoir plus",
      "automaticMessageLabel": "Message automatique",
      "editAutomaticMessageLabel": "Modifier le message automatique",
      "enabled": "Assistant intelligent activé",
      "disabled": "Assistant intelligent désactivé"
    },
    "reportListing": "Signaler cette annonce",
    "reportListingPrompt": "Bonjour, je souhaite signaler une annonce que je trouve inappropriée. Pourrais-tu l'examiner ?\n\nMerci.",
    "invalidFormError": "L'annonce ne peut pas être enregistrée car le formulaire est invalide. Vérifie chaque champ ci-dessus et réessaie."
  },
  "one-loan": {
    "dueDate": "Date limite",
    "returned": "Retourné",
    "addToCalendarButtonText": "Ajouter au calendrier du téléphone",
    "cancelLoanButtonText": {
      "borrowing": "Annuler l'emprunt",
      "lending": "Annuler le prêt",
      "service": "Annuler le service",
      "donation": "Annuler le don",
      "sale": "Annuler la vente"
    },
    "cancelLoanModal": {
      "primaryButtonText": {
        "borrowing": "Annuler l'emprunt",
        "lending": "Annuler le prêt",
        "service": "Annuler le service",
        "donation": "Annuler le don",
        "sale": "Annuler la vente"
      },
      "secondaryButtonText": {
        "borrowing": "Ne pas annuler",
        "lending": "Ne pas annuler",
        "service": "Ne pas annuler",
        "donation": "Ne pas annuler",
        "sale": "Ne pas annuler"
      },
      "text": {
        "borrowing": "En confirmant l'annulation de l'emprunt, tu signifies au prêteur que tu n'as plus besoin de cet objet.",
        "lending": "En confirmant l'annulation du prêt, tu signifies à l'emprunteur que ce prêt n'aura pas lieu.",
        "service": "En annulant ta demande, tu informes le membre que l'échange de service n'aura pas lieu.",
        "donation": "En annulant ta demande, tu informes le membre que le ramassage de ce don n'aura pas lieu.",
        "sale": "En annulant la vente, tu informes le membre que le ramassage n'aura pas lieu."
      },
      "title": {
        "borrowing": "Annuler l'emprunt ?",
        "lending": "Annuler le prêt ?",
        "service": "Annuler le service ?",
        "donation": "Annuler le don ?",
        "sale": "Annuler la vente ?"
      }
    },
    "editParticipationButtonText": "Modifier l'inscription",
    "ratingAccessory": {
      "rate": "👍 Évaluer {{name}}",
      "mine": "Mon évaluation :",
      "recommended": "Recommandé",
      "notRecommended": "Non recommandé"
    },
    "ratingPrompt": {
      "title": "Tu as eu une belle expérience avec {{name}} ? Partage-la !",
      "subtitle": "Tes commentaires aident à bâtir une communauté plus fiable",
      "dismiss": "Non merci"
    },
    "changeDatesButtonText": {
      "borrowing": "Modifier les dates de l'emprunt",
      "lending": "Modifier les dates du prêt",
      "service": "Modifier la date du service",
      "donation": "Modifier la date du don",
      "sale": "Modifier la date de ramassage"
    },
    "contactSupportAboutIncident": "Signaler un problème",
    "contactSupportAboutIncidentPrompt": {
      "insured": "Salut {{name}} ! 😊\n\nPas de souci, les imprévus ça arrive.\n\nPour qu’on puisse t’aider, pourrais-tu nous expliquer ce qui s’est passé et, si possible, nous envoyer quelques photos de l'objet endommagé ?\n\nRassure-toi, si un dommage survient aux objets que tu prêtes ou empruntes d'une valeur de 25 $ ou plus, <strong>nous nous engageons à te dédommager jusqu’à 300 $ par an</strong>.\n\nMerci !",
      "uninsured": "Salut {{name}} ! 😊\n\nPas de souci, les imprévus ça arrive.\n\nPour qu’on puisse t’aider, pourrais-tu nous expliquer ce qui s’est passé et, si possible, nous envoyer quelques photos de l'objet endommagé ?\n\n<strong>On est là pour t’aider.</strong>\n\nMerci !"
    },
    "donationDate": "Date",
    "end": "Retour",
    "endService": "Fin",
    "expectedEnd": "Retour prévu",
    "myParticipations": "Mes inscriptions",
    "allParticipations": "Nombre d'inscriptions",
    "counterpart": {
      "borrower": "Emprunteur·euse",
      "buyer": "Acheteur·euse",
      "donor": "Donateur·rice",
      "lender": "Prêteur·euse",
      "recipient": "Bénéficiaire",
      "seller": "Vendeur·euse"
    },
    "listParticipants": "Voir les participants inscrits",
    "history": {
      "accepted_when": "Accepté le {{date}}",
      "end_when": "Retour prévu · {{date}}",
      "late_x_days": "Objet en retard · {{numDays}} jours",
      "late_yesterday": "Objet en retard · 1 jour",
      "offered_when": "Demande de prêt envoyée le {{date}}",
      "returned_by_you": "toi",
      "returned_when": "Retour confirmé par {{who}} · {{date}}",
      "started_when": "Prêt en cours · {{date}}",
      "title": "Historique"
    },
    "serviceHistory": {
      "accepted_when": "Accepté le {{date}}",
      "end_when": "Fin prévue · {{date}}",
      "late_x_days": "Service en retard · {{numDays}} jours",
      "late_yesterday": "Service en retard · 1 jour",
      "offered_when": "Demande de service envoyée le {{date}}",
      "returned_by_you": "toi",
      "returned_when": "Service rendu confirmé par {{who}} · {{date}}",
      "started_when": "Service en cours · {{date}}",
      "title": "Historique"
    },
    "donationHistory": {
      "accepted_when": "Accepté le {{date}}",
      "late_x_days": "Ramassage en retard · {{numDays}} jours",
      "late_yesterday": "Ramassage en retard · 1 jour",
      "offered_when": "Demande de ramassage envoyée le {{date}}",
      "returned_by_you": "toi",
      "returned_when": "Don ramassé - confirmé par {{who}} · {{date}}",
      "started_when": "Ramassage du don prévu le {{date}}",
      "title": "Historique"
    },
    "saleHistory": {
      "accepted_when": "Accepté le {{date}}",
      "end_when": "Ramassage prévu · {{date}}",
      "late_x_days": "Ramassage en retard · {{numDays}} jours",
      "late_yesterday": "Ramassage en retard · 1 jour",
      "offered_when": "Demande de ramassage envoyée le {{date}}",
      "returned_by_you": "toi",
      "returned_when": "Réception confirmée par {{who}} · {{date}}",
      "started_when": "Ramassage prévu le {{date}}",
      "title": "Historique"
    },
    "sendMessage": "Envoyer un message à {{name}}",
    "start": "Début",
    "status": "Statut",
    "transactionDate": "Date de la transaction",
    "title": {
      "borrowing": "Détails de l'emprunt",
      "lending": "Détails du prêt",
      "service": "Détails du service",
      "donation": "Détails du ramassage d'un don",
      "sell": "Détails de la vente"
    },
    "viewListing": "Voir les détails de l'annonce"
  },
  "payment": {
    "activateButton": "Activer ton abonnement",
    "benefitsTitle": "Les avantages",
    "askForMode": {
      "title": "Choisis un mode de paiement",
      "mode": {
        "googlePay": "Google Pay",
        "applePay": "Apple Pay",
        "stripe": "Carte de crédit"
      }
    },
    "cancellationPolicy": "Ton abonnement sera renouvelé automatiquement chaque année. Tu peux annuler ton abonnement jusqu’à 24 h avant la date de ton prochain paiement.",
    "couponButton": "Appliquer",
    "couponFieldPlaceholder": "Code promo",
    "discountLabel": "Rabais",
    "expiredCoupon": "Ce code a expiré",
    "expiredFreeTrial": "Ta période d'essai se terminait le {{date}}",
    "expiredPlan": "Ton abonnement se terminait le {{date}}",
    "intro": "Emprunte <highlight>sans limite</highlight> avec l’abonnement <highlight>Partage+</highlight> !",
    "willExpirePlan": "Ce nouvel abonnement commencerait le {{date}}",
    "invalidCoupon": "Ce code est non-valide",
    "modal": {
      "firstParagraph": "Merci de ta confiance. Grâce à ton abonnement, tu peux maintenant emprunter et prêter des objets à tes voisins sans limite.",
      "primaryButtonText": "Voir ton abonnement",
      "title": "Merci!"
    },
    "payButton": "Payer",
    "popular": "Populaire",
    "loanDiscount": {
      "percentage": "-25 %",
      "price": {
        "CAD": "45 $",
        "EUR": "54 €",
        "USD": "54 USD"
      },
      "footnote": "*{{discountedPrice}} facturés annuellement, puis {{renewalPrice}} à la date de renouvellement"
    },
    "yearlyMonthlyEquivalent": "{{price}}/mois",
    "monthlyEquivalent": {
      "CAD": "5 $",
      "EUR": "6 €",
      "USD": "6 USD"
    },
    "period": {
      "monthly": "mois",
      "yearly": "année"
    },
    "price": {
      "monthly": {
        "CAD": "8 $",
        "EUR": "9 €",
        "USD": "9 USD"
      },
      "yearly": {
        "CAD": "60 $",
        "EUR": "72 €",
        "USD": "72 USD"
      }
    },
    "savings": {
      "yearly": {
        "CAD": "(Économise 36 $)",
        "EUR": "(Économise 36 €)",
        "USD": "(Économise 36 USD)"
      }
    },
    "mobileRedirect": {
      "subtitle": "L'abonnement Partage Club est en ce moment disponible uniquement sur l'app mobile.\nUne fois abonné(e), tu pourras continuer d'utiliser le site web pour emprunter et prêter des objets.",
      "forWhat": ""
    },
    "web": {
      "activationPending": "L’activation prend plus de temps que prévu. Ton paiement est confirmé et tu ne seras pas facturé·e de nouveau.",
      "initializationError": "Impossible de charger le paiement sécurisé. Réessaie.",
      "retryCheckout": "Réessayer le paiement",
      "genericError": "Le paiement n’a pas pu être confirmé. Vérifie tes informations et réessaie.",
      "loading": "Chargement du paiement sécurisé…",
      "paymentConfirmed": "Paiement confirmé",
      "paymentDetails": "Mode de paiement",
      "paymentPending": "Paiement en attente",
      "paymentPendingDetails": "Ton paiement est toujours en cours de traitement. Nous activerons ton abonnement dès que Stripe l’aura confirmé.",
      "processing": "Nous activons ton abonnement. Cela prend généralement quelques secondes.",
      "removeCoupon": "Retirer le code promo",
      "taxes": "Taxes",
      "total": "Total",
      "unavailable": "Le paiement web n’est pas disponible pour cet abonnement.",
      "verifyingPayment": "Vérification de ton paiement",
      "verifyingPaymentDetails": "Nous vérifions le dernier statut du paiement auprès de Stripe.",
      "viewSubscription": "Voir ton abonnement"
    },
    "subtotal": "Sous-total",
    "taxes": "Taxes",
    "title": "Active ton abonnement"
  },
  "paywall": {
    "firstHero": "Ta période d'essai gratuite est terminée.",
    "firstHeroBis": "Ton abonnement a expiré.",
    "firstSubhero": "Tu peux continuer à prêter sans abonnement, mais pour emprunter, tu dois t'abonner.",
    "pricesDescription": {
      "monthly": "Abonnement mensuel",
      "yearly": "Abonnement annuel"
    },
    "firstFeature": "Emprunts illimités",
    "secondFeature": "Une référence = 1 mois gratuit",
    "thirdFeature": "Partage Club est responsable des dommages causés aux objets",
    "fourthFeature": "Annule à tout moment",
    "ctaLabel": "Abonne-toi maintenant",
    "redesign": {
      "cancelAnytime": "Annule en tout temps",
      "coverageFootnote": "*La Responsabilité Partage Club te dédommage jusqu’à 300 $ sur les objets prêtés ou empruntés.",
      "damageCoverage": "Dédommagement sur les objets*",
      "expired": {
        "subtitle": "Ton abonnement est terminé. Retrouve tous tes avantages en un clic.",
        "title": "Prêt à repartir ?"
      },
      "included": "Ce qui est inclus :",
      "learnMore": "En savoir plus",
      "noThanks": "Non merci",
      "standard": {
        "subtitle": "Débloque l’expérience complète pour continuer d’emprunter en toute tranquillité",
        "title": "Tu es sur la bonne voie !"
      },
      "subscribe": "S’abonner maintenant",
      "unlimitedBorrowing": "Emprunts illimités",
      "unlimitedLending": "Prêts illimités"
    }
  },
  "paywall2": {
    "title": {
      "trial": "Essai gratuit terminé, mais...",
      "regular": "Abonnement terminé, mais..."
    },
    "offer": {
      "trial": "Obtiens 25 % de rabais sur l’abonnement annuel et profite pleinement de la Responsabilité Partage Club !",
      "regular": "Voici une bonne raison de t'abonner !"
    },
    "details": {
      "trial": "Avec ton abonnement, si un dommage survient aux objets que tu prêtes ou empruntes d'une valeur de 25 $ ou plus,  <strong>nous nous engageons à te dédommager jusqu’à 300 $ par an</strong>.\n\nCode promo : <strong>PARTAGE25</strong>",
      "regular": "Avec ton abonnement, si un dommage survient aux objets que tu prêtes ou empruntes d'une valeur de 25 $ ou plus, <strong>nous nous engageons à te dédommager jusqu’à 300 $ par an</strong>."
    },
    "button": {
      "trial": "M’abonner",
      "regular": "M’abonner"
    }
  },
  "personal-information": {
    "activitySectorsFieldLabel": "Secteur(s) d'activité(s)",
    "activitySectorsFieldSubtitle": "Sélectionne au moins 1 option",
    "firstNameFieldLabel": "Prénom",
    "firstNameFieldPlaceholder": "Prénom",
    "lastNameFieldLabel": "Nom",
    "lastNameFieldPlaceholder": "Nom",
    "phoneFieldLabel": "Numéro de téléphone cellulaire",
    "phoneFieldError": "Le numéro de téléphone n'est pas valide.",
    "phoneFieldSubtitle": "Ne t’inquiète pas, on ne partagera jamais ton numéro avec un·e autre membre ou une entreprise.",
    "pictureFieldSubtitle": "La photo de profil augmente la confiance entre membres",
    "pictureFieldTitle": "Ajouter une photo de profil",
    "title": "Tes informations personnelles",
    "phoneFieldHelp": {
      "title": "Numéro de cellulaire",
      "boldText": "Un petit geste qui change tout !",
      "text": "Ton numéro valide ton identité, renforçant la confiance de la communauté.\n\nOn l'utilise uniquement en cas d'urgence (message manqué, courriel bloqué) pour s'assurer que chaque partage se concrétise sans accroc.\n\nOn ne le partagera jamais avec personne d'autre."
    }
  },
  "privacy": {
    "title": "Conditions et confidentialité",
    "button1Text": "Termes et conditions",
    "link1": "https://www.partage.club/fr-ca/terms-and-conditions",
    "button2Text": "Politique de confidentialité",
    "link2": "https://www.partage.club/fr-ca/privacy-policy",
    "button3Text": "Responsabilité du Partage Club",
    "link3": "https://www.partage.club/fr-ca/terms-and-conditions#responsabilite"
  },
  "profile": {
    "tabBarLabel": "Profil"
  },
  "profile-overview": {
    "contactUsButtonLabel": "Aide",
    "editProfileButtonLabel": "Modifier",
    "inviteNeighboursButtonLabel": "Inviter des voisins",
    "logoutButtonLabel": "Me déconnecter",
    "memberSince": "Membre depuis {{date}}",
    "myClubButtonLabel": "Liste des membres",
    "myClubsButtonLabel": "Modifier mes clubs",
    "myFinancialImpactButtonLabel": "Économique",
    "myRatingsButtonLabel": "Évaluations",
    "streak": "Streak",
    "streakHood": "Série de quartier",
    "superButtonLabel": "<strong>Super Partageur.euse</strong>",
    "superButtonLabelNotYet": "Devenir <strong>Super Partageur.euse</strong>",
    "myImpactTitle": "Mon impact",
    "ambassadorButtonLabel": "<strong>Espace Ambassadeur·rice</strong>",
    "ambassadorButtonLabelNotYet": "Devenir <strong>Ambassadeur·rice</strong>",
    "myInformationButtonLabel": "Paramètres du compte",
    "myInformationTitle": "Informations personnelles",
    "myPreferencesButtonLabel": "Gérer mes préférences",
    "myInterestsButtonLabel": "Gérer mes intérêts",
    "myActivitySectorsButtonLabel": "Mes secteurs d’activité",
    "myProfileButtonLabel": "Profil public",
    "mySubscriptionButtonLabel": "Gérer mon abonnement",
    "otherTitle": "Autres",
    "darkModeLabel": "Mode sombre",
    "title": "Mon profil",
    "tosButtonLabel": "Conditions et confidentialité",
    "editAvatarButton": "Editer l'avatar",
    "profilePictureChangedToast": "Photo de profil modifiée",
    "unavailableButtonLabel": "Me signaler <strong>indisponible...</strong>",
    "unavailableStatusInformation": "Du <strong>{{startDate}}</strong> au <strong>{{endDate}}</strong>",
    "unavailableStatusTitle": "Statut",
    "unavailableStatusBadge": "Indisponible",
    "deleteStatus": "Supprimer mon statut",
    "deleteStatusToast": {
      "title": "Ton statut d'indisponibilité a été supprimé"
    },
    "editStatusAccessibilityLabel": "Modifier le statut d'indisponibilité",
    "unavailableStatusWarning": "Indisponibilité prévue du <strong>{{startDate}}</strong> au <strong>{{endDate}}</strong>"
  },
  "my-ratings": {
    "title": "Évaluations",
    "loading": "Chargement des évaluations...",
    "tabs": {
      "given": "Données ({{count}})",
      "received": "Reçues ({{count}})"
    }
  },
  "publicUserWelcome": {
    "title": "Merci !",
    "instructions": "Ton compte est prêt ! Tu pourras bientôt aider les horticulteur·trice·s et recevoir des dons de surplus.",
    "enableNotificationsPrompt": "Active les notifications pour être averti·e dès l’ouverture !",
    "notificationsEnabled": "Les notifications sont activées. Tu seras averti·e dès l’ouverture !",
    "buttonEnableNotifications": "Activer mes notifications",
    "buttonLater": "Plus tard"
  },
  "quick-new-choose": {
    "buttonText": "Valider mes offres ",
    "secondaryButtonText": "Annuler",
    "headerText": "En publiant des objets, tu augmentes la confiance des autres envers toi.",
    "headerTextHalloween": "C'est bientôt l'<strong>Halloween</strong>, des membres recherchent ces déguisements. Les as-tu ?",
    "headerTitle": "Publier une offre multiple",
    "nothingSelectedError": {
      "buttonText": "Retour",
      "text": "Tu dois sélectionner au minimum un objet pour continuer.",
      "title": "Sélectionne 1+ objet(s)"
    }
  },
  "quick-new-confirm": {
    "buttonText": "Publier ({{num}})",
    "secondaryButtonText": "Retour",
    "headerText": "En <strong>appuyant sur Publier</strong>, les objets sélectionnés seront publiés <strong>sur ton profil</strong> et d'autres personnes <strong>pourront te les emprunter</strong>",
    "headerTitle": "Confirmation",
    "almostThere": "On y est presque !"
  },
  "quick-new-thanks": {
    "bodyText": "Tu peux à tout moment aller modifier tes offres dans ton centre de partages.\n\nTon profil est complet, tu es prêt·e à commencer à <strong>prêter !</strong>",
    "buttonBackText": "Accéder au babillard",
    "buttonListingsText": "Voir mes annonces",
    "buttonAddLoanFeeText": "Ajouter un frais de partage",
    "didYouKnowTitle": "Savais-tu que...",
    "didYouKnowBody": "Les objets avec une vraie photo ont 3x plus de chances d’être empruntés. Tu peux aller voir tes annonces pour les bonifier !",
    "headerText": "Merci !",
    "headerTitle": "Merci !",
    "myImpactLevelButtonText": "Voir mon impact",
    "userNowContributorText": "Tu accèdes à un niveau supérieur : <strong>Contributeur</strong>. En publiant ta première offre, tu as augmenté ton impact."
  },
  "ratings": {
    "confirmation": {
      "cancel": "Annuler la recommandation",
      "text1": "<strong>Tu as recommandé {{name}} !</strong>",
      "text2": "<strong>Merci</strong> (de sa part aussi) 😊",
      "text3": "Tu peux voir le nombre de recommandations des membres dans leur profil et un peu partout où l’on voit leur photo."
    },
    "notGreat": {
      "chatPrompt": "Salut {{name}} ! 😊\n\nMerci de prendre le temps de nous partager ton expérience. Alors, qu’est-ce qui s’est passé ?",
      "ctaButton": "Contacter Partage Club",
      "text1": "Merci pour ton retour.",
      "text2": "On est désolés que l’expérience n’ait pas été positive. 🙁 Veux-tu qu’on s’en parle afin que l’on comprenne ce qui s’est passé ?"
    },
    "prompt": {
      "text1": "Évaluer {{name}} ?",
      "text2": "Partage ton expérience pour que d'autres n'hésitent pas à faire de même :)",
      "ctaButton": "Laisser un avis"
    },
    "promptFigma": {
      "title": "Tu as eu une belle expérience ?\nPartage-la !",
      "subtitle": "Tes commentaires aident à bâtir une communauté plus fiable"
    },
    "ratingPrompt": {
      "text": "Ton avis a été publié ! Merci d’avoir pris le temps de partager ton expérience."
    },
    "rated": {
      "recommended": "Tu as recommandé {{name}}",
      "notRecommended": "Tu n'as pas recommandé {{name}}"
    },
    "newRating": {
      "title": "Évalue cet échange",
      "intro": "Ton évaluation honnête contribue à bâtir une communauté plus fiable. Note chaque aspect de 1 à 5.",
      "finalNotice": "Les évaluations sont définitives et ne pourront pas être modifiées.",
      "tapToRate": "Touche un chiffre pour évaluer",
      "commentTitle": "Quelque chose à ajouter ?",
      "commentHelp": "Visible uniquement par l'équipe Partage Club. Utilise ce champ pour signaler un problème ou ajouter du contexte.",
      "commentPlaceholder": "Note interne (optionnelle)...",
      "submitButton": "Envoyer les évaluations",
      "errorTitle": "Une erreur est survenue",
      "errorMessage": "Tes évaluations n'ont pas pu être enregistrées. Réessaie.",
      "notReadyMessage": "Cet échange doit être entièrement terminé avant de laisser une évaluation. Si tu as retourné l'objet, attends la confirmation de l'autre personne.",
      "figmaHeaderTitle": "Rédiger une évaluation",
      "figmaStepLabel": "Étape {{count}} sur 2",
      "figmaStepCounter": "{{current}} sur {{total}}",
      "figmaSubjectBorrowerLabel": "Emprunteur·euse",
      "figmaRecommended": "Recommandé",
      "figmaNotRecommended": "Non recommandé",
      "figmaOverallQuestion": {
        "lender": "Ton expérience de prêt s'est-elle bien passée ?",
        "borrower": "Ton expérience d'emprunt s'est-elle bien passée ?"
      },
      "figmaInfoPrompt": "Objet retourné le {{date}} · {{count}} j d’emprunt",
      "figmaQuestions": {
        "lender": {
          "assetQuality": {
            "question": "Dans quelles conditions était l'objet au retour ?",
            "labels": {
              "1": "Très abîmé",
              "2": "Abîmé",
              "3": "État correct",
              "4": "Bon état",
              "5": "Comme neuf"
            }
          },
          "logisticsReliability": {
            "question": "Cette personne a-t-elle respecté l'heure des rendez-vous ?",
            "labels": {
              "1": "Très en retard",
              "2": "En retard",
              "3": "Légèrement en retard",
              "4": "À l'heure",
              "5": "Très ponctuel·le"
            }
          },
          "communityTrust": {
            "question": "Comment s'est déroulé l'accueil et le contact avec cette personne ?",
            "labels": {
              "1": "Très désagréable",
              "2": "Plutôt froid",
              "3": "Correct",
              "4": "Chaleureux",
              "5": "Exceptionnel"
            }
          }
        },
        "borrower": {
          "assetQuality": {
            "question": "L'objet était-il conforme à l'annonce et fonctionnait-il correctement ?",
            "labels": {
              "1": "Pas du tout conforme",
              "2": "Peu conforme",
              "3": "Assez conforme",
              "4": "Conforme",
              "5": "Parfaitement conforme"
            }
          },
          "logisticsReliability": {
            "question": "Cette personne a-t-elle respecté l'heure des rendez-vous ?",
            "labels": {
              "1": "Très en retard",
              "2": "En retard",
              "3": "Légèrement en retard",
              "4": "À l'heure",
              "5": "Très ponctuel·le"
            }
          },
          "communityTrust": {
            "question": "Comment s'est déroulé l'accueil et le contact avec cette personne ?",
            "labels": {
              "1": "Très désagréable",
              "2": "Plutôt froid",
              "3": "Correct",
              "4": "Chaleureux",
              "5": "Exceptionnel"
            }
          }
        }
      },
      "figmaAddDetailsTitle": "Ajoute des détails",
      "figmaImproveListingTitle": "Améliore l'annonce",
      "figmaAddPhotoTitle": "Ajouter une photo de l'objet",
      "figmaModifyPhotoTitle": "Modifier la photo de l'objet",
      "figmaCommentTitle": "Laisse un commentaire",
      "figmaOptional": "(optionnel)",
      "figmaRequired": "(obligatoire)",
      "figmaCommentPlaceholder": "J'ai récemment emprunté un livre à Jean, et cela a été une expérience enrichissante...",
      "figmaPublicCommentHint": "Ton évaluation sera visible publiquement",
      "figmaDetailSectionTitle": "Évalue les aspects clés",
      "figmaContinueButton": "Continuer",
      "figmaSubmitButton": "Soumettre",
      "thanks": {
        "title": "Merci pour ton évaluation !",
        "subtitle": "Tu contribues à bâtir une communauté plus <strong>fiable</strong>",
        "negativeSubtitle": "On est désolé que l'expérience n'ait pas été positive, nous allons examiner ton évaluation en détail.",
        "button": "Terminer",
        "editButton": "Modifier mon évaluation"
      },
      "reciprocity": {
        "title": "À ton tour de partager",
        "description": "Ton emprunt s’est bien passé ? Publie les objets que tu utilises peu et aide la communauté à ton tour.",
        "publish": "Publier mes objets",
        "later": "Plus tard"
      },
      "badges": {
        "lender": {
          "assetQuality": {
            "negative": "Rendu en mauvais état",
            "neutral": "A pris soin de l'objet",
            "positive": "A pris soin de l'objet"
          },
          "logisticsReliability": {
            "neutral": "Ponctualité",
            "negative": "Ponctualité",
            "medium": "Ponctualité",
            "positive": "Ponctualité"
          },
          "communityTrust": {
            "neutral": "Courtoisie",
            "negative": "Courtoisie",
            "medium": "Courtoisie",
            "positive": "Courtoisie"
          }
        },
        "borrower": {
          "assetQuality": {
            "negative": "Objet non conforme",
            "neutral": "Conformité de l'objet",
            "positive": "Conformité de l'objet"
          },
          "logisticsReliability": {
            "neutral": "Ponctualité",
            "negative": "Ponctualité",
            "medium": "Ponctualité",
            "positive": "Ponctualité"
          },
          "communityTrust": {
            "neutral": "Courtoisie",
            "negative": "Courtoisie",
            "medium": "Courtoisie",
            "positive": "Courtoisie"
          }
        }
      }
    }
  },
  "reset-password": {
    "codeFieldLabel": "Code de confirmation reçu",
    "codeFieldPlaceholder": "ex: 123456",
    "details": "Un code de confirmation t’a été envoyé par courriel. Entre-le ci-dessous, puis choisis un nouveau mot de passe.",
    "passwordFieldLabel": "Ton nouveau mot de passe",
    "passwordFieldPlaceholder": "Choisis un nouveau mot de passe",
    "primaryButtonText": "Changer mon mot de passe",
    "title": "Choisir un nouveau mot de passe"
  },
  "settingsPrompt": {
    "camera": {
      "title": "Autoriser l'accès à la caméra",
      "text": "Pour nous permettre d'accéder à la caméra, accède aux réglages de ton appareil et active la permission à cet effet."
    },
    "notification": {
      "title": "Autoriser les notifications",
      "text": "Pour nous permettre de t'envoyer des notifications, accède aux réglages de ton appareil et active les notifications."
    },
    "primaryButtonText": "Accéder aux Réglages",
    "secondaryButtonText": "Annuler"
  },
  "signup": {
    "guestTitle": "Rejoins {{appName}} !",
    "guestCreateAccount": "Créer un compte",
    "title": "Créer mon compte",
    "alreadyHaveAccountPrefix": "Déjà inscrit ?",
    "alreadyHaveAccount": "Se connecter",
    "signUpWithEmail": "S'inscrire avec un courriel",
    "signUpWithApple": "S'inscrire avec Apple",
    "signUpWithFacebook": "S'inscrire avec Facebook",
    "signUpWithGoogle": "S'inscrire avec Google",
    "continueWithApple": "Continuer avec Apple",
    "continueWithFacebook": "Continuer avec Facebook",
    "continueWithGoogle": "Continuer avec Google",
    "enterValidationCode": "Entrer le code de validation"
  },
  "splash": {
    "poweredBy": "Propulsé par"
  },
  "presentPartageClub": {
    "headerTitle": "Bienvenue sur Partage Club",
    "title": "Bienvenue sur Partage Club",
    "community": {
      "headerText": "Partage Club, c'est l'application de <strong>partage d'objets</strong> entre voisin.e.s.",
      "footerText": "Profite <strong>pleinement</strong> de la vie, sans te limiter à ce que tu possèdes."
    },
    "accessMore": {
      "headerText": "Sur Partage Club, tu accèdes à une <strong>abondance d'objets</strong>.",
      "footerText": "Équipement de sport, outils, jeux pour enfants, etc. : ici, tu trouves <strong>vraiment tout.</strong>"
    },
    "offerMore": {
      "headerText": "Sur Partage Club, ta <strong>générosité</strong> fait une vraie <strong>différence</strong>.",
      "footerText": "Fais <strong>profiter</strong> les autres de tes objets trop peu utilisés. Ça fait du bien."
    },
    "button": {
      "noAccountYet": "Rejoindre la communauté",
      "alreadyHaveAnAccount": "J'ai déjà un compte"
    }
  },
  "presentCommunity": {
    "headerTitle": "Bienvenue dans la communauté",
    "title": "Présentation de la communauté",
    "newFlow": {
      "continue": "Continuer",
      "continueWithoutArrow": "Continuer",
      "startSharing": "Commencer à partager !",
      "continueFree": "Continuer gratuitement",
      "subscribeNow": "S'abonner maintenant",
      "yearlyPrice": "{{annualPrice}}/année ({{monthlyPrice}}/mois). Annule en tout temps",
      "includedToday": "Ce qui est inclus aujourd’hui :",
      "includedWith": "Ce qui est inclus avec",
      "unlimitedLending": "Prêts illimités",
      "unlimitedLendingDescription": "Publie des offres et prête tes objets à tes voisin·e·s autant de fois que tu le souhaites",
      "oneFreeBorrow": "1 emprunt gratuit",
      "oneFreeBorrowPrefix": "1 emprunt",
      "oneFreeBorrowHighlight": "gratuit",
      "oneFreeBorrowDescription": "Emprunte ton premier objet à tes voisin·e·s gratuitement",
      "unlimitedBorrowing": "Emprunts illimités",
      "damageCoverage": "Dédommagement sur les objets",
      "learnMore": "En savoir plus",
      "coverageFootnote": "*La Responsabilité Partage Club te dédommage jusqu'à 300 $ sur les objets prêtés ou empruntés.",
      "free": {
        "title": "Démarre gratuitement !",
        "subtitle": "Découvre les joies du partage sans frais."
      },
      "sponsored": {
        "title": "Ton abonnement\nest offert !",
        "subtitle": "Profite de l’expérience complète grâce à",
        "offeredBy": "Offert par :"
      },
      "upsell": {
        "title": "Pour partager\nen sécurité",
        "subtitle": "Abonne-toi pour activer le dédommagement sur tes partages.",
        "withSubscription": "En s’abonnant à",
        "damageCoverageDescription": "Pour les objets prêtés et empruntés"
      },
      "success": {
        "title": "Merci, {{name}} !",
        "subtitle": "Ton abonnement est actif et tu as accès à l’expérience complète",
        "yourSubscription": "Ton abonnement",
        "currentPlan": {
          "monthly": "Tu es présentement sur un abonnement mensuel.",
          "yearly": "Tu es présentement sur un abonnement annuel.",
          "no": "Ton abonnement est actif."
        },
        "billingNote": {
          "monthly": "*Tu seras facturé {{price}} / mois à la date de renouvellement. Annule jusqu’à 24 h avant la date de ton prochain paiement.",
          "yearly": "*Tu seras facturé {{price}} / année à la date de renouvellement. Annule jusqu’à 24 h avant la date de ton prochain paiement."
        },
        "nextPayment": "Prochain paiement",
        "cancelAnytime": "Annule à tout moment",
        "cancellationDescription": "Tu peux annuler ton abonnement jusqu’à 24 h avant la date de ton prochain paiement. Ton abonnement sera renouvelé chaque année."
      }
    },
    "congratulation": {
      "congratulation": "Félicitations !",
      "text1": "{{name}}, tu es officiellement partageur.euse.",
      "text2": "Tu as obtenu un abonnement gratuit",
      "text3": "Grâce à {{name}}, ton abonnement est gratuit. 🎉\n\n",
      "text4": "Profites-en pour partager de façon illimitée avec la communauté.",
      "freeTrial": {
        "text1": "Tu as maintenant \naccès à la communauté.",
        "text2": "1 emprunt gratuit",
        "text3": "Prêter ? Toujours gratuit.",
        "text4": "Ensuite, si tu veux continuer à emprunter, choisis ton abonnement :",
        "text5": "On ne prélève rien sans ton accord.",
        "price": {
          "yearly": {
            "CAD": "60 $ (annuel, économisez 36 $)",
            "EUR": "72 € (annuel, économisez 36 €)",
            "USD": "72 USD (annuel, économisez 36 USD)"
          }
        }
      },
      "buttonText": "Suivant"
    },
    "responsibility": {
      "headerText": "Partage Club est <strong>responsable</strong> !",
      "footerText": "Grâce à ton abonnement, si un objet d’une valeur de 25 $ ou plus est endommagé pendant un prêt, on te dédommage <strong>jusqu’à 300 $ par an.</strong>"
    },
    "respect": {
      "headerText": "Une communauté <strong>attentionnée</strong> et <strong>respectueuse</strong> !",
      "footerText": "<strong>Moins de 1%</strong> des objets empruntés sont endommagés. Et souvent, ils reviennent encore plus propres. C’est magique."
    },
    "transaction": {
      "headerText": "Sur Partage Club, il n’y a <strong>aucun échange d’argent</strong>",
      "footerText": "Le partage ce n’est pas de la location. Ici, on <strong>s’entraide</strong>. On <strong>prête</strong>. \nOn <strong>emprunte</strong>."
    },
    "trust": {
      "headerText": "Sur Partage Club, la <strong>confiance</strong> passe <strong>avant tout</strong>",
      "footerText": "On privilégie les <strong>échanges dans les lieux publics</strong> et on utilise un système de recommandations pour te garder en <strong>sécurité</strong>."
    },
    "free": {
      "headerText": "Sur Partage Club, c’est 100% gratuit pour <strong>prêter</strong>",
      "footerText": "Et si tu es du genre à aider souvent, on peut même te reconnaître comme <strong>ambassadeur·rice</strong> et t’offrir ton abonnement."
    },
    "button": {
      "next": "Suivant",
      "previous": "Précédent",
      "skip": "Passer"
    }
  },
  "quickInterest": {
    "headerTitle": "Centres d’intérêt",
    "title": "Quels sont tes centres d’intérêt ?",
    "subtitle": "Personnalise tes recommandations et sois notifié des nouvelles offres.",
    "instruction": "Sélectionne un ou plusieurs intérêts :",
    "nothingSelectedError": {
      "buttonText": "Retour",
      "text": "Tu dois sélectionner au minimum un centre d’intérêt pour continuer.",
      "title": "Sélectionne 1+ centre(s) d’intérêt"
    },
    "button": {
      "confirm": "Confirmer",
      "skip": "Peut-être plus tard"
    }
  },
  "borrowerNext": {
    "headerTitle": "Emprunter",
    "title": "Que souhaites-tu faire maintenant ?",
    "searchLabel": "Cherche un objet spécifique",
    "searchPlaceholder": "Gaufrier, shampouineuse…",
    "inspirationButton": "J'ai besoin d'inspiration"
  },
  "lenderNext": {
    "headerTitle": "Prêter",
    "title": "Que souhaites-tu faire maintenant ?",
    "specificObjectButton": "J'ai un objet spécifique à prêter",
    "inspirationButton": "J'ai besoin d'inspiration"
  },
  "interests": {
    "headerTitle": "Centres d’intérêt",
    "title": "Centres d’intérêt",
    "nothingSelectedError": {
      "buttonText": "Retour",
      "text": "Tu dois sélectionner au minimum un objet pour continuer.",
      "title": "Sélectionne 1+ objet(s)"
    },
    "explain": {
      "title": {
        "borrower": "Cher·ère \nemprunteur·euse !",
        "lender": "Cher·ère \nprêteur·euse !",
        "both": "Cher·ère \nemprunteur·euse !"
      },
      "subtitle": {
        "borrower": "Dis-nous ce que tu aimes et ce que tu rêves d’essayer pour qu’on te propose des objets faits pour toi.",
        "lender": "Montre aux autres membres ce que tu as à offrir. \n\nBesoin d’inspiration ?\nParle-nous un peu de toi et on te suggérera des idées d'objets à prêter.",
        "both": "Dis-nous ce que tu aimes et ce que tu rêves d’essayer pour qu’on te propose des objets faits pour toi."
      }
    },
    "chooseTag": {
      "title": {
        "borrower": "Quels sont tes centres d’intérêt ?",
        "lender": "Choisis les catégories d'objets que tu possèdes",
        "both": "Quels sont tes centres d’intérêt ?"
      },
      "subtitle": {
        "borrower": "Tu aimes le camping ou les jeux de société ? Ajoute tes intérêts à ton profil et laisse nous te montrer ce qui pourrait te plaire.",
        "lender": "Ça nous aidera à te proposer des idées d'objets à prêter.",
        "both": "Tu aimes le camping ou les jeux de société ? Ajoute tes intérêts à ton profil et laisse nous te montrer ce qui pourrait te plaire."
      }
    },
    "chooseListing": {
      "title": {
        "borrower": "{{name}}",
        "lender": "{{name}}",
        "both": "{{name}}"
      },
      "subtitle": {
        "borrower": "On a repéré des objets qui correspondent à tes intérêts ! Ajoute-les dans tes favoris.",
        "lender": "Nous avons trouvé des objets souvent demandés que tu pourrais prêter.",
        "both": "On a repéré des objets qui correspondent à tes intérêts ! Ajoute-les dans tes favoris."
      },
      "aggregateTitle": {
        "borrower": "Selon les catégories choisies, voici des objets qui pourraient t’intéresser.",
        "lender": "Selon les catégories choisies, nous avons trouvé des objets souvent demandés que tu pourrais prêter.",
        "both": "Selon les catégories choisies, voici des objets qui pourraient t’intéresser."
      }
    },
    "button": {
      "continue": "Continuer",
      "completeProfile": "Compléter mon profil",
      "skip": "Peut-être plus tard",
      "modifyInterests": "Modifier mes intérêts",
      "pass": "Passer"
    },
    "loading": "Chargement des suggestions...",
    "noListingsFound": "Malheureusement, aucun objet n'a été trouvé pour cette catégorie."
  },
  "ambassador": {
    "title": "Espace Ambassadeur",
    "banner": {
      "title": "Fait rayonner le partage !",
      "subtitle": "Deviens Ambassadeur·rice et développe la communauté"
    },
    "subtitle": {
      "isAmbassador": "Tu es\n<strong>Ambassadeur·rice</strong>",
      "notYetAmbassador": "Devenir\n<strong>Ambassadeur·rice</strong>"
    },
    "description": {
      "isAmbassador": "Un·e ambassadeur·rice est un membre engagé qui <strong>contribue activement à faire vivre le partage dans sa communauté</strong>.\n\nIl ou elle agit comme <strong>point de repère local</strong>, facilite les échanges et aide Partage Club à grandir, de façon humaine et authentique.",
      "notYetAmbassador": "Un·e ambassadeur·rice est un membre engagé qui <strong>contribue activement à faire vivre le partage dans sa communauté</strong>.\n\nIl ou elle agit comme <strong>point de repère local</strong>, facilite les échanges et aide Partage Club à grandir, de façon humaine et authentique."
    },
    "showMore": "voir plus",
    "showLess": "voir moins",
    "ctaButton": "Devenir ambassadeur·rice",
    "channelDiscussion": "Canal de discussion",
    "advantages": {
      "titleIsAmbassador": "Tes avantages",
      "titleNotYet": "Les avantages",
      "advantage1": {
        "title": "Faire partie d'une communauté",
        "body": "Des personnes de ton quartier, qui, comme toi, veulent créer une résilience locale"
      },
      "advantage2": {
        "title": "Abonnements gratuits",
        "body": "Ton abonnement est gratuit et nous pouvons t'en fournir lors de l'organisation d'événements"
      },
      "advantage3": {
        "title": "Pouvoir décisionnel",
        "body": "Donne ton avis sur les futures priorités et projets de Partage Club et du programme ambassadeur"
      },
      "advantage4": {
        "title": "Invitations spéciales aux événements Partage Club",
        "body": "Participe à des rencontres annuelles regroupant les ambassadeur·rices des environs"
      },
      "advantage5": {
        "title": "Accès à des objets fournis par Partage Club",
        "body": "Garde des objets en pension et bénéficie de l'accès à ces objets"
      },
      "advantage6": {
        "title": "Promotions spéciales dans les lieux de partage (à venir)",
        "body": "Profite de promotions offertes par les lieux de partage proches de chez toi : réductions, cadeaux et plus encore..."
      }
    },
    "mission": {
      "title": "La mission",
      "description": "<strong>Être Ambassadeur·rice...</strong>\nC'est faire rayonner la mission du partage à ton échelle, de la façon qui te ressemble. Chacun·e s'implique selon son temps, ses envies et ses forces.",
      "mission1": "Représenter la marque avec authenticité",
      "mission2": "Inspirer et mobiliser sa communauté : Donner envie de partager, montrer l'exemple et créer un effet d'entraînement dans son quartier",
      "mission3": "Recruter des nouveaux membres",
      "mission4": "Partager des objets",
      "concreteTitle": "Concrètement, ça peut vouloir dire :",
      "concreteIntro": "",
      "concrete1": "Faire connaître Partage Club autour de toi",
      "concrete2": "Garder des objets en pension chez toi",
      "concrete3": "Organiser des activités et moments de partage",
      "concrete4": "Participer à la création de contenu",
      "concrete5": "Proposer tes propres idées...",
      "learnMore": "En savoir plus"
    }
  },
  "streak": {
    "headerTitle": "Série de quartier",
    "headerTitleDaily": "Série journalière",
    "title": "Série de quartier",
    "thisMonth": "Ce mois-ci",
    "monthlyStreak": "Série mensuelle",
    "members": "Membres",
    "membersCount_one": "{{displayCount}} membre",
    "membersCount_other": "{{displayCount}} membres",
    "noMembers": "Aucun membre ne fait encore partie de cette série de quartier.",
    "objective": "Objectif ce mois-ci",
    "shares": "partages",
    "daysRemaining_one": "{{count}} jour restant",
    "daysRemaining_other": "{{count}} jours restants",
    "myContribution": "Ma contribution : {{count}}",
    "savedThisMonth": "économisés ce mois-ci",
    "viewMyImpact": "Voir mon impact",
    "objectiveDetailsTitle": "Détails de l'objectif",
    "objectiveDetails": "L’objectif du mois est déterminé en fonction du nombre de voisin·e·s partageur·euse·s autour de toi et de la maturité de ton quartier.",
    "seriesDetailsTitle": "Série mensuelle",
    "seriesDetails": "Pour garder la flamme du partage active, toi et tes voisin·e·s devez atteindre l’objectif de partages indiqué pour le mois.",
    "dailyContributions": "Contribution quotidienne",
    "contributionDetailsTitle": "Contribution quotidienne",
    "contributionDetails": "Les contributions sont toutes les actions qui favorisent le partage comme la publication d’offre/de besoin, mettre des offres en favoris, répondre à des besoins.",
    "currentStreakLabel": "Série en cours",
    "days": "jours",
    "day": "Jour {{day}}",
    "contributeDailyTitle": "Contribue quotidiennement pour maintenir ta flamme!",
    "makeMyDailyContribution": "Faire ma contribution du jour",
    "alreadyContributedToday": "Contribution du jour effectuée ✓",
    "myProgress": "Comment faire mon premier partage ?",
    "tips": {
      "publishRequest": {
        "title": "Publie un besoin pour emprunter",
        "description": "Tu as besoin d'un objet? Les membres autour de toi essaieront de t'aider."
      },
      "browseCatalog": {
        "title": "Explore le catalogue",
        "description": "Explore le catalogue et propose des dates d'emprunt."
      },
      "helpNeighbours": {
        "title": "Essaye d'aider tes voisin·e·s",
        "description": "Explore les besoins des membres autour de toi, tu peux masquer ceux auxquels tu ne peux pas répondre."
      },
      "publishOffer": {
        "title": "Publie une offre pour prêter",
        "description": "Publie un objet spécifique ou choisis parmi les objets suggérés."
      }
    },
    "neighbourhoodFirstShare": "Dans ton quartier, <strong>{{percent}}% de tes voisin·e·s</strong> ont fait leur premier partage <strong>en moins d'une semaine</strong>.",
    "empty": {
      "title": "Démarre ta série et contribue maintenant!",
      "cta": "Allume la flamme du partage"
    },
    "contributions": {
      "add_avatar": {
        "title": "Ajoute une photo",
        "description": "Une photo de profil rassure tes voisin·e·s et te rend reconnaissable dans le quartier.",
        "cta": "Ajouter ma photo"
      },
      "add_bio": {
        "title": "Ajoute une bio",
        "description": "Présente-toi en quelques mots pour donner envie aux autres membres de te prêter et de t'emprunter des objets.",
        "cta": "Ajouter ma bio"
      },
      "publish_offer": {
        "title": "Publier une offre",
        "description": "Publie un objet spécifique, ou choisis parmi les objets suggérés, les offres déjà été faites par nos voisins!",
        "cta": "Publier une offre"
      },
      "publish_request": {
        "title": "Publier un besoin",
        "description": "Tu as besoin d'un objet? Publie un besoin, les membres autour de toi essaieront d'y répondre.",
        "cta": "Publier un besoin"
      },
      "dismiss_request": {
        "title": "Essaye d'aider tes voisins",
        "description": "Explore les besoins des membres autour de toi, tu peux masquer ceux auxquels tu ne peux pas répondre.",
        "cta": "Explorer les besoins"
      },
      "send_message": {
        "title": "Envoie un message",
        "description": "Brise la glace! Écris à un·e voisin·e pour proposer ton aide ou en savoir plus sur une annonce.",
        "cta": "Aller dans mes conversations"
      },
      "add_favourite": {
        "title": "Mettre des offres en favoris",
        "description": "Explore le catalogue et sauvegardes les offres pertinentes pour y revenir plus tard",
        "cta": "Explorer les offres"
      }
    },
    "skip": "Voir une autre suggestion"
  },
  "superPartageur": {
    "title": "Super Partageur.euse",
    "subtitle": {
      "isSuper": "Tu es\n<strong>Super Partageur.euse</strong>",
      "notYetSuper": "Devenir\n<strong>Super Partageur.euse</strong>"
    },
    "requirements": {
      "trustPoints": {
        "emoji": "👍",
        "title": "{{value}} recommandations",
        "description": "Sur {{requiredValue}} requises"
      },
      "responseRate": {
        "emoji": "🛎️",
        "title": "Taux de réponse de {{value}} %",
        "description": "Doit être supérieur à {{requiredValue}} %"
      },
      "lastActiveDays": {
        "emoji": "⏱️",
        "title": "Actif.ve",
        "description": "Dans les derniers {{requiredValue}} jours"
      }
    },
    "learnMore": "Détails des critères"
  },
  "superPartageurDetails": {
    "title": "Détails des critères",
    "title2": "Super Partageur.euse",
    "description": "C’est quoi un.e Super Partageur.euse ?\nUn membre partageur qui s’engage de façon constante envers la communauté.\n\nBonne nouvelle : tout le monde peut le devenir ! Les critères sont simples et évalués automatiquement chaque jour.\n\nPour obtenir ton badge, il te suffit de remplir ces 3 conditions :",
    "requirements": {
      "trustPoints": {
        "title": "Recommandations",
        "description": "Obtiens <strong>{{requiredValue}} recommandations positives (👍)</strong> de membres après un partage, que ce soit un prêt ou un emprunt."
      },
      "responseRate": {
        "title": "Taux de réponses",
        "description": "Ne joue pas au fantôme ! 👻\n\nMaintiens un taux de réponse aux messages des membres <strong>supérieur à {{requiredValue}} %</strong>."
      },
      "lastActiveDays": {
        "title": "Actif.ve",
        "description": "Tu dois avoir ouvert l'application <strong>au moins une fois dans les {{requiredValue}} derniers jours</strong>."
      }
    }
  },
  "superPartageurNotification": {
    "title": {
      "isSuper": "Félicitations\n{{name}} !",
      "lostSuper": "Ton badge a disparu ?\nC’est normal."
    },
    "description": {
      "lostSuper": "Nous avons mis à jour les critères du badge Super Partageur.euse. Il ne suffit plus de partager : ton badge évolue désormais en fonction de ton activité, de tes recommandations et de ton taux de réponse.",
      "keptSuper": "Tu restes <strong>Super Partageur.euse</strong>, même avec les nouveaux critères.",
      "isNowSuper": "Tu es maintenant\n<strong>Super Partageur.euse</strong>."
    },
    "progress": {
      "one": "<strong>Super, tu es sur la bonne voie.</strong>",
      "two": "<strong>Super, tu y es presque !</strong>"
    },
    "goToDetailsButton": "Voir les détails"
  },
  "trialPromo": {
    "title": "Contribue à faire grandir le catalogue du Partage Club et gagne ton abonnement !",
    "details": "Contribue à faire grandir le catalogue du <strong>Partage Club</strong> ! Publie 5 objets et gagne ton <strong>abonnement annuel</strong> ! 🥳",
    "primaryButtonText": "Créer une annonce !",
    "numCreated0": "{{numOffersCreated}}/5 offre publiée",
    "numCreated1": "{{numOffersCreated}}/5 offre publiée",
    "numCreated": "{{numOffersCreated}}/5 offres publiées"
  },
  "tutorial": {
    "guardian": {
      "step1": {
        "title": "Nouveau",
        "text": "Laisse la garde de ton objet à ton emprunteur·euse pour la durée que tu souhaites en le·la désignant gardien·ne. Iel pourra l’utiliser et le prêter à son tour.",
        "cta": "J’ai compris"
      }
    },
    "finish": "Terminer",
    "stepIndicator": "Étape {{current}} sur {{total}}",
    "back": "Retour",
    "chatCreation": {
      "step1": {
        "title": "Nouveau",
        "text": "Clique ici pour créer une conversation privée avec un·e autre membre ou une conversation de groupe",
        "cta": "J'ai compris"
      }
    },
    "firstConversation": {
      "step1": {
        "title": "Présente-toi",
        "text": "Écris un petit mot au membre pour te présenter et exprimer ton intérêt.",
        "cta": "J'ai compris"
      }
    },
    "chatIntro": {
      "step1": {
        "title": "👋 Présente-toi",
        "text": "Écris un petit mot au membre pour te présenter et exprimer ton intérêt.",
        "cta": "Suivant"
      },
      "step2": {
        "title": "Proposer des dates d'emprunt",
        "text": "Clique ici pour accéder au calendrier et choisir une date de début et de fin pour l'emprunt. Le prêteur pourra ensuite l'accepter ou la refuser.",
        "cta": "J'ai compris"
      },
      "step2AltRequest": {
        "title": "Proposer des dates de prêt",
        "text": "Clique ici pour accéder au calendrier et choisir une date de début et de fin pour le prêt. L'emprunteur pourra ensuite l'accepter ou la refuser.",
        "cta": "J'ai compris"
      }
    },
    "firstMessageSent": {
      "step1": {
        "title": "Proposer des dates",
        "text": "Une fois l'entente conclue, n’oubliez pas d'entrer les dates du prêt afin de finaliser la réservation.",
        "cta": "J'ai compris"
      }
    },
    "next": "Suivant",
    "multipleOffers": {
      "step1": {
        "title": "Publier ton premier objet",
        "text": "En offrant tes objets, tu encourages même tes voisin.e.s les plus timides à demander."
      }
    },
    "publishOffers": {
      "step1": {
        "title": "Prendre soin des objets",
        "text": "Ici, la <strong>confiance</strong> règne. Tous les membres s'engagent à respecter les règles d'or.\n\nEn cas de problème, <strong>l'équipe du Partage Club</strong> est à ton service en tout temps. (1/5)"
      },
      "step2": {
        "title": "Faire le premier pas",
        "text": "En offrant tes objets, tu encourages même <strong>tes voisin.e.s les plus timides</strong> à demander. Tu peux toujours prêter tes objets, <strong>même sans abonnement</strong>.\n\nAppuie sur l’icône pour continuer. (2/5)"
      },
      "step2AltCorp": {
        "title": "Faire le premier pas",
        "text": "En offrant tes objets, tu encourages même <strong>tes voisin.e.s les plus timides</strong> à demander.\n\nAppuie sur l’icône pour continuer. (2/5)"
      },
      "step3": {
        "title": "2 façons d’offrir tes objets en partage",
        "text": "Publie un objet à la fois ou plusieurs objets en même temps, en un clic. <strong>Sélectionne l’offre multiple</strong> pour continuer. (3/5)"
      },
      "step4": {
        "title": "Ton annonce est publiée",
        "text": "Tu peux modifier tes annonces à tout moment. (4/5)"
      },
      "step4AltPlural": {
        "title": "Tes annonces sont publiées",
        "text": "Tu peux modifier tes annonces à tout moment. (4/5)"
      },
      "step5": {
        "title": "Publier un objet à la fois",
        "text": "Tu peux à tout moment publier une offre individuelle en prenant une photo de ton objet. (5/5)"
      },
      "stepFinal": {
        "title": "Bravo !",
        "text": "Tu maîtrises à présent l'art de partager des objets.\n\nTu as augmenté ton impact en publiant ta première offre. Tu accèdes désormais au niveau supérieur : Contributeur."
      }
    },
    "conciergerie": {
      "step1": {
        "title": "Nouveau",
        "text": "Lorsque l’assistant contacte un membre et que celui-ci répond, la discussion est marquée d’un symbole pour t’aider à la repérer"
      }
    },
    "homeExplore": {
      "stepIndicator": "Étape {{current}} sur {{total}}",
      "back": "Retour",
      "step1": {
        "title": "Cherche un objet",
        "text": "Utilise la barre de recherche et les filtres pour trouver un objet et faire une demande d’emprunt.",
        "cta": "Suivant"
      },
      "step2": {
        "title": "Publie une offre ou un besoin",
        "text": "Utilise ce bouton rapide pour publier une offre de prêt pour un objet spécifique ou choisis parmi les offres déjà faites par nos soins. Tu peux également demander l’aide de la communauté en publiant un besoin.",
        "cta": "Suivant"
      },
      "step3": {
        "title": "Comment ça marche ?",
        "text": "Clique ici pour recevoir de l'aide sur le processus de partage.",
        "cta": "J'ai compris"
      }
    },
    "contactMember": {
      "step1": {
        "title": "On y est presque! Contacte-le",
        "text": "Prends le temps de regarder les détails de l'offre. Si elle correspond à tes attentes clique ici pour entrer en contact avec le prêteur.",
        "cta": "J'ai compris"
      }
    }
  },
  "tutorialModal": {
    "publishOffers": {
      "ctaButton": "Commencer (2 min)",
      "text": "<strong>Comment offrir tes objets en partage</strong>",
      "title": "Apprendre l'art du partage"
    }
  },
  "listing-activity": {
    "headerTitle": "Activité",
    "wantToHelp_one": "{{count}} membre veut aider",
    "wantToHelp": "{{count}} membres veulent aider",
    "wantedToHelp_one": "{{count}} membre a voulu aider",
    "wantedToHelp": "{{count}} membres ont voulu aider",
    "leaveAMessage": "a laissé un message",
    "hasLent": "a prêté"
  },
  "posts": {
    "newPost": {
      "title": "Partage ton expérience",
      "intro": "Ton expérience peut aider d’autres membres à se lancer. Qu’est-ce qui t’a plu dans cet échange ?",
      "loading": "Chargement de ton échange...",
      "exchangeLabel": "Ton échange",
      "exchangeHint": "Ton post sera visible sur la fiche de cet objet.",
      "unavailableTitle": "Cet échange n’est pas disponible",
      "unavailableText": "Seule la personne qui emprunte peut publier, une fois par échange.",
      "goBack": "Retour",
      "addPhotos": "Ajouter des photos",
      "optional": "Facultatif",
      "publicBadge": "Post public",
      "publicHint": "Ce message apparaîtra dans le fil de ta communauté. Ce n'est pas une évaluation privée.",
      "dismissPublicHint": "Fermer l’avis de publication publique",
      "storyTitle": "Partage ton histoire",
      "storyHint": "Partage ce qui s'est passé, ce que tu as aimé ou un détail utile pour les autres.",
      "textPlaceholder": "J’ai pu réparer mon vélo en un après-midi grâce à cet outil…",
      "photoHint": "Ajoute jusqu’à 10 photos pour rendre ton histoire plus vivante.",
      "submitButton": "Publier mon expérience"
    },
    "editPost": {
      "listingLabel": "Annonce",
      "title": "Modifier l'avis",
      "intro": "Tu peux modifier le message que tu as partagé sur cet échange. N'oublie pas que ce message est public et visible par ta communauté.",
      "addPhotos": "Ajouter des photos",
      "publicBadge": "Post public",
      "publicHint": "Ce message apparaîtra dans le fil de ta communauté. Ce n'est pas une évaluation privée.",
      "storyTitle": "Raconte l'histoire",
      "storyHint": "Partage ce qui s'est passé, ce que tu as aimé ou un détail utile pour les autres.",
      "textPlaceholder": "Parle-nous de ton expérience...",
      "submitButton": "Enregistrer les modifications"
    },
    "banner": {
      "lender": "Prêteur",
      "borrower": "Emprunteur"
    },
    "reviews": {
      "readMore": "Lire la suite",
      "loading": "Chargement des avis...",
      "trustedMember": "{{count}} avis de membre de confiance",
      "trustedMember_plural": "{{count}} avis de membres de confiance",
      "count": "{{count}} avis",
      "count_plural": "{{count}} avis"
    },
    "feed": {
      "endOfFeed": {
        "status": "Tu as tout vu !",
        "title": "À toi de raconter la suite.",
        "description": "Un objet emprunté, une belle rencontre…\nPartage ton histoire avec le voisinage.",
        "action": "Raconter mon histoire",
        "actionHint": "Choisis un emprunt passé pour raconter ton histoire."
      },
      "loading": "Chargement des publications...",
      "timeAgo": "il y a {{time}}",
      "emptyTitle": "Aucune publication pour l'instant",
      "emptyText": "Les histoires de la communauté apparaîtront ici après un échange.",
      "readMore": "Lire la suite",
      "readLess": "Voir moins",
      "likes_one": "{{count}} j'aime",
      "likes_other": "{{count}} j'aime",
      "comments_one": "{{count}} commentaire",
      "comments_other": "{{count}} commentaires",
      "aboutItem": "À propos de {{item}}",
      "listingLabel": "Annonce",
      "likeAction": "Aimer la publication",
      "unlikeAction": "Retirer la mention J’aime",
      "photoPosition": "Photo {{current}} sur {{total}}",
      "openPhoto": "Ouvrir la photo {{current}} sur {{total}}",
      "postOptions": "Options de la publication",
      "lenderLabel": "Prêteur·euse",
      "lentBy": "Prêté par {{name}}",
      "loanContext": "{{lenderName}} a prêté {{listingName}} à {{borrowerName}}",
      "loanContextShort": "Prêt de {{listingName}}",
      "shareAction": "Partager le post",
      "editAction": "Modifier le post",
      "reportAction": "Signaler le post",
      "cancel": "Annuler",
      "shareCopied": "Les informations du post ont été copiées",
      "reportPostPrompt": "Bonjour, je souhaite signaler un post de {{name}} au sujet de {{item}} parce qu'il me semble inapproprié. Pourrais-tu l'examiner ?\n\nMerci."
    },
    "comments": {
      "title": "Commentaires",
      "emptyTitle": "Lance la conversation",
      "empty": "Sois la première personne à laisser un commentaire.",
      "count_one": "1 commentaire",
      "count_other": "{{count}} commentaires",
      "send": "Envoyer",
      "placeholder": "Écris un commentaire bienveillant…",
      "postBy": "Publication de {{name}}",
      "aboutItem": "À propos de {{item}}",
      "showPost": "Voir le post complet",
      "showLess": "Voir moins",
      "publicHint": "Visible par la communauté",
      "loadError": "Impossible de charger les commentaires.",
      "submitError": "Impossible de publier ton commentaire. Réessaie."
    },
    "storyComposer": {
      "addPhotos": "Ajoute ce moment en images",
      "publicHint": "Partagé publiquement avec ta communauté.",
      "storyTitle": "Ton histoire",
      "textPlaceholder": "Grâce à cet emprunt, j’ai…",
      "photoHint": "Facultatif · jusqu’à 10 photos",
      "submitButton": "Partager mon histoire",
      "composeTitle": "Fais revivre ce moment.",
      "composeHint": "Un projet, une découverte, un petit geste. Raconte-le à ta façon.",
      "changeMemory": "Un autre emprunt",
      "neighbour": "un membre du voisinage",
      "borrowedFrom": "Prêt de {{name}}",
      "borrowedOn": "Emprunt du {{date}}",
      "timeAgo": "Terminé il y a {{time}}",
      "shortStoryHint": "Quelques mots suffisent",
      "starterHint": "Besoin d’un point de départ ?",
      "prompts": {
        "made": "Une création",
        "tried": "Une première fois",
        "thanks": "Un merci"
      },
      "starters": {
        "made": "Grâce à cet emprunt, j’ai créé ",
        "tried": "C’était la première fois que j’essayais ",
        "thanks": "Un grand merci à {{name}} pour "
      },
      "dismissPublicHint": "Fermer l’avis de publication publique",
      "discardTitle": "Abandonner cette histoire ?",
      "discardMessage": "Si tu choisis un autre emprunt, le texte et les photos de ce brouillon seront perdus.",
      "keepWriting": "Continuer à écrire",
      "discardStory": "Abandonner l’histoire"
    }
  },
  "unavailable": {
    "clearButtonLabel": "Retirer",
    "clearHint": "Retire cette plage si tu es de nouveau disponible.",
    "selectRangeHint": "Sélectionne une date de début puis une date de fin (touche le même jour une deuxième fois pour un seul jour).",
    "singleDayRangeHint": "Un jour sélectionné : tu seras indisponible pour toute la journée.",
    "title": "Me signaler indisponible",
    "topInformation": "Je ne suis pas disponible durant cette période...",
    "suspendNotificationsLabel": "Suspendre les notifications?",
    "saveButtonLabel": "Enregistrer"
  },
  "listing-comments": {
    "title_zero": "Commentaires",
    "title_one": "1 commentaire",
    "title_other": "{{count}} commentaires",
    "title": "Commentaires",
    "placeholder": "Ajouter un commentaire...",
    "send": "Envoyer",
    "delete": "Supprimer",
    "empty": "Aucun commentaire pour le moment. Sois le premier à poser une question!",
    "loginToComment": "Connecte-toi pour laisser un commentaire.",
    "showMore": "Voir {{count}} commentaire(s) de plus",
    "showLess": "Voir moins"
  },
  "new-conversation": {
    "title": "Nouveau message",
    "searchPlaceholder": "Entrer un nom",
    "dmChat": "Discussion privée (2 personnes)",
    "groupChat": "Discussion de groupe (3+ personnes)",
    "noResults": "Aucun utilisateur trouvé"
  },
  "new-group-chat": {
    "title": "Nouveau groupe",
    "groupNamePlaceholder": "Nom du groupe (Facultatif)",
    "addMembers_one": "Ajouter un membre ({{count}})",
    "addMembers": "Ajouter des membres ({{count}})",
    "minimumMembersError": "Ajoute au moins 2 membres pour créer une discussion de groupe.",
    "searchPlaceholder": "Rechercher un membre",
    "next": "Suivant",
    "noResults": "Aucun utilisateur trouvé",
    "defaultGroupName_one": "Groupe ({{count}} membre)",
    "defaultGroupName": "Groupe ({{count}} membres)",
    "choosePhoto": "Choisir une photo",
    "choosePhotoHint": "Choisis une image pour personnaliser la discussion de groupe"
  },
  "add-chat-members": {
    "title": "Ajouter des membres",
    "addButton": "Ajouter ({{count}})",
    "searchPlaceholder": "Rechercher un membre",
    "noResults": "Aucun utilisateur trouvé",
    "alreadyMember": "Déjà membre",
    "forbiddenTitle": "Seuls les admins peuvent ajouter des membres",
    "forbiddenBody": "Tu dois être administrateur du groupe pour ajouter des membres à cette discussion.",
    "backButton": "Retour"
  },
  "web-footer": {
    "apps": "Applications",
    "openingHours": {
      "title": "Heures d’ouverture",
      "weekdays": "Lundi au vendredi",
      "hours": "De 9 à 17 h"
    },
    "follow": {
      "title": "Nous suivre"
    },
    "about": {
      "title": "À propos",
      "fundraising": "Collecte de fonds",
      "pressKit": "Kit de presse",
      "joinTeam": "Joignez-vous à l’équipe",
      "myCity": "Ma ville",
      "faq": "FAQ",
      "terms": "Termes et conditions",
      "privacy": "Politique de confidentialité"
    },
    "community": {
      "title": "Communauté",
      "gift": "Offrir en cadeau",
      "ambassador": "Devenir ambassadeur",
      "neighbourhood": "Votre quartier"
    }
  },
  "offer-hub": {
    "completedLists_one": "Liste terminée",
    "completedLists_other": "Listes terminées",
    "title": "Créer des offres",
    "heading": "Tu l’as? Partage-le.",
    "explanation": "Glisse à droite ou touche « J’ai ça » pour publier tout de suite.",
    "accept": "J'ai ça",
    "reject": "Je n’ai pas",
    "visibility": "Partagé avec {{destinations}}",
    "noDestinations": "aucune destination choisie",
    "editVisibility": "Changer où je partage",
    "doneEditing": "Terminé",
    "selectDestination": "Choisis au moins un quartier ou un club pour publier tes offres.",
    "loading": "On prépare tes suggestions…",
    "retryLoading": "Réessayer de charger",
    "storageError": "Certains choix n’ont pas pu être enregistrés sur cet appareil. Garde l’application ouverte et réessaie pour les conserver.",
    "retry": "Réessayer",
    "loadError": "Impossible de charger tes suggestions. Réessaie dans un instant.",
    "progress": "{{current}} / {{total}}",
    "encouragement": "Quelques choix, plus de partage.",
    "completeTitle": "Bien joué!",
    "completeDescription": "Chaque choix compte. Merci d’avoir pris le temps!",
    "caughtUp": "Tout exploré!",
    "caughtUpDescription": "Ton prochain partage se cache chez toi.",
    "more_one": "Essayer {{count}} autre objet",
    "more_other": "Essayer {{count}} autres objets",
    "challenge": "3 objets à faire circuler.",
    "challengeDescription": "Les objets du quotidien peuvent faire des heureux. Un petit tour dans…",
    "viewOffers": "Voir mes offres",
    "failedTitle": "Ces choix sont à vérifier",
    "otherWays": "Une autre idée en tête?",
    "single": "Créer une offre",
    "photos": "Quelques photos",
    "donate": "Donner un objet",
    "edit": "Modifier",
    "lastItem": "Le dernier, tu y es presque!",
    "roundProgress": "Objets passés en revue",
    "acceptHint": "Publie une offre dans les quartiers et clubs choisis.",
    "published_one": "offre publiée",
    "published_other": "offres publiées",
    "pending_one": "choix en cours",
    "pending_other": "choix en cours",
    "failed_one": "à vérifier",
    "failed_other": "à vérifier",
    "pendingDescription": "Tes choix s’enregistrent. Tu peux continuer à explorer.",
    "singleDescription": "Ajouter un objet de ton choix.",
    "photosDescription": "Créer plusieurs offres.",
    "eyebrow": "OFFRES EXPRESS",
    "challengeEyebrow": "PETITE CHASSE AUX TRÉSORS",
    "huntCupboard": "Cuisine",
    "huntLivingRoom": "Salon",
    "huntGarage": "Garage",
    "startHunt": "Trouver mes 3 trésors",
    "huntPhotos": "On t’aide à transformer les photos en offres.",
    "huntSingle": "Un objet pour commencer. Les autres suivront.",
    "remaining_one": "Le dernier!",
    "remaining_other": "Encore {{count}}",
    "chooseRoom": "On commence par quelle pièce?",
    "roomPrompt": "Tu as peut-être…",
    "kitchenIdeas": "Un gaufrier, un moule à gâteau, un mélangeur…",
    "livingIdeas": "Un jeu de société, un projecteur, un tapis de yoga…",
    "garageIdeas": "Une perceuse, un escabeau, une pompe à vélo…",
    "photographFinds": "Photographier mes trouvailles",
    "tabs": {
      "suggestions": "Suggestions",
      "photos": "Photos",
      "manual": "Manuel",
      "stories": "Histoires"
    },
    "help": "Revoir le tutoriel",
    "close": "Fermer",
    "backToHub": "Revenir aux suggestions",
    "listRemaining": "{{count}} restant(s)",
    "beginTutorial": "Commencer maintenant !",
    "startList": "Démarrer une liste",
    "quickSignal_one": "Publie 1 objet en {{seconds}} sec !",
    "quickSignal_other": "Publie {{count}} objets en {{seconds}} sec !",
    "quickTitle": "Publier des objets",
    "quickCardStart": "Démarrer",
    "whyPublish": "Pourquoi publier des offres ?",
    "benefitReciprocity": "Ça donne envie de te rendre la pareille",
    "benefitTrust": "Les autres te feront plus confiance",
    "benefitKarma": "C’est bon pour le karma",
    "resumeList": "Continuer la liste",
    "startTitle": "As-tu ces objets ?",
    "startDescription": "Passe au travers d’une liste d’objets prêts à publier instantanément",
    "resumeTitle": "Tu es proche du but !",
    "resumeDescription": "Termine ta liste en cours",
    "listComplete": "Tu as fini cette liste !",
    "lifetimeStats": "Tes statistiques depuis la création de ton compte",
    "publishedLabel": "Offre(s) publiée(s)",
    "manageOffers": "Gérer mes offres",
    "finish": "Terminer",
    "restart": "Relancer",
    "swipeTutorial": {
      "0": {
        "title": "Prêt à publier\nrapidement ?",
        "description": "Passe au travers d’une liste d’objets prêts à publier instantanément"
      },
      "1": {
        "title": "Tu as l'objet? Balaye à droite",
        "description": "Tu pourras modifier les détails plus tard"
      },
      "2": {
        "title": "Tu n'as pas l'objet? Balaye à gauche",
        "description": "Tu ne verras plus l’objet dans la liste"
      },
      "3": {
        "title": "Tu es paré !",
        "description": "Tu as toutes les bases pour démarrer ta première liste"
      }
    },
    "tutorial": {
      "step": "Étape {{current}} sur {{total}}",
      "back": "Retour",
      "next": "Suivant",
      "finish": "Terminer",
      "close": "Fermer le tutoriel",
      "steps": {
        "suggestions": {
          "title": "Offres rapides suggérées",
          "description": "Passe au travers d’une liste d’offres pré-existantes à publier instantanément"
        },
        "photos": {
          "title": "Publier en lot",
          "description": "Prends plusieurs objets en photo, on génère les descriptions pour toi et tu n’as qu’à les réviser avant de publier les offres"
        },
        "manual": {
          "title": "Saisie manuelle",
          "description": "Crée ton offre pour un seul objet spécifique"
        }
      }
    },
    "listingTypes": {
      "offer": "Offre",
      "request": "Besoin"
    },
    "object": "Objet",
    "storyLoadingError": "Impossible de charger les annonces.",
    "storyPickTitle": "Qu’est-ce que cet emprunt a rendu possible ?",
    "storyPickHint": "Derrière chaque objet emprunté, il y a un moment à raconter. Retrouve un emprunt passé pour commencer ton histoire.",
    "storyMemories": "Tes emprunts passés",
    "storyLoading": "On retrouve tes souvenirs de partage…",
    "storyEmpty": "Ta prochaine histoire reste à vivre. Après un emprunt terminé, tu pourras raconter ce moment ici."
  },
  "featurePresentations": {
    "title": "Nouveauté",
    "close": "Fermer",
    "guardian": {
      "title": "Tu peux maintenant envoyer tes objets en pension !",
      "description": "Si tu prêtes de façon <strong>récurrente</strong> à un·e même emprunteur·euse, il est possible de lui laisser la <strong>garde</strong> de ton objet aussi longtemps que tu le souhaites.\n\nIl·elle pourra également prêter ton objet à d’autres membres si tu es d’accord.\n\nRetrouve l’option dans le détail d’un prêt."
    }
  },
  "guardian": {
    "badge": "En pension",
    "action": "Désigner {{name}} comme gardien·ne (pension)",
    "confirmation": "Confirmation",
    "confirmAssign": "Tu es sur le point de désigner {{name}} gardien·ne de ton objet.\n\nTon offre passera en statut « En pension », il te suffit de contacter {{name}} depuis les détails de l’offre pour arranger le retour de l’objet quand tu le souhaites.",
    "endsLoan": "Cette action mettra fin au prêt en cours",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "member": "ce membre",
    "reclaim": "J’ai récupéré l’objet",
    "confirmReclaim": "Tu confirmes avoir récupéré ton objet ? Cette action mettra fin à sa pension. Le·la gardien·ne ne pourra plus le prêter.",
    "history": "{{name}} désigné·e gardien·ne le {{date}}. Prêt terminé.",
    "banner": "Objet envoyé en pension il y a {{ago}}",
    "guardian": "🪽 Gardien·ne",
    "since": "depuis {{ago}}",
    "contact": "Contacter le·la 🪽 gardien·ne",
    "lastActive": "Actif·ve il y a {{ago}}"
  },
  "support-profile": {
    "title": "Aide & Support",
    "officialTeam": "Équipe officielle",
    "welcomeTitle": "Besoin d’aide ?",
    "welcomeDescription": "L’équipe {{team}} est disponible pour t’accompagner dans tes échanges et l’utilisation de l’application.",
    "loanGuide": "Comment fonctionne un prêt ?",
    "compensation": "Garanties et dédommagement bris/vol",
    "managePlan": "Gérer mon abonnement Partage+",
    "manageAccount": "Gérer mon compte",
    "helpCenter": "Consulter le centre d’aide complet",
    "resourcesTitle": "Trouver une réponse",
    "email": "Écrire au support",
    "contactSupport": "Contacter le support",
    "faq": "Consulter notre FAQ en ligne"
  }
}
